export function getVTCTypesMock() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:08:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "15:47:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 9.657093,
            dist: 63400,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 6., 9., 25. Dic, 1., 6. Ene, 28. Feb, 17., 18. Abr, 1. May",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B363CF9F3E7CF9F3C7CF9F3E7CF9C3E74F9F3E7CF9F3E7CF9F3E7CF98",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiY2RlOGVjMzQtOGU1MC00MjlhLThiODctMTY4OGE1NjQ1MGQ4IiwicHJpY2UiOjIyLjI1ODMsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVkyUmxPR1ZqTXpRdE9HVTFNQzAwTWpsaExUaGlPRGN0TVRZNE9HRTFOalExTUdRNElpd2ljSEpwWTJVaU9qSXlMakkxT0RNc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 2226,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiY2RlOGVjMzQtOGU1MC00MjlhLThiODctMTY4OGE1NjQ1MGQ4IiwicHJpY2UiOjIyLjI1ODMsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:002",
                  },
                  {
                    name: "secIds",
                    value: "C-0:002",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMTcyOTc1YTUtZDdjMy00OThlLWEyNWMtNDg4NDI2OTFkNTZjIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1UY3lPVGMxWVRVdFpEZGpNeTAwT1RobExXRXlOV010TkRnNE5ESTJPVEZrTlRaaklpd2ljSEpwWTJVaU9qTTFMalV5TkRjc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3552,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMTcyOTc1YTUtZDdjMy00OThlLWEyNWMtNDg4NDI2OTFkNTZjIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121408$202411121430$$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Illar, Íllar@L=780@a=128@$202411121430$202411121530$ALSALSA $$1$$$$$$§G@T$A=1@O=Illar, Íllar@L=780@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121530$202411121547$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT1H39M",
          rtDuration: "PT1H39M",
          checksum: "7289aec7_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:08:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  time: "14:30:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@|12112024|140800|143000|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT22M",
                dist: 21203,
                GisRoute: {
                  dist: 21203,
                  durS: "PT22M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "14:30:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Illar, Íllar",
                  type: "ST",
                  id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                  extId: "780",
                  lon: -2.639161,
                  lat: 36.986413,
                  routeIdx: 5,
                  prognosisType: "PROGNOSED",
                  time: "15:30:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121574#TA#0#DA#121124#1S#100056312#1T#1430#LS#790#LT#1640#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1430#TO#790#TT#1640#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11143",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 5,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "14:30:00",
                      depDate: "2024-11-12",
                      depDir: "Laujar De Andarax",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "14:50:00",
                      depDate: "2024-11-12",
                      arrTime: "14:50:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "15:22:00",
                      depDate: "2024-11-12",
                      arrTime: "15:22:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                      arrTime: "15:30:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121574#TA#0#DA#121124#1S#100056312#1T#1430#LS#790#LT#1640#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1430#TO#790#TT#1640#",
                },
                id: "C-0:001",
                idx: 1,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Laujar De Andarax",
                directionFlag: "0",
                duration: "PT1H",
                dist: 29879,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Illar, Íllar",
                  type: "ST",
                  id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                  extId: "780",
                  lon: -2.639161,
                  lat: 36.986413,
                  time: "15:30:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "15:47:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Illar, Íllar@L=780@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|153000|154700|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:002",
                idx: 2,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT17M",
                dist: 12318,
                GisRoute: {
                  dist: 12318,
                  durS: "PT17M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:08:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "15:59:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 8.111323,
            dist: 62050,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 6., 9., 25. Dic, 1., 6. Ene, 28. Feb, 17., 18. Abr, 1. May",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B363CF9F3E7CF9F3C7CF9F3E7CF9C3E74F9F3E7CF9F3E7CF9F3E7CF98",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMmMwMDdmOGUtNGE2Mi00MzZhLWFmMDItNWJmM2NmM2VlNDZjIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1tTXdNRGRtT0dVdE5HRTJNaTAwTXpaaExXRm1NREl0TldKbU0yTm1NMlZsTkRaaklpd2ljSEpwWTJVaU9qUXVPVFEwTENKamRYSnlaVzVqZVNJNklrVlZVaUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 494,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMmMwMDdmOGUtNGE2Mi00MzZhLWFmMDItNWJmM2NmM2VlNDZjIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-1:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:002",
                  },
                  {
                    name: "secIds",
                    value: "C-1:002",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYjI1ZGUwNTYtZWYzMy00OWEwLTg4YTgtOGY1MGE4MzU0NTMxIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVlqSTFaR1V3TlRZdFpXWXpNeTAwT1dFd0xUZzRZVGd0T0dZMU1HRTRNelUwTlRNeElpd2ljSEpwWTJVaU9qTTFMalV5TkRjc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3552,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYjI1ZGUwNTYtZWYzMy00OWEwLTg4YTgtOGY1MGE4MzU0NTMxIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-1:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:000",
                  },
                  {
                    name: "secIds",
                    value: "C-1:000",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶G@T$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121408$202411121430$$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Canjayar, Canjáyar@L=777@a=128@$202411121430$202411121555$ALSALSA $$1$$$$$$§G@T$A=1@O=Canjayar, Canjáyar@L=777@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121555$202411121559$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT1H51M",
          rtDuration: "PT1H51M",
          checksum: "150b57f1_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:08:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  time: "14:30:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@|12112024|140800|143000|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-1:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT22M",
                dist: 21203,
                GisRoute: {
                  dist: 21203,
                  durS: "PT22M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "14:30:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  routeIdx: 8,
                  prognosisType: "PROGNOSED",
                  time: "15:55:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121574#TA#0#DA#121124#1S#100056312#1T#1430#LS#790#LT#1640#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1430#TO#790#TT#1640#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11143",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 8,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "14:30:00",
                      depDate: "2024-11-12",
                      depDir: "Laujar De Andarax",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "14:50:00",
                      depDate: "2024-11-12",
                      arrTime: "14:50:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "15:22:00",
                      depDate: "2024-11-12",
                      arrTime: "15:22:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                      depTime: "15:30:00",
                      depDate: "2024-11-12",
                      arrTime: "15:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Instincion, Instinción",
                      id: "A=1@O=Instincion, Instinción@X=-2659459@Y=36994090@U=80@L=783@",
                      extId: "783",
                      routeIdx: 6,
                      lon: -2.659459,
                      lat: 36.99409,
                      depTime: "15:35:00",
                      depDate: "2024-11-12",
                      arrTime: "15:35:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Ragol, Rágol",
                      id: "A=1@O=Ragol, Rágol@X=-2680682@Y=36995564@U=80@L=778@",
                      extId: "778",
                      routeIdx: 7,
                      lon: -2.680682,
                      lat: 36.995564,
                      depTime: "15:40:00",
                      depDate: "2024-11-12",
                      arrTime: "15:40:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Canjayar, Canjáyar",
                      id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                      extId: "777",
                      routeIdx: 8,
                      lon: -2.740775,
                      lat: 37.009219,
                      arrTime: "15:55:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121574#TA#0#DA#121124#1S#100056312#1T#1430#LS#790#LT#1640#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1430#TO#790#TT#1640#",
                },
                id: "C-1:001",
                idx: 1,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Laujar De Andarax",
                directionFlag: "0",
                duration: "PT1H25M",
                dist: 39319,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                    {
                      order: 6,
                      lon: -2.659459,
                      lat: 36.99409,
                    },
                    {
                      order: 7,
                      lon: -2.680682,
                      lat: 36.995564,
                    },
                    {
                      order: 8,
                      lon: -2.740775,
                      lat: 37.009219,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  time: "15:55:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "15:59:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Canjayar, Canjáyar@L=777@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|155500|155900|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-1:002",
                idx: 2,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT4M",
                dist: 1528,
                GisRoute: {
                  dist: 1528,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:43:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:18:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 7.579644,
            dist: 61708,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "12. Nov hasta 31. Dic 2024 Lu - Vi; no 6., 9., 25. Dic",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B30000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 2,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYTUxODA1YzgtMzM5Ny00ZDQ5LTk1ZjgtYTFkN2ZkNTczYWYwIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVlUVXhPREExWXpndE16TTVOeTAwWkRRNUxUazFaamd0WVRGa04yWmtOVGN6WVdZd0lpd2ljSEpwWTJVaU9qTTRMalV5TWl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3852,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYTUxODA1YzgtMzM5Ny00ZDQ5LTk1ZjgtYTFkN2ZkNTczYWYwIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "5",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "VTC Executive",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNDZjODdlZTAtM2RjNS00ZWFiLTkyMGYtMjNkZmU5YTVkNTJhIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5EWmpPRGRsWlRBdE0yUmpOUzAwWldGaUxUa3lNR1l0TWpOa1ptVTVZVFZrTlRKaElpd2ljSEpwWTJVaU9qUTFMamM0TXpVd01EQXdNREF3TURBd05Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi VTC Executive",
                        price: 4578,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNDZjODdlZTAtM2RjNS00ZWFiLTkyMGYtMjNkZmU5YTVkNTJhIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "9",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZDkzNTEyZGYtM2ZlOC00Mjk5LTk1OTMtNTRhODk2ZGY5MTBhIiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVpEa3pOVEV5WkdZdE0yWmxPQzAwTWprNUxUazFPVE10TlRSaE9EazJaR1k1TVRCaElpd2ljSEpwWTJVaU9qVXdMams0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan 7pax",
                        price: 5099,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZDkzNTEyZGYtM2ZlOC00Mjk5LTk1OTMtNTRhODk2ZGY5MTBhIiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "10",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan EXECUTIVE 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjIwZDZmZWItODc1Mi00NDcyLThhOTktZTMyNGMwZGY0Y2RiIiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5qSXdaRFptWldJdE9EYzFNaTAwTkRjeUxUaGhPVGt0WlRNeU5HTXdaR1kwWTJSaUlpd2ljSEpwWTJVaU9qVTRMamd4TXl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan EXECUTIVE 7pax",
                        price: 5881,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjIwZDZmZWItODc1Mi00NDcyLThhOTktZTMyNGMwZGY0Y2RiIiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-2:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:003",
                  },
                  {
                    name: "secIds",
                    value: "C-2:003",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                param: [
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-2:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:001",
                  },
                  {
                    name: "TariffURL",
                    value:
                      "https://www.juntadeandalucia.es/temas/transporte/publico/metropolitano.html",
                  },
                  {
                    name: "Supplier",
                    value: "033_junta_andal",
                  },
                  {
                    name: "secIds",
                    value: "C-2:001",
                  },
                ],
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶G@F$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$202411121443$202411121456$$$1$$$$$$§T$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121456$202411121529$RedM-333$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=V.Pavon, Huécija@L=779@a=128@$202411121600$202411121652$ALSALSA $$1$$$$$$§G@T$A=1@O=V.Pavon, Huécija@L=779@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121652$202411121718$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT2H35M",
          rtDuration: "PT2H35M",
          checksum: "49f144b3_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:43:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@|12112024|144300|145600|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT13M",
                dist: 830,
                GisRoute: {
                  dist: 830,
                  durS: "PT13M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  routeIdx: 27,
                  prognosisType: "PROGNOSED",
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 42,
                  prognosisType: "PROGNOSED",
                  time: "15:29:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:29:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:02:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191502#TA#1#DA#121124#1S#700003937#1T#1450#LS#100056312#LT#1602#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1450#TO#100056312#TT#1602#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9511",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 27,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:31:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 42,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:04:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191119#TA#0#DA#121124#1S#700004041#1T#1435#LS#100056312#LT#1604#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1435#TO#100056312#TT#1604#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 204,
                            g: 0,
                            b: 153,
                            hex: "#CC0099",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-333",
                        internalName: "RedM-333",
                        displayNumber: "M-333",
                        num: "9328",
                        line: "M-333",
                        lineId: "6_21(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-333",
                      },
                      name: "RedM-333",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-333",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#0#DA#121124#1S#700003937#1T#1545#LS#100056312#LT#1657#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1545#TO#100056312#TT#1657#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9555",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:54:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:27:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191515#TA#1#DA#121124#1S#700003937#1T#1615#LS#100056312#LT#1727#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1615#TO#100056312#TT#1727#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9512",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "17:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#1#DA#121124#1S#700003937#1T#1645#LS#100056312#LT#1757#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1645#TO#100056312#TT#1757#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9587",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 53,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 204,
                        g: 0,
                        b: 153,
                        hex: "#CC0099",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      nameS: "CTA",
                      nameN: "Red de C",
                      nameL:
                        "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      id: "CTAL",
                    },
                    name: "RedM-333",
                    internalName: "RedM-333",
                    displayNumber: "M-333",
                    num: "9675",
                    line: "M-333",
                    lineId: "6_21(CTAL)033",
                    catOut: "Red de C",
                    catIn: "CTA",
                    catCode: "8",
                    cls: "256",
                    catOutS: "CTA",
                    catOutL:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    operatorCode: "CTA",
                    operator:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    admin: "033004",
                    routeIdxFrom: 27,
                    routeIdxTo: 42,
                    matchId: "M-333",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Pol. Ind. La Algaida, Roquetas de Mar",
                      id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                      extId: "500003962",
                      routeIdx: 27,
                      lon: -2.606746,
                      lat: 36.785972,
                      depTime: "14:56:00",
                      depDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                      mainMastExtId: "700003923",
                      mainMastLon: -2.606971,
                      mainMastLat: 36.786125,
                      depDir: "Estación de tren Almeria, Almería",
                      entry: true,
                    },
                    {
                      name: "Barrio San Francisco, Roquetas de Mar",
                      id: "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603339@Y=36794548@U=80@L=700003963@",
                      extId: "700003963",
                      routeIdx: 28,
                      lon: -2.603339,
                      lat: 36.794548,
                      depTime: "14:58:00",
                      depDate: "2024-11-12",
                      arrTime: "14:58:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603546@Y=36794646@U=80@L=500003946@",
                      mainMastExtId: "500003946",
                      mainMastLon: -2.603546,
                      mainMastLat: 36.794646,
                      entry: true,
                    },
                    {
                      name: "El Parador - Karting, Roquetas de Mar",
                      id: "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2600993@Y=36800130@U=80@L=600003964@",
                      extId: "600003964",
                      routeIdx: 29,
                      lon: -2.600993,
                      lat: 36.80013,
                      depTime: "14:59:00",
                      depDate: "2024-11-12",
                      arrTime: "14:59:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2601146@Y=36800382@U=80@L=500003922@",
                      mainMastExtId: "500003922",
                      mainMastLon: -2.601146,
                      mainMastLat: 36.800382,
                      entry: true,
                    },
                    {
                      name: "El Parador - Fabriquilla, Roquetas de Mar",
                      id: "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2599887@Y=36802881@U=80@L=400004245@",
                      extId: "400004245",
                      routeIdx: 30,
                      lon: -2.599887,
                      lat: 36.802881,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2600373@Y=36802521@U=80@L=500004244@",
                      mainMastExtId: "500004244",
                      mainMastLon: -2.600373,
                      mainMastLat: 36.802521,
                      entry: true,
                    },
                    {
                      name: "El Parador - Parrales V, Roquetas de Mar",
                      id: "A=1@O=El Parador - Parrales V, Roquetas de Mar@X=-2598880@Y=36805676@U=80@L=500003965@",
                      extId: "500003965",
                      routeIdx: 31,
                      lon: -2.59888,
                      lat: 36.805676,
                      depTime: "15:01:00",
                      depDate: "2024-11-12",
                      arrTime: "15:01:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Las Arenas, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Las Arenas, Roquetas de Mar@X=-2592291@Y=36809560@U=80@L=600003966@",
                      extId: "600003966",
                      routeIdx: 32,
                      lon: -2.592291,
                      lat: 36.80956,
                      depTime: "15:03:00",
                      depDate: "2024-11-12",
                      arrTime: "15:03:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=La Gloria, Roquetas de Mar@X=-2591545@Y=36810045@U=80@L=868@",
                      mainMastExtId: "868",
                      mainMastLon: -2.591545,
                      mainMastLat: 36.810045,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - La Gloria, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2586835@Y=36810512@U=80@L=600003967@",
                      extId: "600003967",
                      routeIdx: 33,
                      lon: -2.586835,
                      lat: 36.810512,
                      depTime: "15:05:00",
                      depDate: "2024-11-12",
                      arrTime: "15:05:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2585675@Y=36810917@U=80@L=400003896@",
                      mainMastExtId: "400003896",
                      mainMastLon: -2.585675,
                      mainMastLat: 36.810917,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - Venta Vitorino, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Venta Vitorino, Roquetas de Mar@X=-2582987@Y=36811321@U=80@L=700003968@",
                      extId: "700003968",
                      routeIdx: 34,
                      lon: -2.582987,
                      lat: 36.811321,
                      depTime: "15:06:00",
                      depDate: "2024-11-12",
                      arrTime: "15:06:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Guardia Civil, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575877@Y=36813164@U=80@L=700003969@",
                      extId: "700003969",
                      routeIdx: 35,
                      lon: -2.575877,
                      lat: 36.813164,
                      depTime: "15:08:00",
                      depDate: "2024-11-12",
                      arrTime: "15:08:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575994@Y=36813416@U=80@L=300003895@",
                      mainMastExtId: "300003895",
                      mainMastLon: -2.575994,
                      mainMastLat: 36.813416,
                      entry: true,
                    },
                    {
                      name: "Aguadulce (Almeria), Roquetas de Mar",
                      id: "A=1@O=Aguadulce (Almeria), Roquetas de Mar@X=-2569126@Y=36815268@U=80@L=865@",
                      extId: "865",
                      routeIdx: 36,
                      lon: -2.569126,
                      lat: 36.815268,
                      depTime: "15:10:00",
                      depDate: "2024-11-12",
                      arrTime: "15:10:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Puerto, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565485@Y=36816328@U=80@L=600003972@",
                      extId: "600003972",
                      routeIdx: 37,
                      lon: -2.565485,
                      lat: 36.816328,
                      depTime: "15:11:00",
                      depDate: "2024-11-12",
                      arrTime: "15:11:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565674@Y=36816427@U=80@L=800003893@",
                      mainMastExtId: "800003893",
                      mainMastLon: -2.565674,
                      mainMastLat: 36.816427,
                      entry: true,
                    },
                    {
                      name: "Hotel La Parra, Enix",
                      id: "A=1@O=Hotel La Parra, Enix@X=-2532117@Y=36822019@U=80@L=400003974@",
                      extId: "400003974",
                      routeIdx: 38,
                      lon: -2.532117,
                      lat: 36.822019,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Hotel La Parra, Enix@X=-2529690@Y=36823376@U=80@L=700003973@",
                      mainMastExtId: "700003973",
                      mainMastLon: -2.52969,
                      mainMastLat: 36.823376,
                      entry: true,
                    },
                    {
                      name: "Camping La Garrofa, Almería",
                      id: "A=1@O=Camping La Garrofa, Almería@X=-2516971@Y=36826738@U=80@L=600003976@",
                      extId: "600003976",
                      routeIdx: 39,
                      lon: -2.516971,
                      lat: 36.826738,
                      depTime: "15:17:00",
                      depDate: "2024-11-12",
                      arrTime: "15:17:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Almeria, Almería@X=-2517168@Y=36826909@U=80@L=688@",
                      mainMastExtId: "688",
                      mainMastLon: -2.517168,
                      mainMastLat: 36.826909,
                      entry: true,
                    },
                    {
                      name: "Almería - Pescadería, Almería",
                      id: "A=1@O=Almería - Pescadería, Almería@X=-2480151@Y=36836995@U=80@L=700003931@",
                      extId: "700003931",
                      routeIdx: 40,
                      lon: -2.480151,
                      lat: 36.836995,
                      depTime: "15:21:00",
                      depDate: "2024-11-12",
                      arrTime: "15:21:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=San Roque-Al, Almería@X=-2478542@Y=36837417@U=80@L=100008226@",
                      mainMastExtId: "100008226",
                      mainMastLon: -2.478542,
                      mainMastLat: 36.837417,
                      entry: true,
                    },
                    {
                      name: "Almería - Puerto V, Almería",
                      id: "A=1@O=Almería - Puerto V, Almería@X=-2464842@Y=36833956@U=80@L=800003928@",
                      extId: "800003928",
                      routeIdx: 41,
                      lon: -2.464842,
                      lat: 36.833956,
                      depTime: "15:25:00",
                      depDate: "2024-11-12",
                      arrTime: "15:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 42,
                      lon: -2.45552,
                      lat: 36.834954,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "15:29:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                id: "C-2:001",
                idx: 1,
                name: "RedM-333",
                number: "M-333",
                category: "CTA",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Almeria, Almería",
                directionFlag: "1",
                duration: "PT33M",
                dist: 15734,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.606746,
                      lat: 36.785972,
                    },
                    {
                      order: 1,
                      lon: -2.603339,
                      lat: 36.794548,
                    },
                    {
                      order: 2,
                      lon: -2.600993,
                      lat: 36.80013,
                    },
                    {
                      order: 3,
                      lon: -2.599887,
                      lat: 36.802881,
                    },
                    {
                      order: 4,
                      lon: -2.59888,
                      lat: 36.805676,
                    },
                    {
                      order: 5,
                      lon: -2.592291,
                      lat: 36.80956,
                    },
                    {
                      order: 6,
                      lon: -2.586835,
                      lat: 36.810512,
                    },
                    {
                      order: 7,
                      lon: -2.582987,
                      lat: 36.811321,
                    },
                    {
                      order: 8,
                      lon: -2.575877,
                      lat: 36.813164,
                    },
                    {
                      order: 9,
                      lon: -2.569126,
                      lat: 36.815268,
                    },
                    {
                      order: 10,
                      lon: -2.565485,
                      lat: 36.816328,
                    },
                    {
                      order: 11,
                      lon: -2.532117,
                      lat: 36.822019,
                    },
                    {
                      order: 12,
                      lon: -2.516971,
                      lat: 36.826738,
                    },
                    {
                      order: 13,
                      lon: -2.480151,
                      lat: 36.836995,
                    },
                    {
                      order: 14,
                      lon: -2.464842,
                      lat: 36.833956,
                    },
                    {
                      order: 15,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  routeIdx: 4,
                  prognosisType: "PROGNOSED",
                  time: "16:52:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 4,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-2:002",
                idx: 2,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT52M",
                dist: 25688,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  time: "16:52:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:18:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=V.Pavon, Huécija@L=779@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|165200|171800|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-2:003",
                idx: 3,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT26M",
                dist: 19456,
                GisRoute: {
                  dist: 19456,
                  durS: "PT26M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:43:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:44:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 4.890262000000001,
            dist: 57989,
            type: "PTM",
            rating: 1,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "12. Nov hasta 31. Dic 2024 Lu - Vi; no 6., 9., 25. Dic",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B30000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 2,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNDQxNzZjN2EtNWQyOS00MWE5LWIzZTctNzk3NWI0NjkwZTE2IiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5EUXhOelpqTjJFdE5XUXlPUzAwTVdFNUxXSXpaVGN0TnprM05XSTBOamt3WlRFMklpd2ljSEpwWTJVaU9qUXVPVFEwTENKamRYSnlaVzVqZVNJNklrVlZVaUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 494,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNDQxNzZjN2EtNWQyOS00MWE5LWIzZTctNzk3NWI0NjkwZTE2IiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-3:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:003",
                  },
                  {
                    name: "secIds",
                    value: "C-3:003",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                param: [
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-3:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:001",
                  },
                  {
                    name: "TariffURL",
                    value:
                      "https://www.juntadeandalucia.es/temas/transporte/publico/metropolitano.html",
                  },
                  {
                    name: "Supplier",
                    value: "033_junta_andal",
                  },
                  {
                    name: "secIds",
                    value: "C-3:001",
                  },
                ],
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 3,
          tripId: "C-3",
          ctxRecon:
            "¶HKI¶G@F$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$202411121443$202411121456$$$1$$$$$$§T$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121456$202411121529$RedM-333$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Canjayar, Canjáyar@L=777@a=128@$202411121600$202411121740$ALSALSA $$1$$$$$$§G@T$A=1@O=Canjayar, Canjáyar@L=777@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121740$202411121744$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT3H1M",
          rtDuration: "PT3H1M",
          checksum: "af90d642_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:43:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@|12112024|144300|145600|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT13M",
                dist: 830,
                GisRoute: {
                  dist: 830,
                  durS: "PT13M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  routeIdx: 27,
                  prognosisType: "PROGNOSED",
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 42,
                  prognosisType: "PROGNOSED",
                  time: "15:29:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:29:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:02:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191502#TA#1#DA#121124#1S#700003937#1T#1450#LS#100056312#LT#1602#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1450#TO#100056312#TT#1602#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9511",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 27,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:31:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 42,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:04:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191119#TA#0#DA#121124#1S#700004041#1T#1435#LS#100056312#LT#1604#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1435#TO#100056312#TT#1604#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 204,
                            g: 0,
                            b: 153,
                            hex: "#CC0099",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-333",
                        internalName: "RedM-333",
                        displayNumber: "M-333",
                        num: "9328",
                        line: "M-333",
                        lineId: "6_21(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-333",
                      },
                      name: "RedM-333",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-333",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#0#DA#121124#1S#700003937#1T#1545#LS#100056312#LT#1657#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1545#TO#100056312#TT#1657#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9555",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:54:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:27:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191515#TA#1#DA#121124#1S#700003937#1T#1615#LS#100056312#LT#1727#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1615#TO#100056312#TT#1727#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9512",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "17:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#1#DA#121124#1S#700003937#1T#1645#LS#100056312#LT#1757#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1645#TO#100056312#TT#1757#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9587",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 53,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 204,
                        g: 0,
                        b: 153,
                        hex: "#CC0099",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      nameS: "CTA",
                      nameN: "Red de C",
                      nameL:
                        "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      id: "CTAL",
                    },
                    name: "RedM-333",
                    internalName: "RedM-333",
                    displayNumber: "M-333",
                    num: "9675",
                    line: "M-333",
                    lineId: "6_21(CTAL)033",
                    catOut: "Red de C",
                    catIn: "CTA",
                    catCode: "8",
                    cls: "256",
                    catOutS: "CTA",
                    catOutL:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    operatorCode: "CTA",
                    operator:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    admin: "033004",
                    routeIdxFrom: 27,
                    routeIdxTo: 42,
                    matchId: "M-333",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Pol. Ind. La Algaida, Roquetas de Mar",
                      id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                      extId: "500003962",
                      routeIdx: 27,
                      lon: -2.606746,
                      lat: 36.785972,
                      depTime: "14:56:00",
                      depDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                      mainMastExtId: "700003923",
                      mainMastLon: -2.606971,
                      mainMastLat: 36.786125,
                      depDir: "Estación de tren Almeria, Almería",
                      entry: true,
                    },
                    {
                      name: "Barrio San Francisco, Roquetas de Mar",
                      id: "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603339@Y=36794548@U=80@L=700003963@",
                      extId: "700003963",
                      routeIdx: 28,
                      lon: -2.603339,
                      lat: 36.794548,
                      depTime: "14:58:00",
                      depDate: "2024-11-12",
                      arrTime: "14:58:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603546@Y=36794646@U=80@L=500003946@",
                      mainMastExtId: "500003946",
                      mainMastLon: -2.603546,
                      mainMastLat: 36.794646,
                      entry: true,
                    },
                    {
                      name: "El Parador - Karting, Roquetas de Mar",
                      id: "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2600993@Y=36800130@U=80@L=600003964@",
                      extId: "600003964",
                      routeIdx: 29,
                      lon: -2.600993,
                      lat: 36.80013,
                      depTime: "14:59:00",
                      depDate: "2024-11-12",
                      arrTime: "14:59:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2601146@Y=36800382@U=80@L=500003922@",
                      mainMastExtId: "500003922",
                      mainMastLon: -2.601146,
                      mainMastLat: 36.800382,
                      entry: true,
                    },
                    {
                      name: "El Parador - Fabriquilla, Roquetas de Mar",
                      id: "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2599887@Y=36802881@U=80@L=400004245@",
                      extId: "400004245",
                      routeIdx: 30,
                      lon: -2.599887,
                      lat: 36.802881,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2600373@Y=36802521@U=80@L=500004244@",
                      mainMastExtId: "500004244",
                      mainMastLon: -2.600373,
                      mainMastLat: 36.802521,
                      entry: true,
                    },
                    {
                      name: "El Parador - Parrales V, Roquetas de Mar",
                      id: "A=1@O=El Parador - Parrales V, Roquetas de Mar@X=-2598880@Y=36805676@U=80@L=500003965@",
                      extId: "500003965",
                      routeIdx: 31,
                      lon: -2.59888,
                      lat: 36.805676,
                      depTime: "15:01:00",
                      depDate: "2024-11-12",
                      arrTime: "15:01:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Las Arenas, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Las Arenas, Roquetas de Mar@X=-2592291@Y=36809560@U=80@L=600003966@",
                      extId: "600003966",
                      routeIdx: 32,
                      lon: -2.592291,
                      lat: 36.80956,
                      depTime: "15:03:00",
                      depDate: "2024-11-12",
                      arrTime: "15:03:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=La Gloria, Roquetas de Mar@X=-2591545@Y=36810045@U=80@L=868@",
                      mainMastExtId: "868",
                      mainMastLon: -2.591545,
                      mainMastLat: 36.810045,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - La Gloria, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2586835@Y=36810512@U=80@L=600003967@",
                      extId: "600003967",
                      routeIdx: 33,
                      lon: -2.586835,
                      lat: 36.810512,
                      depTime: "15:05:00",
                      depDate: "2024-11-12",
                      arrTime: "15:05:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2585675@Y=36810917@U=80@L=400003896@",
                      mainMastExtId: "400003896",
                      mainMastLon: -2.585675,
                      mainMastLat: 36.810917,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - Venta Vitorino, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Venta Vitorino, Roquetas de Mar@X=-2582987@Y=36811321@U=80@L=700003968@",
                      extId: "700003968",
                      routeIdx: 34,
                      lon: -2.582987,
                      lat: 36.811321,
                      depTime: "15:06:00",
                      depDate: "2024-11-12",
                      arrTime: "15:06:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Guardia Civil, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575877@Y=36813164@U=80@L=700003969@",
                      extId: "700003969",
                      routeIdx: 35,
                      lon: -2.575877,
                      lat: 36.813164,
                      depTime: "15:08:00",
                      depDate: "2024-11-12",
                      arrTime: "15:08:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575994@Y=36813416@U=80@L=300003895@",
                      mainMastExtId: "300003895",
                      mainMastLon: -2.575994,
                      mainMastLat: 36.813416,
                      entry: true,
                    },
                    {
                      name: "Aguadulce (Almeria), Roquetas de Mar",
                      id: "A=1@O=Aguadulce (Almeria), Roquetas de Mar@X=-2569126@Y=36815268@U=80@L=865@",
                      extId: "865",
                      routeIdx: 36,
                      lon: -2.569126,
                      lat: 36.815268,
                      depTime: "15:10:00",
                      depDate: "2024-11-12",
                      arrTime: "15:10:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Puerto, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565485@Y=36816328@U=80@L=600003972@",
                      extId: "600003972",
                      routeIdx: 37,
                      lon: -2.565485,
                      lat: 36.816328,
                      depTime: "15:11:00",
                      depDate: "2024-11-12",
                      arrTime: "15:11:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565674@Y=36816427@U=80@L=800003893@",
                      mainMastExtId: "800003893",
                      mainMastLon: -2.565674,
                      mainMastLat: 36.816427,
                      entry: true,
                    },
                    {
                      name: "Hotel La Parra, Enix",
                      id: "A=1@O=Hotel La Parra, Enix@X=-2532117@Y=36822019@U=80@L=400003974@",
                      extId: "400003974",
                      routeIdx: 38,
                      lon: -2.532117,
                      lat: 36.822019,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Hotel La Parra, Enix@X=-2529690@Y=36823376@U=80@L=700003973@",
                      mainMastExtId: "700003973",
                      mainMastLon: -2.52969,
                      mainMastLat: 36.823376,
                      entry: true,
                    },
                    {
                      name: "Camping La Garrofa, Almería",
                      id: "A=1@O=Camping La Garrofa, Almería@X=-2516971@Y=36826738@U=80@L=600003976@",
                      extId: "600003976",
                      routeIdx: 39,
                      lon: -2.516971,
                      lat: 36.826738,
                      depTime: "15:17:00",
                      depDate: "2024-11-12",
                      arrTime: "15:17:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Almeria, Almería@X=-2517168@Y=36826909@U=80@L=688@",
                      mainMastExtId: "688",
                      mainMastLon: -2.517168,
                      mainMastLat: 36.826909,
                      entry: true,
                    },
                    {
                      name: "Almería - Pescadería, Almería",
                      id: "A=1@O=Almería - Pescadería, Almería@X=-2480151@Y=36836995@U=80@L=700003931@",
                      extId: "700003931",
                      routeIdx: 40,
                      lon: -2.480151,
                      lat: 36.836995,
                      depTime: "15:21:00",
                      depDate: "2024-11-12",
                      arrTime: "15:21:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=San Roque-Al, Almería@X=-2478542@Y=36837417@U=80@L=100008226@",
                      mainMastExtId: "100008226",
                      mainMastLon: -2.478542,
                      mainMastLat: 36.837417,
                      entry: true,
                    },
                    {
                      name: "Almería - Puerto V, Almería",
                      id: "A=1@O=Almería - Puerto V, Almería@X=-2464842@Y=36833956@U=80@L=800003928@",
                      extId: "800003928",
                      routeIdx: 41,
                      lon: -2.464842,
                      lat: 36.833956,
                      depTime: "15:25:00",
                      depDate: "2024-11-12",
                      arrTime: "15:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 42,
                      lon: -2.45552,
                      lat: 36.834954,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "15:29:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                id: "C-3:001",
                idx: 1,
                name: "RedM-333",
                number: "M-333",
                category: "CTA",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Almeria, Almería",
                directionFlag: "1",
                duration: "PT33M",
                dist: 15734,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.606746,
                      lat: 36.785972,
                    },
                    {
                      order: 1,
                      lon: -2.603339,
                      lat: 36.794548,
                    },
                    {
                      order: 2,
                      lon: -2.600993,
                      lat: 36.80013,
                    },
                    {
                      order: 3,
                      lon: -2.599887,
                      lat: 36.802881,
                    },
                    {
                      order: 4,
                      lon: -2.59888,
                      lat: 36.805676,
                    },
                    {
                      order: 5,
                      lon: -2.592291,
                      lat: 36.80956,
                    },
                    {
                      order: 6,
                      lon: -2.586835,
                      lat: 36.810512,
                    },
                    {
                      order: 7,
                      lon: -2.582987,
                      lat: 36.811321,
                    },
                    {
                      order: 8,
                      lon: -2.575877,
                      lat: 36.813164,
                    },
                    {
                      order: 9,
                      lon: -2.569126,
                      lat: 36.815268,
                    },
                    {
                      order: 10,
                      lon: -2.565485,
                      lat: 36.816328,
                    },
                    {
                      order: 11,
                      lon: -2.532117,
                      lat: 36.822019,
                    },
                    {
                      order: 12,
                      lon: -2.516971,
                      lat: 36.826738,
                    },
                    {
                      order: 13,
                      lon: -2.480151,
                      lat: 36.836995,
                    },
                    {
                      order: 14,
                      lon: -2.464842,
                      lat: 36.833956,
                    },
                    {
                      order: 15,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  routeIdx: 10,
                  prognosisType: "PROGNOSED",
                  time: "17:40:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 10,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "16:52:00",
                      depDate: "2024-11-12",
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Alicun, Alicún",
                      id: "A=1@O=Alicun, Alicún@X=-2601991@Y=36966304@U=80@L=782@",
                      extId: "782",
                      routeIdx: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                      depTime: "16:55:00",
                      depDate: "2024-11-12",
                      arrTime: "16:55:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Huecija, Huécija",
                      id: "A=1@O=Huecija, Huécija@X=-2607690@Y=36967006@U=80@L=781@",
                      extId: "781",
                      routeIdx: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                      depTime: "17:00:00",
                      depDate: "2024-11-12",
                      arrTime: "17:00:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                      depTime: "17:15:00",
                      depDate: "2024-11-12",
                      arrTime: "17:15:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Instincion, Instinción",
                      id: "A=1@O=Instincion, Instinción@X=-2659459@Y=36994090@U=80@L=783@",
                      extId: "783",
                      routeIdx: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                      depTime: "17:20:00",
                      depDate: "2024-11-12",
                      arrTime: "17:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Ragol, Rágol",
                      id: "A=1@O=Ragol, Rágol@X=-2680682@Y=36995564@U=80@L=778@",
                      extId: "778",
                      routeIdx: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                      depTime: "17:25:00",
                      depDate: "2024-11-12",
                      arrTime: "17:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Canjayar, Canjáyar",
                      id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                      extId: "777",
                      routeIdx: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                      arrTime: "17:40:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-3:002",
                idx: 2,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT1H40M",
                dist: 39897,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                    },
                    {
                      order: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                    },
                    {
                      order: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                    {
                      order: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                    },
                    {
                      order: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                    },
                    {
                      order: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  time: "17:40:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:44:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Canjayar, Canjáyar@L=777@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|174000|174400|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-3:003",
                idx: 3,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT4M",
                dist: 1528,
                GisRoute: {
                  dist: 1528,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "15:38:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:18:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 10.848101,
            dist: 66347,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "Lu - Sa",
              sDaysI:
                "no 6., 9., 25. Dic, 1., 6. Ene, 28. Feb, 17., 18. Abr, 1. May",
              sDaysB:
                "E7EFDEBF7EFDFBD3EFDBB73EFDFBF7EFDFBD7EFDFBF7EFDCBF76FDFBF7EFDFBF7EFDFBF7EFD8",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMDU0NTQ2ZjEtNjZlOC00ODcwLTk1Y2ItOGUzNzU0ZDFlZGMwIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1EVTBOVFEyWmpFdE5qWmxPQzAwT0Rjd0xUazFZMkl0T0dVek56VTBaREZsWkdNd0lpd2ljSEpwWTJVaU9qTTRMalV5TWl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3852,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMDU0NTQ2ZjEtNjZlOC00ODcwLTk1Y2ItOGUzNzU0ZDFlZGMwIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "5",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "VTC Executive",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTRmZGI1YTMtMTFjNC00NzExLThkOTMtNTcxYTBhNDAyNjMyIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVpUUm1aR0kxWVRNdE1URmpOQzAwTnpFeExUaGtPVE10TlRjeFlUQmhOREF5TmpNeUlpd2ljSEpwWTJVaU9qUTFMamM0TXpVd01EQXdNREF3TURBd05Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi VTC Executive",
                        price: 4578,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTRmZGI1YTMtMTFjNC00NzExLThkOTMtNTcxYTBhNDAyNjMyIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "9",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYTFjMGViNzItMzMxNS00OGY5LWFhNWMtYTA3MWI1OTE1NzVjIiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVlURmpNR1ZpTnpJdE16TXhOUzAwT0dZNUxXRmhOV010WVRBM01XSTFPVEUxTnpWaklpd2ljSEpwWTJVaU9qVXdMams0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan 7pax",
                        price: 5099,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiYTFjMGViNzItMzMxNS00OGY5LWFhNWMtYTA3MWI1OTE1NzVjIiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "10",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan EXECUTIVE 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTNjN2M0MzAtYzdmOC00ZWRkLTgzNmUtZmYzNzQ0OWJmZTI1IiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVpUTmpOMk0wTXpBdFl6ZG1PQzAwWldSa0xUZ3pObVV0Wm1Zek56UTBPV0ptWlRJMUlpd2ljSEpwWTJVaU9qVTRMamd4TXl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan EXECUTIVE 7pax",
                        price: 5881,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTNjN2M0MzAtYzdmOC00ZWRkLTgzNmUtZmYzNzQ0OWJmZTI1IiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-4:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-4:002",
                  },
                  {
                    name: "secIds",
                    value: "C-4:002",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZmUwNmJmMjMtMDM5Zi00MzkzLWFkM2ItZGE3NjU3YTIwZjM4IiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVptVXdObUptTWpNdE1ETTVaaTAwTXprekxXRmtNMkl0WkdFM05qVTNZVEl3WmpNNElpd2ljSEpwWTJVaU9qTTFMalV5TkRjc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3552,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZmUwNmJmMjMtMDM5Zi00MzkzLWFkM2ItZGE3NjU3YTIwZjM4IiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-4:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-4:000",
                  },
                  {
                    name: "secIds",
                    value: "C-4:000",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 4,
          tripId: "C-4",
          ctxRecon:
            "¶HKI¶G@T$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121538$202411121600$$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=V.Pavon, Huécija@L=779@a=128@$202411121600$202411121652$ALSALSA $$1$$$$$$§G@T$A=1@O=V.Pavon, Huécija@L=779@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121652$202411121718$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT1H40M",
          rtDuration: "PT1H40M",
          checksum: "f0293213_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "15:38:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@|12112024|153800|160000|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-4:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT22M",
                dist: 21203,
                GisRoute: {
                  dist: 21203,
                  durS: "PT22M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  routeIdx: 4,
                  prognosisType: "PROGNOSED",
                  time: "16:52:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 4,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-4:001",
                idx: 1,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT52M",
                dist: 25688,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  time: "16:52:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:18:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=V.Pavon, Huécija@L=779@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|165200|171800|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-4:002",
                idx: 2,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT26M",
                dist: 19456,
                GisRoute: {
                  dist: 19456,
                  durS: "PT26M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "15:38:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:44:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 8.158719,
            dist: 62628,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 6., 9., 25. Dic, 1., 6. Ene, 28. Feb, 17., 18. Abr, 1. May",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B363CF9F3E7CF9F3C7CF9F3E7CF9C3E74F9F3E7CF9F3E7CF9F3E7CF98",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNzAwMGQ4M2QtYWVkZS00Y2EyLTkwMjEtZWE1M2EzNzI4MTk5IiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU56QXdNR1E0TTJRdFlXVmtaUzAwWTJFeUxUa3dNakV0WldFMU0yRXpOekk0TVRrNUlpd2ljSEpwWTJVaU9qUXVPVFEwTENKamRYSnlaVzVqZVNJNklrVlZVaUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 494,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNzAwMGQ4M2QtYWVkZS00Y2EyLTkwMjEtZWE1M2EzNzI4MTk5IiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-5:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-5:002",
                  },
                  {
                    name: "secIds",
                    value: "C-5:002",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjY0OWZiODQtMjkxNy00ZmRmLWE5MGQtZjkzMGEwYWYyOTRhIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5qWTBPV1ppT0RRdE1qa3hOeTAwWm1SbUxXRTVNR1F0Wmprek1HRXdZV1l5T1RSaElpd2ljSEpwWTJVaU9qTTFMalV5TkRjc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3552,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjY0OWZiODQtMjkxNy00ZmRmLWE5MGQtZjkzMGEwYWYyOTRhIiwicHJpY2UiOjM1LjUyNDcsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-5:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-5:000",
                  },
                  {
                    name: "secIds",
                    value: "C-5:000",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 5,
          tripId: "C-5",
          ctxRecon:
            "¶HKI¶G@T$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121538$202411121600$$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Canjayar, Canjáyar@L=777@a=128@$202411121600$202411121740$ALSALSA $$1$$$$$$§G@T$A=1@O=Canjayar, Canjáyar@L=777@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121740$202411121744$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT2H6M",
          rtDuration: "PT2H6M",
          checksum: "83f696bf_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "15:38:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@|12112024|153800|160000|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-5:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT22M",
                dist: 21203,
                GisRoute: {
                  dist: 21203,
                  durS: "PT22M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  routeIdx: 10,
                  prognosisType: "PROGNOSED",
                  time: "17:40:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 10,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "16:52:00",
                      depDate: "2024-11-12",
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Alicun, Alicún",
                      id: "A=1@O=Alicun, Alicún@X=-2601991@Y=36966304@U=80@L=782@",
                      extId: "782",
                      routeIdx: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                      depTime: "16:55:00",
                      depDate: "2024-11-12",
                      arrTime: "16:55:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Huecija, Huécija",
                      id: "A=1@O=Huecija, Huécija@X=-2607690@Y=36967006@U=80@L=781@",
                      extId: "781",
                      routeIdx: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                      depTime: "17:00:00",
                      depDate: "2024-11-12",
                      arrTime: "17:00:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                      depTime: "17:15:00",
                      depDate: "2024-11-12",
                      arrTime: "17:15:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Instincion, Instinción",
                      id: "A=1@O=Instincion, Instinción@X=-2659459@Y=36994090@U=80@L=783@",
                      extId: "783",
                      routeIdx: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                      depTime: "17:20:00",
                      depDate: "2024-11-12",
                      arrTime: "17:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Ragol, Rágol",
                      id: "A=1@O=Ragol, Rágol@X=-2680682@Y=36995564@U=80@L=778@",
                      extId: "778",
                      routeIdx: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                      depTime: "17:25:00",
                      depDate: "2024-11-12",
                      arrTime: "17:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Canjayar, Canjáyar",
                      id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                      extId: "777",
                      routeIdx: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                      arrTime: "17:40:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-5:001",
                idx: 1,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT1H40M",
                dist: 39897,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                    },
                    {
                      order: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                    },
                    {
                      order: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                    {
                      order: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                    },
                    {
                      order: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                    },
                    {
                      order: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  time: "17:40:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:44:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Canjayar, Canjáyar@L=777@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|174000|174400|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-5:002",
                idx: 2,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT4M",
                dist: 1528,
                GisRoute: {
                  dist: 1528,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:00:00",
            date: "2024-11-12",
            mcp: true,
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "14:58:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 10.785045,
            dist: 50163,
            type: "IMT",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjg2N2VjOGYtMjJhMy00ZDY0LTkzYmMtYjVhNmY0MGFhMmU2IiwicHJpY2UiOjc4Ljc0MzUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5qZzJOMlZqT0dZdE1qSmhNeTAwWkRZMExUa3pZbU10WWpWaE5tWTBNR0ZoTW1VMklpd2ljSEpwWTJVaU9qYzRMamMwTXpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSW4wPQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 7874,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNjg2N2VjOGYtMjJhMy00ZDY0LTkzYmMtYjVhNmY0MGFhMmU2IiwicHJpY2UiOjc4Ljc0MzUsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121400$202411121458$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjQtMTEtMTIiLCJyVGltZSI6IjE0OjAwIiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9UQVhJIn0=",
          duration: "PT58M",
          checksum: "0e269e4b_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:00:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "14:58:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|140000|145800|ft|ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@60000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT58M",
                dist: 50163,
                GisRoute: {
                  dist: 50163,
                  durS: "PT58M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:43:00",
            date: "2024-11-12",
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:18:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 7.579644,
            dist: 61708,
            type: "PTM",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "12. Nov hasta 31. Dic 2024 Lu - Vi; no 6., 9., 25. Dic",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B30000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 2,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiOWVmY2VmMDItN2E5NC00NjFhLTlhNDAtZTRkMDEwMDQ3OGYzIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU9XVm1ZMlZtTURJdE4yRTVOQzAwTmpGaExUbGhOREF0WlRSa01ERXdNRFEzT0dZeklpd2ljSEpwWTJVaU9qTTRMalV5TWl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 3852,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiOWVmY2VmMDItN2E5NC00NjFhLTlhNDAtZTRkMDEwMDQ3OGYzIiwicHJpY2UiOjM4LjUyMiwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "5",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "VTC Executive",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMzMzMWU3MjQtMTgwMy00MGYwLThjZmUtNjExNDEzNTEyMjkzIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU16TXpNV1UzTWpRdE1UZ3dNeTAwTUdZd0xUaGpabVV0TmpFeE5ERXpOVEV5TWpreklpd2ljSEpwWTJVaU9qUTFMamM0TXpVd01EQXdNREF3TURBd05Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi VTC Executive",
                        price: 4578,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMzMzMWU3MjQtMTgwMy00MGYwLThjZmUtNjExNDEzNTEyMjkzIiwicHJpY2UiOjQ1Ljc4MzUwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "9",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMGMxZjgzOGYtYzA3MC00MGMzLTkzNzMtMjVhZjg4ZmNlMTc3IiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1HTXhaamd6T0dZdFl6QTNNQzAwTUdNekxUa3pOek10TWpWaFpqZzRabU5sTVRjM0lpd2ljSEpwWTJVaU9qVXdMams0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan 7pax",
                        price: 5099,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMGMxZjgzOGYtYzA3MC00MGMzLTkzNzMtMjVhZjg4ZmNlMTc3IiwicHJpY2UiOjUwLjk4NSwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "10",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan EXECUTIVE 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMjNhMTYwZTAtY2IwMC00NTE1LTg4MjctYWEyNTZiMDEwYWRmIiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1qTmhNVFl3WlRBdFkySXdNQzAwTlRFMUxUZzRNamN0WVdFeU5UWmlNREV3WVdSbUlpd2ljSEpwWTJVaU9qVTRMamd4TXl3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan EXECUTIVE 7pax",
                        price: 5881,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMjNhMTYwZTAtY2IwMC00NTE1LTg4MjctYWEyNTZiMDEwYWRmIiwicHJpY2UiOjU4LjgxMywiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:003",
                  },
                  {
                    name: "secIds",
                    value: "C-0:003",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                param: [
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-0:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:001",
                  },
                  {
                    name: "TariffURL",
                    value:
                      "https://www.juntadeandalucia.es/temas/transporte/publico/metropolitano.html",
                  },
                  {
                    name: "Supplier",
                    value: "033_junta_andal",
                  },
                  {
                    name: "secIds",
                    value: "C-0:001",
                  },
                ],
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@F$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$202411121443$202411121456$$$1$$$$$$§T$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121456$202411121529$RedM-333$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=V.Pavon, Huécija@L=779@a=128@$202411121600$202411121652$ALSALSA $$1$$$$$$§G@T$A=1@O=V.Pavon, Huécija@L=779@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121652$202411121718$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT2H35M",
          rtDuration: "PT2H35M",
          checksum: "0719729a_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:43:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@|12112024|144300|145600|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT13M",
                dist: 830,
                GisRoute: {
                  dist: 830,
                  durS: "PT13M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  routeIdx: 27,
                  prognosisType: "PROGNOSED",
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 42,
                  prognosisType: "PROGNOSED",
                  time: "15:29:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:29:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:02:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191502#TA#1#DA#121124#1S#700003937#1T#1450#LS#100056312#LT#1602#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1450#TO#100056312#TT#1602#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9511",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 27,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:31:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 42,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:04:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191119#TA#0#DA#121124#1S#700004041#1T#1435#LS#100056312#LT#1604#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1435#TO#100056312#TT#1604#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 204,
                            g: 0,
                            b: 153,
                            hex: "#CC0099",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-333",
                        internalName: "RedM-333",
                        displayNumber: "M-333",
                        num: "9328",
                        line: "M-333",
                        lineId: "6_21(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-333",
                      },
                      name: "RedM-333",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-333",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#0#DA#121124#1S#700003937#1T#1545#LS#100056312#LT#1657#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1545#TO#100056312#TT#1657#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9555",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:54:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:27:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191515#TA#1#DA#121124#1S#700003937#1T#1615#LS#100056312#LT#1727#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1615#TO#100056312#TT#1727#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9512",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "17:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#1#DA#121124#1S#700003937#1T#1645#LS#100056312#LT#1757#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1645#TO#100056312#TT#1757#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9587",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 53,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 204,
                        g: 0,
                        b: 153,
                        hex: "#CC0099",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      nameS: "CTA",
                      nameN: "Red de C",
                      nameL:
                        "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      id: "CTAL",
                    },
                    name: "RedM-333",
                    internalName: "RedM-333",
                    displayNumber: "M-333",
                    num: "9675",
                    line: "M-333",
                    lineId: "6_21(CTAL)033",
                    catOut: "Red de C",
                    catIn: "CTA",
                    catCode: "8",
                    cls: "256",
                    catOutS: "CTA",
                    catOutL:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    operatorCode: "CTA",
                    operator:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    admin: "033004",
                    routeIdxFrom: 27,
                    routeIdxTo: 42,
                    matchId: "M-333",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Pol. Ind. La Algaida, Roquetas de Mar",
                      id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                      extId: "500003962",
                      routeIdx: 27,
                      lon: -2.606746,
                      lat: 36.785972,
                      depTime: "14:56:00",
                      depDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                      mainMastExtId: "700003923",
                      mainMastLon: -2.606971,
                      mainMastLat: 36.786125,
                      depDir: "Estación de tren Almeria, Almería",
                      entry: true,
                    },
                    {
                      name: "Barrio San Francisco, Roquetas de Mar",
                      id: "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603339@Y=36794548@U=80@L=700003963@",
                      extId: "700003963",
                      routeIdx: 28,
                      lon: -2.603339,
                      lat: 36.794548,
                      depTime: "14:58:00",
                      depDate: "2024-11-12",
                      arrTime: "14:58:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603546@Y=36794646@U=80@L=500003946@",
                      mainMastExtId: "500003946",
                      mainMastLon: -2.603546,
                      mainMastLat: 36.794646,
                      entry: true,
                    },
                    {
                      name: "El Parador - Karting, Roquetas de Mar",
                      id: "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2600993@Y=36800130@U=80@L=600003964@",
                      extId: "600003964",
                      routeIdx: 29,
                      lon: -2.600993,
                      lat: 36.80013,
                      depTime: "14:59:00",
                      depDate: "2024-11-12",
                      arrTime: "14:59:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2601146@Y=36800382@U=80@L=500003922@",
                      mainMastExtId: "500003922",
                      mainMastLon: -2.601146,
                      mainMastLat: 36.800382,
                      entry: true,
                    },
                    {
                      name: "El Parador - Fabriquilla, Roquetas de Mar",
                      id: "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2599887@Y=36802881@U=80@L=400004245@",
                      extId: "400004245",
                      routeIdx: 30,
                      lon: -2.599887,
                      lat: 36.802881,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2600373@Y=36802521@U=80@L=500004244@",
                      mainMastExtId: "500004244",
                      mainMastLon: -2.600373,
                      mainMastLat: 36.802521,
                      entry: true,
                    },
                    {
                      name: "El Parador - Parrales V, Roquetas de Mar",
                      id: "A=1@O=El Parador - Parrales V, Roquetas de Mar@X=-2598880@Y=36805676@U=80@L=500003965@",
                      extId: "500003965",
                      routeIdx: 31,
                      lon: -2.59888,
                      lat: 36.805676,
                      depTime: "15:01:00",
                      depDate: "2024-11-12",
                      arrTime: "15:01:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Las Arenas, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Las Arenas, Roquetas de Mar@X=-2592291@Y=36809560@U=80@L=600003966@",
                      extId: "600003966",
                      routeIdx: 32,
                      lon: -2.592291,
                      lat: 36.80956,
                      depTime: "15:03:00",
                      depDate: "2024-11-12",
                      arrTime: "15:03:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=La Gloria, Roquetas de Mar@X=-2591545@Y=36810045@U=80@L=868@",
                      mainMastExtId: "868",
                      mainMastLon: -2.591545,
                      mainMastLat: 36.810045,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - La Gloria, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2586835@Y=36810512@U=80@L=600003967@",
                      extId: "600003967",
                      routeIdx: 33,
                      lon: -2.586835,
                      lat: 36.810512,
                      depTime: "15:05:00",
                      depDate: "2024-11-12",
                      arrTime: "15:05:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2585675@Y=36810917@U=80@L=400003896@",
                      mainMastExtId: "400003896",
                      mainMastLon: -2.585675,
                      mainMastLat: 36.810917,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - Venta Vitorino, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Venta Vitorino, Roquetas de Mar@X=-2582987@Y=36811321@U=80@L=700003968@",
                      extId: "700003968",
                      routeIdx: 34,
                      lon: -2.582987,
                      lat: 36.811321,
                      depTime: "15:06:00",
                      depDate: "2024-11-12",
                      arrTime: "15:06:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Guardia Civil, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575877@Y=36813164@U=80@L=700003969@",
                      extId: "700003969",
                      routeIdx: 35,
                      lon: -2.575877,
                      lat: 36.813164,
                      depTime: "15:08:00",
                      depDate: "2024-11-12",
                      arrTime: "15:08:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575994@Y=36813416@U=80@L=300003895@",
                      mainMastExtId: "300003895",
                      mainMastLon: -2.575994,
                      mainMastLat: 36.813416,
                      entry: true,
                    },
                    {
                      name: "Aguadulce (Almeria), Roquetas de Mar",
                      id: "A=1@O=Aguadulce (Almeria), Roquetas de Mar@X=-2569126@Y=36815268@U=80@L=865@",
                      extId: "865",
                      routeIdx: 36,
                      lon: -2.569126,
                      lat: 36.815268,
                      depTime: "15:10:00",
                      depDate: "2024-11-12",
                      arrTime: "15:10:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Puerto, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565485@Y=36816328@U=80@L=600003972@",
                      extId: "600003972",
                      routeIdx: 37,
                      lon: -2.565485,
                      lat: 36.816328,
                      depTime: "15:11:00",
                      depDate: "2024-11-12",
                      arrTime: "15:11:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565674@Y=36816427@U=80@L=800003893@",
                      mainMastExtId: "800003893",
                      mainMastLon: -2.565674,
                      mainMastLat: 36.816427,
                      entry: true,
                    },
                    {
                      name: "Hotel La Parra, Enix",
                      id: "A=1@O=Hotel La Parra, Enix@X=-2532117@Y=36822019@U=80@L=400003974@",
                      extId: "400003974",
                      routeIdx: 38,
                      lon: -2.532117,
                      lat: 36.822019,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Hotel La Parra, Enix@X=-2529690@Y=36823376@U=80@L=700003973@",
                      mainMastExtId: "700003973",
                      mainMastLon: -2.52969,
                      mainMastLat: 36.823376,
                      entry: true,
                    },
                    {
                      name: "Camping La Garrofa, Almería",
                      id: "A=1@O=Camping La Garrofa, Almería@X=-2516971@Y=36826738@U=80@L=600003976@",
                      extId: "600003976",
                      routeIdx: 39,
                      lon: -2.516971,
                      lat: 36.826738,
                      depTime: "15:17:00",
                      depDate: "2024-11-12",
                      arrTime: "15:17:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Almeria, Almería@X=-2517168@Y=36826909@U=80@L=688@",
                      mainMastExtId: "688",
                      mainMastLon: -2.517168,
                      mainMastLat: 36.826909,
                      entry: true,
                    },
                    {
                      name: "Almería - Pescadería, Almería",
                      id: "A=1@O=Almería - Pescadería, Almería@X=-2480151@Y=36836995@U=80@L=700003931@",
                      extId: "700003931",
                      routeIdx: 40,
                      lon: -2.480151,
                      lat: 36.836995,
                      depTime: "15:21:00",
                      depDate: "2024-11-12",
                      arrTime: "15:21:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=San Roque-Al, Almería@X=-2478542@Y=36837417@U=80@L=100008226@",
                      mainMastExtId: "100008226",
                      mainMastLon: -2.478542,
                      mainMastLat: 36.837417,
                      entry: true,
                    },
                    {
                      name: "Almería - Puerto V, Almería",
                      id: "A=1@O=Almería - Puerto V, Almería@X=-2464842@Y=36833956@U=80@L=800003928@",
                      extId: "800003928",
                      routeIdx: 41,
                      lon: -2.464842,
                      lat: 36.833956,
                      depTime: "15:25:00",
                      depDate: "2024-11-12",
                      arrTime: "15:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 42,
                      lon: -2.45552,
                      lat: 36.834954,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "15:29:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                id: "C-0:001",
                idx: 1,
                name: "RedM-333",
                number: "M-333",
                category: "CTA",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Almeria, Almería",
                directionFlag: "1",
                duration: "PT33M",
                dist: 15734,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.606746,
                      lat: 36.785972,
                    },
                    {
                      order: 1,
                      lon: -2.603339,
                      lat: 36.794548,
                    },
                    {
                      order: 2,
                      lon: -2.600993,
                      lat: 36.80013,
                    },
                    {
                      order: 3,
                      lon: -2.599887,
                      lat: 36.802881,
                    },
                    {
                      order: 4,
                      lon: -2.59888,
                      lat: 36.805676,
                    },
                    {
                      order: 5,
                      lon: -2.592291,
                      lat: 36.80956,
                    },
                    {
                      order: 6,
                      lon: -2.586835,
                      lat: 36.810512,
                    },
                    {
                      order: 7,
                      lon: -2.582987,
                      lat: 36.811321,
                    },
                    {
                      order: 8,
                      lon: -2.575877,
                      lat: 36.813164,
                    },
                    {
                      order: 9,
                      lon: -2.569126,
                      lat: 36.815268,
                    },
                    {
                      order: 10,
                      lon: -2.565485,
                      lat: 36.816328,
                    },
                    {
                      order: 11,
                      lon: -2.532117,
                      lat: 36.822019,
                    },
                    {
                      order: 12,
                      lon: -2.516971,
                      lat: 36.826738,
                    },
                    {
                      order: 13,
                      lon: -2.480151,
                      lat: 36.836995,
                    },
                    {
                      order: 14,
                      lon: -2.464842,
                      lat: 36.833956,
                    },
                    {
                      order: 15,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  routeIdx: 4,
                  prognosisType: "PROGNOSED",
                  time: "16:52:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 4,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-0:002",
                idx: 2,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT52M",
                dist: 25688,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "V.Pavon, Huécija",
                  type: "ST",
                  id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                  extId: "779",
                  lon: -2.605146,
                  lat: 36.960318,
                  time: "16:52:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:18:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=V.Pavon, Huécija@L=779@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|165200|171800|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:003",
                idx: 3,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT26M",
                dist: 19456,
                GisRoute: {
                  dist: 19456,
                  durS: "PT26M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "14:43:00",
            date: "2024-11-12",
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "17:44:00",
            date: "2024-11-12",
          },
          Eco: {
            co2: 4.890262000000001,
            dist: 57989,
            type: "PTM",
            rating: 1,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "12. Nov hasta 31. Dic 2024 Lu - Vi; no 6., 9., 25. Dic",
              sDaysB:
                "E7CF9E3E7CF9F3C3CF9B30000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 2,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTRhODZjNDYtYzY4Zi00YjEyLTgwYzEtM2QyNGZiY2NmMzllIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaVpUUmhPRFpqTkRZdFl6WTRaaTAwWWpFeUxUZ3dZekV0TTJReU5HWmlZMk5tTXpsbElpd2ljSEpwWTJVaU9qUXVPVFEwTENKamRYSnlaVzVqZVNJNklrVlZVaUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 494,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiZTRhODZjNDYtYzY4Zi00YjEyLTgwYzEtM2QyNGZiY2NmMzllIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-1:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:003",
                  },
                  {
                    name: "secIds",
                    value: "C-1:003",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                param: [
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-1:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:001",
                  },
                  {
                    name: "TariffURL",
                    value:
                      "https://www.juntadeandalucia.es/temas/transporte/publico/metropolitano.html",
                  },
                  {
                    name: "Supplier",
                    value: "033_junta_andal",
                  },
                  {
                    name: "secIds",
                    value: "C-1:001",
                  },
                ],
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶G@F$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$202411121443$202411121456$$$1$$$$$$§T$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411121456$202411121529$RedM-333$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Canjayar, Canjáyar@L=777@a=128@$202411121600$202411121740$ALSALSA $$1$$$$$$§G@T$A=1@O=Canjayar, Canjáyar@L=777@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411121740$202411121744$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT3H1M",
          rtDuration: "PT3H1M",
          checksum: "abd1ba5a_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "14:43:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@|12112024|144300|145600|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT13M",
                dist: 830,
                GisRoute: {
                  dist: 830,
                  durS: "PT13M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  routeIdx: 27,
                  prognosisType: "PROGNOSED",
                  time: "14:56:00",
                  date: "2024-11-12",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 42,
                  prognosisType: "PROGNOSED",
                  time: "15:29:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:29:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:02:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191502#TA#1#DA#121124#1S#700003937#1T#1450#LS#100056312#LT#1602#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1450#TO#100056312#TT#1602#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9511",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 27,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "15:31:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 42,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:04:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191119#TA#0#DA#121124#1S#700004041#1T#1435#LS#100056312#LT#1604#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1435#TO#100056312#TT#1604#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 204,
                            g: 0,
                            b: 153,
                            hex: "#CC0099",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-333",
                        internalName: "RedM-333",
                        displayNumber: "M-333",
                        num: "9328",
                        line: "M-333",
                        lineId: "6_21(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-333",
                      },
                      name: "RedM-333",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-333",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "16:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#0#DA#121124#1S#700003937#1T#1545#LS#100056312#LT#1657#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1545#TO#100056312#TT#1657#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9555",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "16:54:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:27:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191515#TA#1#DA#121124#1S#700003937#1T#1615#LS#100056312#LT#1727#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1615#TO#100056312#TT#1727#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9512",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "17:24:00",
                            depDate: "2024-11-12",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "17:57:00",
                            arrDate: "2024-11-12",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191598#TA#1#DA#121124#1S#700003937#1T#1645#LS#100056312#LT#1757#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#1645#TO#100056312#TT#1757#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9587",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 53,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 204,
                        g: 0,
                        b: 153,
                        hex: "#CC0099",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      nameS: "CTA",
                      nameN: "Red de C",
                      nameL:
                        "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      id: "CTAL",
                    },
                    name: "RedM-333",
                    internalName: "RedM-333",
                    displayNumber: "M-333",
                    num: "9675",
                    line: "M-333",
                    lineId: "6_21(CTAL)033",
                    catOut: "Red de C",
                    catIn: "CTA",
                    catCode: "8",
                    cls: "256",
                    catOutS: "CTA",
                    catOutL:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    operatorCode: "CTA",
                    operator:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    admin: "033004",
                    routeIdxFrom: 27,
                    routeIdxTo: 42,
                    matchId: "M-333",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Pol. Ind. La Algaida, Roquetas de Mar",
                      id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                      extId: "500003962",
                      routeIdx: 27,
                      lon: -2.606746,
                      lat: 36.785972,
                      depTime: "14:56:00",
                      depDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                      mainMastExtId: "700003923",
                      mainMastLon: -2.606971,
                      mainMastLat: 36.786125,
                      depDir: "Estación de tren Almeria, Almería",
                      entry: true,
                    },
                    {
                      name: "Barrio San Francisco, Roquetas de Mar",
                      id: "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603339@Y=36794548@U=80@L=700003963@",
                      extId: "700003963",
                      routeIdx: 28,
                      lon: -2.603339,
                      lat: 36.794548,
                      depTime: "14:58:00",
                      depDate: "2024-11-12",
                      arrTime: "14:58:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603546@Y=36794646@U=80@L=500003946@",
                      mainMastExtId: "500003946",
                      mainMastLon: -2.603546,
                      mainMastLat: 36.794646,
                      entry: true,
                    },
                    {
                      name: "El Parador - Karting, Roquetas de Mar",
                      id: "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2600993@Y=36800130@U=80@L=600003964@",
                      extId: "600003964",
                      routeIdx: 29,
                      lon: -2.600993,
                      lat: 36.80013,
                      depTime: "14:59:00",
                      depDate: "2024-11-12",
                      arrTime: "14:59:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2601146@Y=36800382@U=80@L=500003922@",
                      mainMastExtId: "500003922",
                      mainMastLon: -2.601146,
                      mainMastLat: 36.800382,
                      entry: true,
                    },
                    {
                      name: "El Parador - Fabriquilla, Roquetas de Mar",
                      id: "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2599887@Y=36802881@U=80@L=400004245@",
                      extId: "400004245",
                      routeIdx: 30,
                      lon: -2.599887,
                      lat: 36.802881,
                      depTime: "15:00:00",
                      depDate: "2024-11-12",
                      arrTime: "15:00:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2600373@Y=36802521@U=80@L=500004244@",
                      mainMastExtId: "500004244",
                      mainMastLon: -2.600373,
                      mainMastLat: 36.802521,
                      entry: true,
                    },
                    {
                      name: "El Parador - Parrales V, Roquetas de Mar",
                      id: "A=1@O=El Parador - Parrales V, Roquetas de Mar@X=-2598880@Y=36805676@U=80@L=500003965@",
                      extId: "500003965",
                      routeIdx: 31,
                      lon: -2.59888,
                      lat: 36.805676,
                      depTime: "15:01:00",
                      depDate: "2024-11-12",
                      arrTime: "15:01:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Las Arenas, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Las Arenas, Roquetas de Mar@X=-2592291@Y=36809560@U=80@L=600003966@",
                      extId: "600003966",
                      routeIdx: 32,
                      lon: -2.592291,
                      lat: 36.80956,
                      depTime: "15:03:00",
                      depDate: "2024-11-12",
                      arrTime: "15:03:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=La Gloria, Roquetas de Mar@X=-2591545@Y=36810045@U=80@L=868@",
                      mainMastExtId: "868",
                      mainMastLon: -2.591545,
                      mainMastLat: 36.810045,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - La Gloria, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2586835@Y=36810512@U=80@L=600003967@",
                      extId: "600003967",
                      routeIdx: 33,
                      lon: -2.586835,
                      lat: 36.810512,
                      depTime: "15:05:00",
                      depDate: "2024-11-12",
                      arrTime: "15:05:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - La Gloria, Roquetas de Mar@X=-2585675@Y=36810917@U=80@L=400003896@",
                      mainMastExtId: "400003896",
                      mainMastLon: -2.585675,
                      mainMastLat: 36.810917,
                      entry: true,
                    },
                    {
                      name: "Aguadulce - Venta Vitorino, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Venta Vitorino, Roquetas de Mar@X=-2582987@Y=36811321@U=80@L=700003968@",
                      extId: "700003968",
                      routeIdx: 34,
                      lon: -2.582987,
                      lat: 36.811321,
                      depTime: "15:06:00",
                      depDate: "2024-11-12",
                      arrTime: "15:06:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Guardia Civil, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575877@Y=36813164@U=80@L=700003969@",
                      extId: "700003969",
                      routeIdx: 35,
                      lon: -2.575877,
                      lat: 36.813164,
                      depTime: "15:08:00",
                      depDate: "2024-11-12",
                      arrTime: "15:08:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Guardia Civil, Roquetas de Mar@X=-2575994@Y=36813416@U=80@L=300003895@",
                      mainMastExtId: "300003895",
                      mainMastLon: -2.575994,
                      mainMastLat: 36.813416,
                      entry: true,
                    },
                    {
                      name: "Aguadulce (Almeria), Roquetas de Mar",
                      id: "A=1@O=Aguadulce (Almeria), Roquetas de Mar@X=-2569126@Y=36815268@U=80@L=865@",
                      extId: "865",
                      routeIdx: 36,
                      lon: -2.569126,
                      lat: 36.815268,
                      depTime: "15:10:00",
                      depDate: "2024-11-12",
                      arrTime: "15:10:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Aguadulce - Puerto, Roquetas de Mar",
                      id: "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565485@Y=36816328@U=80@L=600003972@",
                      extId: "600003972",
                      routeIdx: 37,
                      lon: -2.565485,
                      lat: 36.816328,
                      depTime: "15:11:00",
                      depDate: "2024-11-12",
                      arrTime: "15:11:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Aguadulce - Puerto, Roquetas de Mar@X=-2565674@Y=36816427@U=80@L=800003893@",
                      mainMastExtId: "800003893",
                      mainMastLon: -2.565674,
                      mainMastLat: 36.816427,
                      entry: true,
                    },
                    {
                      name: "Hotel La Parra, Enix",
                      id: "A=1@O=Hotel La Parra, Enix@X=-2532117@Y=36822019@U=80@L=400003974@",
                      extId: "400003974",
                      routeIdx: 38,
                      lon: -2.532117,
                      lat: 36.822019,
                      depTime: "15:15:00",
                      depDate: "2024-11-12",
                      arrTime: "15:15:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Hotel La Parra, Enix@X=-2529690@Y=36823376@U=80@L=700003973@",
                      mainMastExtId: "700003973",
                      mainMastLon: -2.52969,
                      mainMastLat: 36.823376,
                      entry: true,
                    },
                    {
                      name: "Camping La Garrofa, Almería",
                      id: "A=1@O=Camping La Garrofa, Almería@X=-2516971@Y=36826738@U=80@L=600003976@",
                      extId: "600003976",
                      routeIdx: 39,
                      lon: -2.516971,
                      lat: 36.826738,
                      depTime: "15:17:00",
                      depDate: "2024-11-12",
                      arrTime: "15:17:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Almeria, Almería@X=-2517168@Y=36826909@U=80@L=688@",
                      mainMastExtId: "688",
                      mainMastLon: -2.517168,
                      mainMastLat: 36.826909,
                      entry: true,
                    },
                    {
                      name: "Almería - Pescadería, Almería",
                      id: "A=1@O=Almería - Pescadería, Almería@X=-2480151@Y=36836995@U=80@L=700003931@",
                      extId: "700003931",
                      routeIdx: 40,
                      lon: -2.480151,
                      lat: 36.836995,
                      depTime: "15:21:00",
                      depDate: "2024-11-12",
                      arrTime: "15:21:00",
                      arrDate: "2024-11-12",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=San Roque-Al, Almería@X=-2478542@Y=36837417@U=80@L=100008226@",
                      mainMastExtId: "100008226",
                      mainMastLon: -2.478542,
                      mainMastLat: 36.837417,
                      entry: true,
                    },
                    {
                      name: "Almería - Puerto V, Almería",
                      id: "A=1@O=Almería - Puerto V, Almería@X=-2464842@Y=36833956@U=80@L=800003928@",
                      extId: "800003928",
                      routeIdx: 41,
                      lon: -2.464842,
                      lat: 36.833956,
                      depTime: "15:25:00",
                      depDate: "2024-11-12",
                      arrTime: "15:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 42,
                      lon: -2.45552,
                      lat: 36.834954,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "15:29:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191623#TA#1#DA#121124#1S#700004041#1T#1400#LS#100056312#LT#1529#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#700004041#FT#1400#TO#100056312#TT#1529#",
                },
                id: "C-1:001",
                idx: 1,
                name: "RedM-333",
                number: "M-333",
                category: "CTA",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Almeria, Almería",
                directionFlag: "1",
                duration: "PT33M",
                dist: 15734,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.606746,
                      lat: 36.785972,
                    },
                    {
                      order: 1,
                      lon: -2.603339,
                      lat: 36.794548,
                    },
                    {
                      order: 2,
                      lon: -2.600993,
                      lat: 36.80013,
                    },
                    {
                      order: 3,
                      lon: -2.599887,
                      lat: 36.802881,
                    },
                    {
                      order: 4,
                      lon: -2.59888,
                      lat: 36.805676,
                    },
                    {
                      order: 5,
                      lon: -2.592291,
                      lat: 36.80956,
                    },
                    {
                      order: 6,
                      lon: -2.586835,
                      lat: 36.810512,
                    },
                    {
                      order: 7,
                      lon: -2.582987,
                      lat: 36.811321,
                    },
                    {
                      order: 8,
                      lon: -2.575877,
                      lat: 36.813164,
                    },
                    {
                      order: 9,
                      lon: -2.569126,
                      lat: 36.815268,
                    },
                    {
                      order: 10,
                      lon: -2.565485,
                      lat: 36.816328,
                    },
                    {
                      order: 11,
                      lon: -2.532117,
                      lat: 36.822019,
                    },
                    {
                      order: 12,
                      lon: -2.516971,
                      lat: 36.826738,
                    },
                    {
                      order: 13,
                      lon: -2.480151,
                      lat: 36.836995,
                    },
                    {
                      order: 14,
                      lon: -2.464842,
                      lat: 36.833956,
                    },
                    {
                      order: 15,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2024-11-12",
                },
                Destination: {
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  routeIdx: 10,
                  prognosisType: "PROGNOSED",
                  time: "17:40:00",
                  date: "2024-11-12",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - A",
                    num: "11144",
                    line: "ALSA - A",
                    lineId: "7550(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 10,
                    matchId: "ALSA - A",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2024-11-12",
                      depDir: "Ohanes",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      extId: "100000737",
                      routeIdx: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                      depTime: "16:20:00",
                      depDate: "2024-11-12",
                      arrTime: "16:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "16:30:00",
                      depDate: "2024-11-12",
                      arrTime: "16:30:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "16:45:00",
                      depDate: "2024-11-12",
                      arrTime: "16:45:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "16:52:00",
                      depDate: "2024-11-12",
                      arrTime: "16:52:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Alicun, Alicún",
                      id: "A=1@O=Alicun, Alicún@X=-2601991@Y=36966304@U=80@L=782@",
                      extId: "782",
                      routeIdx: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                      depTime: "16:55:00",
                      depDate: "2024-11-12",
                      arrTime: "16:55:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Huecija, Huécija",
                      id: "A=1@O=Huecija, Huécija@X=-2607690@Y=36967006@U=80@L=781@",
                      extId: "781",
                      routeIdx: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                      depTime: "17:00:00",
                      depDate: "2024-11-12",
                      arrTime: "17:00:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                      depTime: "17:15:00",
                      depDate: "2024-11-12",
                      arrTime: "17:15:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Instincion, Instinción",
                      id: "A=1@O=Instincion, Instinción@X=-2659459@Y=36994090@U=80@L=783@",
                      extId: "783",
                      routeIdx: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                      depTime: "17:20:00",
                      depDate: "2024-11-12",
                      arrTime: "17:20:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Ragol, Rágol",
                      id: "A=1@O=Ragol, Rágol@X=-2680682@Y=36995564@U=80@L=778@",
                      extId: "778",
                      routeIdx: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                      depTime: "17:25:00",
                      depDate: "2024-11-12",
                      arrTime: "17:25:00",
                      arrDate: "2024-11-12",
                    },
                    {
                      name: "Canjayar, Canjáyar",
                      id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                      extId: "777",
                      routeIdx: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                      arrTime: "17:40:00",
                      arrDate: "2024-11-12",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-12",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#121578#TA#0#DA#121124#1S#100056312#1T#1600#LS#773#LT#1820#PU#80#RT#1#CA#300#ZE#ALSA - A#ZB#ALSALSA #PC#8#FR#100056312#FT#1600#TO#773#TT#1820#",
                },
                id: "C-1:002",
                idx: 2,
                name: "ALSALSA",
                number: "ALSA - A",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Ohanes",
                directionFlag: "0",
                duration: "PT1H40M",
                dist: 39897,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.460815,
                      lat: 36.926527,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.601991,
                      lat: 36.966304,
                    },
                    {
                      order: 6,
                      lon: -2.60769,
                      lat: 36.967006,
                    },
                    {
                      order: 7,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                    {
                      order: 8,
                      lon: -2.659459,
                      lat: 36.99409,
                    },
                    {
                      order: 9,
                      lon: -2.680682,
                      lat: 36.995564,
                    },
                    {
                      order: 10,
                      lon: -2.740775,
                      lat: 37.009219,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  time: "17:40:00",
                  date: "2024-11-12",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "17:44:00",
                  date: "2024-11-12",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Canjayar, Canjáyar@L=777@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|12112024|174000|174400|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-1:003",
                idx: 3,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT4M",
                dist: 1528,
                GisRoute: {
                  dist: 1528,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  key: "P4",
                  type: "A",
                },
                {
                  key: "CA",
                  type: "A",
                },
              ],
            },
            name: "Roquetas de Mar, Aquarium Roquetas de Mar",
            type: "POI",
            id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
            extId: "970119291",
            lon: -2.604022,
            lat: 36.781648,
            time: "07:11:00",
            date: "2024-11-13",
          },
          Destination: {
            name: "Calle Alcora",
            description: "Canjáyar",
            type: "ADR",
            id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
            lon: -2.738851,
            lat: 36.998971,
            time: "09:44:00",
            date: "2024-11-13",
          },
          Eco: {
            co2: 4.90822,
            dist: 58208,
            type: "PTM",
            rating: 1,
          },
          EcoCmp: [
            {
              co2: 5.022570907891614,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "12. Nov hasta 31. Dic 2024 Lu - Vi",
              sDaysB:
                "E7CF9F3E7CF9F3E7CF9F30000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 24,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiOTI0MDVhOTYtMDMyMi00OGYwLWE5YmUtN2I0ODMzNjlhM2YwIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU9USTBNRFZoT1RZdE1ETXlNaTAwT0dZd0xXRTVZbVV0TjJJME9ETXpOamxoTTJZd0lpd2ljSEpwWTJVaU9qUXVPVFEwTENKamRYSnlaVzVqZVNJNklrVlZVaUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 494,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiOTI0MDVhOTYtMDMyMi00OGYwLWE5YmUtN2I0ODMzNjlhM2YwIiwicHJpY2UiOjQuOTQ0LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-2:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:003",
                  },
                  {
                    name: "secIds",
                    value: "C-2:003",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                param: [
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-2:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:001",
                  },
                  {
                    name: "TariffURL",
                    value:
                      "https://www.juntadeandalucia.es/temas/transporte/publico/metropolitano.html",
                  },
                  {
                    name: "Supplier",
                    value: "033_junta_andal",
                  },
                  {
                    name: "secIds",
                    value: "C-2:001",
                  },
                ],
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶G@F$A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$202411130711$202411130724$$$1$$$$$$§T$A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$202411130724$202411130744$RedM-330$$1$$$$$$§T$A=1@O=Estación de tren Almeria, Almería@L=100056312@a=128@$A=1@O=Canjayar, Canjáyar@L=777@a=128@$202411130830$202411130940$ALSALSA $$1$$$$$$§G@T$A=1@O=Canjayar, Canjáyar@L=777@a=128@$A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@$202411130940$202411130944$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT2H33M",
          rtDuration: "PT2H33M",
          checksum: "763f4366_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        key: "P4",
                        type: "A",
                      },
                      {
                        key: "CA",
                        type: "A",
                      },
                    ],
                  },
                  name: "Roquetas de Mar, Aquarium Roquetas de Mar",
                  type: "POI",
                  id: "A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@U=101@L=970119291@",
                  extId: "970119291",
                  lon: -2.604022,
                  lat: 36.781648,
                  time: "07:11:00",
                  date: "2024-11-13",
                },
                Destination: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  time: "07:24:00",
                  date: "2024-11-13",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=4@O=Roquetas de Mar, Aquarium Roquetas de Mar@X=-2604022@Y=36781648@L=970119291@a=128@|A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@L=500003962@a=128@|13112024|71100|72400|bf|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT13M",
                dist: 830,
                GisRoute: {
                  dist: 830,
                  durS: "PT13M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Pol. Ind. La Algaida, Roquetas de Mar",
                  type: "ST",
                  id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                  extId: "500003962",
                  lon: -2.606746,
                  lat: 36.785972,
                  routeIdx: 22,
                  prognosisType: "PROGNOSED",
                  time: "07:24:00",
                  date: "2024-11-13",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                  mainMastExtId: "700003923",
                  mainMastLon: -2.606971,
                  mainMastLat: 36.786125,
                  entry: true,
                },
                Destination: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 30,
                  prognosisType: "PROGNOSED",
                  time: "07:44:00",
                  date: "2024-11-13",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191501#TA#0#DA#131124#1S#700003937#1T#645#LS#100056312#LT#744#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#645#TO#100056312#TT#744#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "07:54:00",
                            depDate: "2024-11-13",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "08:27:00",
                            arrDate: "2024-11-13",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191502#TA#0#DA#131124#1S#700003937#1T#715#LS#100056312#LT#827#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#715#TO#100056312#TT#827#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9499",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "08:24:00",
                            depDate: "2024-11-13",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "08:57:00",
                            arrDate: "2024-11-13",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191505#TA#0#DA#131124#1S#700003937#1T#745#LS#100056312#LT#857#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#745#TO#100056312#TT#857#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9500",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 29,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "08:48:00",
                            depDate: "2024-11-13",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 44,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "09:21:00",
                            arrDate: "2024-11-13",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191821#TA#0#DA#131124#1S#600004042#1T#740#LS#100056312#LT#921#PU#80#RT#1#CA#CTA#ZE#M-333#ZB#RedM-333#PC#8#FR#600004042#FT#740#TO#100056312#TT#921#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 204,
                            g: 0,
                            b: 153,
                            hex: "#CC0099",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-333",
                        internalName: "RedM-333",
                        displayNumber: "M-333",
                        num: "9674",
                        line: "M-333",
                        lineId: "6_21(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-333",
                      },
                      name: "RedM-333",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-333",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "09:24:00",
                            depDate: "2024-11-13",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 37,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "09:57:00",
                            arrDate: "2024-11-13",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191505#TA#1#DA#131124#1S#700003937#1T#845#LS#100056312#LT#957#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#845#TO#100056312#TT#957#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9501",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Pol. Ind. La Algaida, Roquetas de Mar",
                            id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                            extId: "500003962",
                            routeIdx: 22,
                            lon: -2.606746,
                            lat: 36.785972,
                            depTime: "09:54:00",
                            depDate: "2024-11-13",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                            mainMastExtId: "700003923",
                            mainMastLon: -2.606971,
                            mainMastLat: 36.786125,
                            depDir: "Estación de tren Almeria, Almería",
                            entry: true,
                          },
                          {
                            name: "Estación de tren Almeria, Almería",
                            id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                            extId: "100056312",
                            routeIdx: 30,
                            lon: -2.45552,
                            lat: 36.834954,
                            arrPrognosisType: "PROGNOSED",
                            arrTime: "10:14:00",
                            arrDate: "2024-11-13",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191501#TA#1#DA#131124#1S#700003937#1T#915#LS#100056312#LT#1014#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#915#TO#100056312#TT#1014#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 255,
                            g: 102,
                            b: 102,
                            hex: "#FF6666",
                          },
                          res: "prod_bus",
                        },
                        operatorInfo: {
                          name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          nameS: "CTA",
                          nameN: "Red de C",
                          nameL:
                            "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                          id: "CTAL",
                        },
                        name: "RedM-330",
                        internalName: "RedM-330",
                        displayNumber: "M-330",
                        num: "9502",
                        line: "M-330",
                        lineId: "6_19(CTAL)033",
                        catOut: "Red de C",
                        catIn: "CTA",
                        catCode: "8",
                        cls: "256",
                        catOutS: "CTA",
                        catOutL:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        operatorCode: "CTA",
                        operator:
                          "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                        admin: "033004",
                        matchId: "M-330",
                      },
                      name: "RedM-330",
                      direction: "Estación de tren Almeria, Almería",
                      trainNumber: "M-330",
                      trainCategory: "CTA",
                    },
                  ],
                  waitMinimum: 24,
                  waitMaximum: 36,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 255,
                        g: 102,
                        b: 102,
                        hex: "#FF6666",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      nameS: "CTA",
                      nameN: "Red de C",
                      nameL:
                        "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                      id: "CTAL",
                    },
                    name: "RedM-330",
                    internalName: "RedM-330",
                    displayNumber: "M-330",
                    num: "9498",
                    line: "M-330",
                    lineId: "6_19(CTAL)033",
                    catOut: "Red de C",
                    catIn: "CTA",
                    catCode: "8",
                    cls: "256",
                    catOutS: "CTA",
                    catOutL:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    operatorCode: "CTA",
                    operator:
                      "Red de Consorcios de Transporte de Andalucía - Área de Almería",
                    admin: "033004",
                    routeIdxFrom: 22,
                    routeIdxTo: 30,
                    matchId: "M-330",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Pol. Ind. La Algaida, Roquetas de Mar",
                      id: "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606746@Y=36785972@U=80@L=500003962@",
                      extId: "500003962",
                      routeIdx: 22,
                      lon: -2.606746,
                      lat: 36.785972,
                      depTime: "07:24:00",
                      depDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pol. Ind. La Algaida, Roquetas de Mar@X=-2606971@Y=36786125@U=80@L=700003923@",
                      mainMastExtId: "700003923",
                      mainMastLon: -2.606971,
                      mainMastLat: 36.786125,
                      depDir: "Estación de tren Almeria, Almería",
                      entry: true,
                    },
                    {
                      name: "Barrio San Francisco, Roquetas de Mar",
                      id: "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603339@Y=36794548@U=80@L=700003963@",
                      extId: "700003963",
                      routeIdx: 23,
                      lon: -2.603339,
                      lat: 36.794548,
                      depTime: "07:26:00",
                      depDate: "2024-11-13",
                      arrTime: "07:26:00",
                      arrDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Barrio San Francisco, Roquetas de Mar@X=-2603546@Y=36794646@U=80@L=500003946@",
                      mainMastExtId: "500003946",
                      mainMastLon: -2.603546,
                      mainMastLat: 36.794646,
                      entry: true,
                    },
                    {
                      name: "El Parador - Karting, Roquetas de Mar",
                      id: "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2600993@Y=36800130@U=80@L=600003964@",
                      extId: "600003964",
                      routeIdx: 24,
                      lon: -2.600993,
                      lat: 36.80013,
                      depTime: "07:27:00",
                      depDate: "2024-11-13",
                      arrTime: "07:27:00",
                      arrDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Karting, Roquetas de Mar@X=-2601146@Y=36800382@U=80@L=500003922@",
                      mainMastExtId: "500003922",
                      mainMastLon: -2.601146,
                      mainMastLat: 36.800382,
                      entry: true,
                    },
                    {
                      name: "El Parador - Fabriquilla, Roquetas de Mar",
                      id: "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2599887@Y=36802881@U=80@L=400004245@",
                      extId: "400004245",
                      routeIdx: 25,
                      lon: -2.599887,
                      lat: 36.802881,
                      depTime: "07:28:00",
                      depDate: "2024-11-13",
                      arrTime: "07:28:00",
                      arrDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=El Parador - Fabriquilla, Roquetas de Mar@X=-2600373@Y=36802521@U=80@L=500004244@",
                      mainMastExtId: "500004244",
                      mainMastLon: -2.600373,
                      mainMastLat: 36.802521,
                      entry: true,
                    },
                    {
                      name: "El Parador - Parrales V, Roquetas de Mar",
                      id: "A=1@O=El Parador - Parrales V, Roquetas de Mar@X=-2598880@Y=36805676@U=80@L=500003965@",
                      extId: "500003965",
                      routeIdx: 26,
                      lon: -2.59888,
                      lat: 36.805676,
                      depTime: "07:29:00",
                      depDate: "2024-11-13",
                      arrTime: "07:29:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "C.C. Viapark, Vícar",
                      id: "A=1@O=C.C. Viapark, Vícar@X=-2600103@Y=36816041@U=80@L=600003887@",
                      extId: "600003887",
                      routeIdx: 27,
                      lon: -2.600103,
                      lat: 36.816041,
                      depTime: "07:32:00",
                      depDate: "2024-11-13",
                      arrTime: "07:32:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Almería - Pescadería, Almería",
                      id: "A=1@O=Almería - Pescadería, Almería@X=-2480151@Y=36836995@U=80@L=700003931@",
                      extId: "700003931",
                      routeIdx: 28,
                      lon: -2.480151,
                      lat: 36.836995,
                      depTime: "07:36:00",
                      depDate: "2024-11-13",
                      arrTime: "07:36:00",
                      arrDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=San Roque-Al, Almería@X=-2478542@Y=36837417@U=80@L=100008226@",
                      mainMastExtId: "100008226",
                      mainMastLon: -2.478542,
                      mainMastLat: 36.837417,
                      entry: true,
                    },
                    {
                      name: "Almería - Puerto V, Almería",
                      id: "A=1@O=Almería - Puerto V, Almería@X=-2464842@Y=36833956@U=80@L=800003928@",
                      extId: "800003928",
                      routeIdx: 29,
                      lon: -2.464842,
                      lat: 36.833956,
                      depTime: "07:40:00",
                      depDate: "2024-11-13",
                      arrTime: "07:40:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 30,
                      lon: -2.45552,
                      lat: 36.834954,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "07:44:00",
                      arrDate: "2024-11-13",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-13",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#191501#TA#0#DA#131124#1S#700003937#1T#645#LS#100056312#LT#744#PU#80#RT#1#CA#CTA#ZE#M-330#ZB#RedM-330#PC#8#FR#700003937#FT#645#TO#100056312#TT#744#",
                },
                id: "C-2:001",
                idx: 1,
                name: "RedM-330",
                number: "M-330",
                category: "CTA",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Almeria, Almería",
                directionFlag: "1",
                duration: "PT20M",
                dist: 16633,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.606746,
                      lat: 36.785972,
                    },
                    {
                      order: 1,
                      lon: -2.603339,
                      lat: 36.794548,
                    },
                    {
                      order: 2,
                      lon: -2.600993,
                      lat: 36.80013,
                    },
                    {
                      order: 3,
                      lon: -2.599887,
                      lat: 36.802881,
                    },
                    {
                      order: 4,
                      lon: -2.59888,
                      lat: 36.805676,
                    },
                    {
                      order: 5,
                      lon: -2.600103,
                      lat: 36.816041,
                    },
                    {
                      order: 6,
                      lon: -2.480151,
                      lat: 36.836995,
                    },
                    {
                      order: 7,
                      lon: -2.464842,
                      lat: 36.833956,
                    },
                    {
                      order: 8,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Almeria, Almería",
                  type: "ST",
                  id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                  extId: "100056312",
                  lon: -2.45552,
                  lat: 36.834954,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "08:30:00",
                  date: "2024-11-13",
                },
                Destination: {
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  routeIdx: 8,
                  prognosisType: "PROGNOSED",
                  time: "09:40:00",
                  date: "2024-11-13",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#168319#TA#0#DA#131124#1S#100056312#1T#830#LS#787#LT#1100#PU#80#RT#1#CA#300#ZE#ALSA - C#ZB#ALSALSA #PC#8#FR#100056312#FT#830#TO#787#TT#1100#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - C",
                    num: "7211",
                    line: "ALSA - C",
                    lineId: "2988(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 8,
                    matchId: "ALSA - C",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Almeria, Almería",
                      id: "A=1@O=Estación de tren Almeria, Almería@X=-2455520@Y=36834954@U=80@L=100056312@",
                      extId: "100056312",
                      routeIdx: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                      depPrognosisType: "PROGNOSED",
                      depTime: "08:30:00",
                      depDate: "2024-11-13",
                      depDir: "Berja",
                    },
                    {
                      name: "Benahadux, Benahadux",
                      id: "A=1@O=Benahadux, Benahadux@X=-2461642@Y=36924496@U=80@L=738@",
                      extId: "738",
                      routeIdx: 1,
                      lon: -2.461642,
                      lat: 36.924496,
                      depTime: "08:50:00",
                      depDate: "2024-11-13",
                      arrTime: "08:50:00",
                      arrDate: "2024-11-13",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Benahadux, Benahadux@X=-2460815@Y=36926527@U=80@L=100000737@",
                      mainMastExtId: "100000737",
                      mainMastLon: -2.460815,
                      mainMastLat: 36.926527,
                      entry: true,
                    },
                    {
                      name: "Gádor - Pueblo, Gádor",
                      id: "A=1@O=Gádor - Pueblo, Gádor@X=-2494111@Y=36954861@U=80@L=600004143@",
                      extId: "600004143",
                      routeIdx: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                      depTime: "09:00:00",
                      depDate: "2024-11-13",
                      arrTime: "09:00:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Estación de tren Gador, Gádor",
                      id: "A=1@O=Estación de tren Gador, Gádor@X=-2487657@Y=36951625@U=80@L=100056308@",
                      extId: "100056308",
                      routeIdx: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                      depTime: "09:10:00",
                      depDate: "2024-11-13",
                      arrTime: "09:10:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "V.Pavon, Huécija",
                      id: "A=1@O=V.Pavon, Huécija@X=-2605146@Y=36960318@U=80@L=779@",
                      extId: "779",
                      routeIdx: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                      depTime: "09:20:00",
                      depDate: "2024-11-13",
                      arrTime: "09:20:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Illar, Íllar",
                      id: "A=1@O=Illar, Íllar@X=-2639161@Y=36986413@U=80@L=780@",
                      extId: "780",
                      routeIdx: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                      depTime: "09:25:00",
                      depDate: "2024-11-13",
                      arrTime: "09:25:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Instincion, Instinción",
                      id: "A=1@O=Instincion, Instinción@X=-2659459@Y=36994090@U=80@L=783@",
                      extId: "783",
                      routeIdx: 6,
                      lon: -2.659459,
                      lat: 36.99409,
                      depTime: "09:30:00",
                      depDate: "2024-11-13",
                      arrTime: "09:30:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Ragol, Rágol",
                      id: "A=1@O=Ragol, Rágol@X=-2680682@Y=36995564@U=80@L=778@",
                      extId: "778",
                      routeIdx: 7,
                      lon: -2.680682,
                      lat: 36.995564,
                      depTime: "09:35:00",
                      depDate: "2024-11-13",
                      arrTime: "09:35:00",
                      arrDate: "2024-11-13",
                    },
                    {
                      name: "Canjayar, Canjáyar",
                      id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                      extId: "777",
                      routeIdx: 8,
                      lon: -2.740775,
                      lat: 37.009219,
                      arrTime: "09:40:00",
                      arrDate: "2024-11-13",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-13",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#168319#TA#0#DA#131124#1S#100056312#1T#830#LS#787#LT#1100#PU#80#RT#1#CA#300#ZE#ALSA - C#ZB#ALSALSA #PC#8#FR#100056312#FT#830#TO#787#TT#1100#",
                },
                id: "C-2:002",
                idx: 2,
                name: "ALSALSA",
                number: "ALSA - C",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Berja",
                directionFlag: "0",
                duration: "PT1H10M",
                dist: 39217,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -2.45552,
                      lat: 36.834954,
                    },
                    {
                      order: 1,
                      lon: -2.461642,
                      lat: 36.924496,
                    },
                    {
                      order: 2,
                      lon: -2.494111,
                      lat: 36.954861,
                    },
                    {
                      order: 3,
                      lon: -2.487657,
                      lat: 36.951625,
                    },
                    {
                      order: 4,
                      lon: -2.605146,
                      lat: 36.960318,
                    },
                    {
                      order: 5,
                      lon: -2.639161,
                      lat: 36.986413,
                    },
                    {
                      order: 6,
                      lon: -2.659459,
                      lat: 36.99409,
                    },
                    {
                      order: 7,
                      lon: -2.680682,
                      lat: 36.995564,
                    },
                    {
                      order: 8,
                      lon: -2.740775,
                      lat: 37.009219,
                    },
                  ],
                },
              },
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Canjayar, Canjáyar",
                  type: "ST",
                  id: "A=1@O=Canjayar, Canjáyar@X=-2740775@Y=37009219@U=80@L=777@",
                  extId: "777",
                  lon: -2.740775,
                  lat: 37.009219,
                  time: "09:40:00",
                  date: "2024-11-13",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Alcora",
                  description: "Canjáyar",
                  type: "ADR",
                  id: "A=2@O=Calle Alcora@X=-2738851@Y=36998971@U=100@b=980171501@",
                  lon: -2.738851,
                  lat: 36.998971,
                  time: "09:44:00",
                  date: "2024-11-13",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Canjayar, Canjáyar@L=777@a=128@|A=2@O=Calle Alcora@X=-2738851@Y=36998971@b=980171501@a=128@|13112024|94000|94400|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@0@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-2:003",
                idx: 3,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT4M",
                dist: 1528,
                GisRoute: {
                  dist: 1528,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
      ],
    },
  };
}

export function getTripMockExample() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:15:00",
            date: "2023-01-26",
            mcp: true,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:19:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.501595,
            type: "IMT",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "900",
                          },
                          {
                            name: "estimateHigh",
                            value: "900",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 900,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2250",
                          },
                          {
                            name: "estimateHigh",
                            value: "2250",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 2250,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1350",
                          },
                          {
                            name: "estimateHigh",
                            value: "1350",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1350,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2501",
                          },
                          {
                            name: "estimateHigh",
                            value: "2501",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 2501,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2728",
                          },
                          {
                            name: "estimateHigh",
                            value: "2728",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:OTFkNmNiZWEtMDllMC00MzVkLTlkODctMDM5NWU0Y2MzY2M1O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "3",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "91d6cbea-09e0-435d-9d87-0395e4cc3cc5",
                          },
                          {
                            name: "FLEET_NAME",
                            value:
                              "Will Always Decline After Acc (Robot Fleet)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/bea1240a-c4b7-4746-8353-83a253042c2e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6T1RGa05tTmlaV0V0TURsbE1DMDBNelZrTFRsa09EY3RNRE01TldVMFkyTXpZMk0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUMVJHYTA1dFRtbGFWMFYwVFVSc2JFMURNREJOZWxaclRGUnNhMDlFWTNSTlJFMDFUbGRWTUZreVRYcFpNazB4VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Will Always Decline After Acc (Robot Fleet)",
                        price: 2728,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6T1RGa05tTmlaV0V0TURsbE1DMDBNelZrTFRsa09EY3RNRE01TldVMFkyTXpZMk0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1170",
                          },
                          {
                            name: "estimateHigh",
                            value: "1170",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "1",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1170,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1046",
                          },
                          {
                            name: "estimateHigh",
                            value: "1046",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "2",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1046,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1240",
                          },
                          {
                            name: "estimateHigh",
                            value: "1240",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Taxi",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1240,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1800",
                          },
                          {
                            name: "estimateHigh",
                            value: "1800",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2228",
                          },
                          {
                            name: "estimateHigh",
                            value: "2228",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2V4ZWN1dGl2ZTtzdGFuZGFyZDtsdXh1cnk=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYzJSWWFERmpibXM5SWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2228,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1591",
                          },
                          {
                            name: "estimateHigh",
                            value: "1591",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2340",
                          },
                          {
                            name: "estimateHigh",
                            value: "2340",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2340,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "352",
                          },
                          {
                            name: "estimateHigh",
                            value: "352",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:NmFjZWU3NjctYzU5Zi00MTU5LWE4OWItMjlhMTY0YmY1Y2Q3O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Delayed Allocation Fleet (Robot Fleet GB)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://karhoo.com/fleettcs/6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUbTFHYWxwWFZUTk9hbU4wV1hwVk5WcHBNREJOVkZVMVRGZEZORTlYU1hSTmFteG9UVlJaTUZsdFdURlpNbEV6VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Delayed Allocation Fleet (Robot Fleet GB)",
                        price: 352,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "600",
                          },
                          {
                            name: "estimateHigh",
                            value: "600",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "2",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Taxi",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 600,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2700",
                          },
                          {
                            name: "estimateHigh",
                            value: "2700",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O21wdjttcHY7Y2hpbGQtc2VhdA==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpJeGQyUnFkSFJqU0ZrM1dUSm9jR0pIVVhSak1sWm9aRUU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2700,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2591",
                          },
                          {
                            name: "estimateHigh",
                            value: "2591",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1364",
                          },
                          {
                            name: "estimateHigh",
                            value: "1364",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1364,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1710",
                          },
                          {
                            name: "estimateHigh",
                            value: "1710",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1710,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1800",
                          },
                          {
                            name: "estimateHigh",
                            value: "1800",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Karhoo Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Karhoo Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261315$202301261319$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDEtMjYiLCJyVGltZSI6IjEzOjE1IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9UQVhJIn0=",
          duration: "PT4M",
          checksum: "50c293c4_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:15:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:19:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|131500|131900|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Karhoo",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Karhoo",
                type: "TAXI",
                duration: "PT4M",
                dist: 2333,
                GisRoute: {
                  Notes: {
                    Note: [
                      {
                        value:
                          "Desgraciadamente, este viaje no está disponible. Rogamos buscar conexiones alternativas.",
                        key: "text.connection.section.show.with.info.UNKNOWN",
                        type: "I",
                        txtN: "Desgraciadamente, este viaje no está disponible. Rogamos buscar conexiones alternativas.",
                      },
                    ],
                  },
                  dist: 2333,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:15:00",
            date: "2023-01-26",
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:30:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.01098,
            type: "IMT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "REQUIRED",
                          },
                          {
                            name: "TARIFF_INFO",
                            value:
                              "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6InZfM25nejlrazFleDZudjI3MmQ2NGgiLCJuYW1lIjoia2lja19zY29vdGVyIHRhcmlmZiIsImN1cnJlbmN5IjoiRVVSIiwiYmFzZUNvc3QiOiIwLjAwIiwiY29zdFBlclNlY29uZCI6W3siYW1vdW50IjoiMC4wNSIsInJhbmdlIjp7fSwiaW50ZXJ2YWwiOjYwfV19XX0=",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVieS1lc2Nvb3RlciIsInZlcnNpb24iOiIxLjEyIiwidmVoaWNsZUlkIjoidl8zbmd6OWtrMWV4Nm52MjcyZDY0aCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "reby-escooter",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Reby eScooter",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WaWVTMWxjMk52YjNSbGNpSXNJblpsY25OcGIyNGlPaUl4TGpFeUlpd2lkbVZvYVdOc1pVbGtJam9pZGw4emJtZDZPV3RyTVdWNE5tNTJNamN5WkRZMGFDSjk=",
                          provider: "reby-escooter",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "kick_scooter tariff",
                        price: 60,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVieS1lc2Nvb3RlciIsInZlcnNpb24iOiIxLjEyIiwidmVoaWNsZUlkIjoidl8zbmd6OWtrMWV4Nm52MjcyZDY0aCJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Reby eScooter",
                  },
                  {
                    name: "secId",
                    value: "C-0:001",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:001",
                  },
                  {
                    name: "secIds",
                    value: "C-0:001",
                  },
                ],
                name: "Reby eScooter",
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@F$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@a=128@$202301261315$202301261318$$$1$$$$$$§G@B$A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261318$202301261330$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDEtMjYiLCJyVGltZSI6IjEzOjE1IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSIn0=",
          duration: "PT15M",
          checksum: "27847e7d_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:15:00",
                  date: "2023-01-26",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "kick_scooter",
                        key: "VEHICLE_TYPE",
                        type: "W",
                        txtN: "kick_scooter",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "reby-escooter",
                    },
                    {
                      name: "providerName",
                      value: "Reby eScooter",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "reby-escooter:bookee_v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "externalId",
                      value: "v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Barcelona, 10 Vinos.Com",
                  type: "MCP",
                  id: "A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h@S=2@",
                  extId:
                    "%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h",
                  lon: 2.175956,
                  lat: 41.405447,
                  time: "13:18:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@|26012023|131500|131800|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 229,
                GisRoute: {
                  dist: 229,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "kick_scooter",
                        key: "VEHICLE_TYPE",
                        type: "W",
                        txtN: "kick_scooter",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "reby-escooter",
                    },
                    {
                      name: "providerName",
                      value: "Reby eScooter",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "reby-escooter:bookee_v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "externalId",
                      value: "v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Barcelona, 10 Vinos.Com",
                  type: "MCP",
                  id: "A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h@S=2@",
                  extId:
                    "%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h",
                  lon: 2.175956,
                  lat: 41.405447,
                  time: "13:18:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:30:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@B|A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=JTIzbWNwJTNBViUzQXJlYnktZXNjb290ZXIlM0Fib29rZWVfdl8zbmd6OWtrMWV4Nm52MjcyZDY0aA==@S=2@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|131800|133000|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 97,
                        g: 62,
                        b: 234,
                        hex: "#613EEA",
                      },
                      res: "prod_reby",
                    },
                    name: "Reby eScooter",
                    internalName: "Reby eScooter",
                  },
                ],
                id: "C-0:001",
                idx: 1,
                name: "Reby eScooter",
                type: "BIKE",
                duration: "PT12M",
                dist: 2678,
                GisRoute: {
                  dist: 2678,
                  durS: "PT12M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:17:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:30:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.090214,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-0:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
            unsharp: true,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$202301261317$202301261322$TMB   L2$$1$$$$$$§W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261322$202301261326$$$1$$$$$$§G@F$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261326$202301261330$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT13M",
          rtDuration: "PT13M",
          checksum: "3f474102_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:17:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:22:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4670",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 14,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:17:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:18:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                id: "C-0:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT5M",
                dist: 2098,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  time: "13:22:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:30:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261322$202301261326$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Metro Pg de Gràcia, Barcelona@X=2167524@Y=41389923@U=80@L=100002429@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|132600|133000|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:002&001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 290,
                GisRoute: {
                  dist: 290,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:17:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:32:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.136052,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-1:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-1:000 C-1:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Universitat, Barcelona@L=100000038@a=128@$202301261317$202301261323$TMB   L2$$1$$$$$$§W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261323$202301261324$$$1$$$$$$§T$A=1@O=Universitat, Barcelona@L=100000020@a=128@$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$202301261324$202301261325$TMB   L1$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261325$202301261329$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261329$202301261332$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT15M",
          rtDuration: "PT15M",
          checksum: "f7e51e25_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:17:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:23:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4670",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 15,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:17:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:18:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      depTime: "13:22:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                      extId: "100000038",
                      routeIdx: 15,
                      lon: 2.16391,
                      lat: 41.384772,
                      arrTime: "13:23:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                id: "C-1:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT6M",
                dist: 2729,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                    {
                      order: 4,
                      lon: 2.16391,
                      lat: 41.384772,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  time: "13:23:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261323$202301261324$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 120,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.16391, 41.384772, 2.164288, 41.385815],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 120,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:25:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37094#TA#3#DA#260123#1S#100000001#1T#1302#LS#100000035#LT#1348#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1302#TO#100000035#TT#1348#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 206,
                        g: 17,
                        b: 38,
                        hex: "#CE1126",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L1",
                    internalName: "TMB   L1",
                    displayNumber: "L1",
                    num: "1173",
                    line: "L1",
                    lineId: "1.1.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 14,
                    routeIdxTo: 15,
                    matchId: "L1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                      extId: "100000020",
                      routeIdx: 14,
                      lon: 2.164288,
                      lat: 41.385815,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                      depDir: "Fondo",
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                      extId: "60000021",
                      routeIdx: 15,
                      lon: 2.168998,
                      lat: 41.387487,
                      arrTime: "13:25:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37094#TA#3#DA#260123#1S#100000001#1T#1302#LS#100000035#LT#1348#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1302#TO#100000035#TT#1348#",
                },
                id: "C-1:002",
                idx: 2,
                name: "TMB L1",
                number: "L1",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Fondo",
                directionFlag: "0",
                duration: "PT1M",
                dist: 435,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.164288,
                      lat: 41.385815,
                    },
                    {
                      order: 1,
                      lon: 2.168998,
                      lat: 41.387487,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  time: "13:25:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:32:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261325$202301261329$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|132900|133200|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT7M",
                dist: 186,
                GisRoute: {
                  dist: 186,
                  durS: "PT7M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
            extId: "100000116",
            lon: 2.173619,
            lat: 41.403838,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:18:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:35:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.128269,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.321685,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-2:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-2:000 C-2:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000116@a=128@$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$202301261318$202301261320$TMB   L5$$1$$$$$$§W$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$202301261320$202301261321$$$1$$$$$$§T$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$202301261324$202301261327$TMB   L3$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261327$202301261332$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261332$202301261335$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT17M",
          rtDuration: "PT17M",
          checksum: "6c37cb62_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
                  extId: "100000116",
                  lon: 2.173619,
                  lat: 41.403838,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:18:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                  extId: "100000114",
                  lon: 2.158831,
                  lat: 41.394436,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "13:20:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#36305#TA#1#DA#260123#1S#100000127#1T#1258#LS#30000102#LT#1341#PU#80#RT#1#CA#TMB#ZE#L5#ZB#TMB   L5#PC#6#FR#100000127#FT#1258#TO#30000102#TT#1341#",
                },
                Freq: {
                  waitMinimum: 3,
                  waitMaximum: 4,
                  alternativeCount: 37,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 90,
                        b: 151,
                        hex: "#005A97",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L5",
                    internalName: "TMB   L5",
                    displayNumber: "L5",
                    num: "8708",
                    line: "L5",
                    lineId: "1.5.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "L5",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
                      extId: "100000116",
                      routeIdx: 11,
                      lon: 2.173619,
                      lat: 41.403838,
                      depTime: "13:18:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Cornellà Centre",
                    },
                    {
                      name: "Verdaguer, Barcelona",
                      id: "A=1@O=Verdaguer, Barcelona@X=2167092@Y=41398948@U=80@L=100000115@",
                      extId: "100000115",
                      routeIdx: 12,
                      lon: 2.167092,
                      lat: 41.398948,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:19:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Verdaguer, Barcelona@X=2168063@Y=41400369@U=80@L=100003224@",
                      mainMastExtId: "100003224",
                      mainMastLon: 2.168063,
                      mainMastLat: 41.400369,
                    },
                    {
                      name: "Diagonal, Barcelona",
                      id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                      extId: "100000114",
                      routeIdx: 13,
                      lon: 2.158831,
                      lat: 41.394436,
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                      mainMastExtId: "100003201",
                      mainMastLon: 2.160045,
                      mainMastLat: 41.395892,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#36305#TA#1#DA#260123#1S#100000127#1T#1258#LS#30000102#LT#1341#PU#80#RT#1#CA#TMB#ZE#L5#ZB#TMB   L5#PC#6#FR#100000127#FT#1258#TO#30000102#TT#1341#",
                },
                id: "C-2:000",
                idx: 0,
                name: "TMB L5",
                number: "L5",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Cornellà Centre",
                directionFlag: "1",
                duration: "PT2M",
                dist: 1623,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.173619,
                      lat: 41.403838,
                    },
                    {
                      order: 1,
                      lon: 2.167092,
                      lat: 41.398948,
                    },
                    {
                      order: 2,
                      lon: 2.158831,
                      lat: 41.394436,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                  extId: "100000114",
                  lon: 2.158831,
                  lat: 41.394436,
                  time: "13:20:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                Destination: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                  extId: "100000068",
                  lon: 2.160045,
                  lat: 41.395892,
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$202301261320$202301261321$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 191,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.158831, 41.394436, 2.160045, 41.395892],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 191,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                  extId: "100000068",
                  lon: 2.160045,
                  lat: 41.395892,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                  extId: "30000066",
                  lon: 2.170095,
                  lat: 41.386318,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#33791#TA#0#DA#260123#1S#100000079#1T#1304#LS#100000054#LT#1346#PU#80#RT#1#CA#TMB#ZE#L3#ZB#TMB   L3#PC#6#FR#100000079#FT#1304#TO#100000054#TT#1346#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 27,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 30,
                        g: 181,
                        b: 58,
                        hex: "#1EB53A",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L3",
                    internalName: "TMB   L3",
                    displayNumber: "L3",
                    num: "5894",
                    line: "L3",
                    lineId: "1.3.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "L3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Diagonal, Barcelona",
                      id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                      extId: "100000068",
                      routeIdx: 11,
                      lon: 2.160045,
                      lat: 41.395892,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                      mainMastExtId: "100003201",
                      mainMastLon: 2.160045,
                      mainMastLat: 41.395892,
                      depDir: "Zona Universitària",
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2165349@Y=41391604@U=80@L=30000067@",
                      extId: "30000067",
                      routeIdx: 12,
                      lon: 2.165349,
                      lat: 41.391604,
                      depTime: "13:26:00",
                      depDate: "2023-01-26",
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                      extId: "30000066",
                      routeIdx: 13,
                      lon: 2.170095,
                      lat: 41.386318,
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#33791#TA#0#DA#260123#1S#100000079#1T#1304#LS#100000054#LT#1346#PU#80#RT#1#CA#TMB#ZE#L3#ZB#TMB   L3#PC#6#FR#100000079#FT#1304#TO#100000054#TT#1346#",
                },
                id: "C-2:002",
                idx: 2,
                name: "TMB L3",
                number: "L3",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Zona Universitària",
                directionFlag: "1",
                duration: "PT3M",
                dist: 1360,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.160045,
                      lat: 41.395892,
                    },
                    {
                      order: 1,
                      lon: 2.165349,
                      lat: 41.391604,
                    },
                    {
                      order: 2,
                      lon: 2.170095,
                      lat: 41.386318,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                  extId: "30000066",
                  lon: 2.170095,
                  lat: 41.386318,
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:35:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261327$202301261332$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133200|133500|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 336,
                GisRoute: {
                  dist: 336,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:18:00",
            date: "2023-01-26",
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:42:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.220088,
            type: "PUT",
            rating: 2,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 8,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-3:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:001",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-3:001",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 3,
          tripId: "C-3",
          ctxRecon:
            "¶HKI¶G@F$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=1@O=Mallorca - Marina, Barcelona@L=100000396@a=128@$202301261318$202301261320$$$1$$$$$$§T$A=1@O=Mallorca - Marina, Barcelona@L=100000396@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261320$202301261339$TMB  D50$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261339$202301261342$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT24M",
          rtDuration: "PT24M",
          checksum: "b1cf2a3c_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:18:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Mallorca - Marina, Barcelona",
                  type: "ST",
                  id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                  extId: "100000396",
                  lon: 2.175938,
                  lat: 41.403955,
                  time: "13:20:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@|26012023|131800|132000|bf|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT2M",
                dist: 81,
                GisRoute: {
                  dist: 81,
                  durS: "PT2M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Mallorca - Marina, Barcelona",
                  type: "ST",
                  id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                  extId: "100000396",
                  lon: 2.175938,
                  lat: 41.403955,
                  routeIdx: 29,
                  prognosisType: "PROGNOSED",
                  time: "13:20:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                  extId: "800000330",
                  lon: 2.169313,
                  lat: 41.387757,
                  routeIdx: 37,
                  prognosisType: "PROGNOSED",
                  time: "13:39:00",
                  date: "2023-01-26",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#24400#TA#1#DA#260123#1S#100000634#1T#1236#LS#100002183#LT#1353#PU#80#RT#1#CA#TMB#ZE#D50#ZB#TMB  D50#PC#8#FR#100000634#FT#1236#TO#100002183#TT#1353#",
                },
                Freq: {
                  waitMinimum: 8,
                  waitMaximum: 10,
                  alternativeCount: 14,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 16,
                        b: 126,
                        hex: "#93107E",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB D50",
                    internalName: "TMB  D50",
                    displayNumber: "D50",
                    num: "34241",
                    line: "D50",
                    lineId: "2.250.3051(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "8",
                    cls: "256",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 29,
                    routeIdxTo: 37,
                    matchId: "D50",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Mallorca - Marina, Barcelona",
                      id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                      extId: "100000396",
                      routeIdx: 29,
                      lon: 2.175938,
                      lat: 41.403955,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Mallorca - Nàpols, Barcelona",
                      id: "A=1@O=Mallorca - Nàpols, Barcelona@X=2172351@Y=41401276@U=80@L=100001876@",
                      extId: "100001876",
                      routeIdx: 30,
                      lon: 2.172351,
                      lat: 41.401276,
                      depTime: "13:22:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de Sant Joan - Pl Mossèn Jacint Verdaguer, Barc",
                      id: "A=1@O=Pg de Sant Joan - Pl Mossèn Jacint Verdaguer, Barc@X=2170427@Y=41398625@U=80@L=100000554@",
                      extId: "100000554",
                      routeIdx: 31,
                      lon: 2.170427,
                      lat: 41.398625,
                      depTime: "13:25:00",
                      depDate: "2023-01-26",
                      arrTime: "13:25:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg Sant Joan - Consell de Cent, Barcelona",
                      id: "A=1@O=Pg Sant Joan - Consell de Cent, Barcelona@X=2172522@Y=41397043@U=80@L=100001921@",
                      extId: "100001921",
                      routeIdx: 32,
                      lon: 2.172522,
                      lat: 41.397043,
                      depTime: "13:27:00",
                      depDate: "2023-01-26",
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de Sant Joan - Diputació, Barcelona",
                      id: "A=1@O=Pg de Sant Joan - Diputació, Barcelona@X=2174670@Y=41395416@U=80@L=100001738@",
                      extId: "100001738",
                      routeIdx: 33,
                      lon: 2.17467,
                      lat: 41.395416,
                      depTime: "13:28:00",
                      depDate: "2023-01-26",
                      arrTime: "13:28:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de St Joan - Ausiàs March, Barcelona",
                      id: "A=1@O=Pg de St Joan - Ausiàs March, Barcelona@X=2178680@Y=41392404@U=80@L=800001800@",
                      extId: "800001800",
                      routeIdx: 34,
                      lon: 2.17868,
                      lat: 41.392404,
                      depTime: "13:32:00",
                      depDate: "2023-01-26",
                      arrTime: "13:32:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Ronda Sant Pere - Girona, Barcelona",
                      id: "A=1@O=Ronda Sant Pere - Girona, Barcelona@X=2175965@Y=41390247@U=80@L=100000542@",
                      extId: "100000542",
                      routeIdx: 35,
                      lon: 2.175965,
                      lat: 41.390247,
                      depTime: "13:34:00",
                      depDate: "2023-01-26",
                      arrTime: "13:34:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Metro Urquinaona, Barcelona",
                      id: "A=1@O=Metro Urquinaona, Barcelona@X=2172783@Y=41389024@U=80@L=100000221@",
                      extId: "100000221",
                      routeIdx: 36,
                      lon: 2.172783,
                      lat: 41.389024,
                      depTime: "13:36:00",
                      depDate: "2023-01-26",
                      arrTime: "13:36:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                      id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                      extId: "800000330",
                      routeIdx: 37,
                      lon: 2.169313,
                      lat: 41.387757,
                      arrTime: "13:39:00",
                      arrDate: "2023-01-26",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#24400#TA#1#DA#260123#1S#100000634#1T#1236#LS#100002183#LT#1353#PU#80#RT#1#CA#TMB#ZE#D50#ZB#TMB  D50#PC#8#FR#100000634#FT#1236#TO#100002183#TT#1353#",
                },
                id: "C-3:001",
                idx: 1,
                name: "TMB D50",
                number: "D50",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT19M",
                dist: 2684,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175938,
                      lat: 41.403955,
                    },
                    {
                      order: 1,
                      lon: 2.172351,
                      lat: 41.401276,
                    },
                    {
                      order: 2,
                      lon: 2.170427,
                      lat: 41.398625,
                    },
                    {
                      order: 3,
                      lon: 2.172522,
                      lat: 41.397043,
                    },
                    {
                      order: 4,
                      lon: 2.17467,
                      lat: 41.395416,
                    },
                    {
                      order: 5,
                      lon: 2.17868,
                      lat: 41.392404,
                    },
                    {
                      order: 6,
                      lon: 2.175965,
                      lat: 41.390247,
                    },
                    {
                      order: 7,
                      lon: 2.172783,
                      lat: 41.389024,
                    },
                    {
                      order: 8,
                      lon: 2.169313,
                      lat: 41.387757,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                  extId: "800000330",
                  lon: 2.169313,
                  lat: 41.387757,
                  time: "13:39:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:42:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133900|134200|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:002",
                idx: 2,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 146,
                GisRoute: {
                  dist: 146,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:21:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:34:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.090214,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-4:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-4:000",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-4:000",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
            unsharp: true,
          },
          idx: 4,
          tripId: "C-4",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$202301261321$202301261326$TMB   L2$$1$$$$$$§W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261326$202301261330$$$1$$$$$$§G@F$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261330$202301261334$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT13M",
          rtDuration: "PT13M",
          checksum: "411616bc_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:26:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4706",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 14,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:21:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:23:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      arrTime: "13:24:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                id: "C-4:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT5M",
                dist: 2098,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  time: "13:26:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:34:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261326$202301261330$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Metro Pg de Gràcia, Barcelona@X=2167524@Y=41389923@U=80@L=100002429@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133000|133400|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-4:002&001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 290,
                GisRoute: {
                  dist: 290,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:21:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:36:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.136052,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-5:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-5:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-5:000 C-5:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 5,
          tripId: "C-5",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Universitat, Barcelona@L=100000038@a=128@$202301261321$202301261327$TMB   L2$$1$$$$$$§W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261327$202301261328$$$1$$$$$$§T$A=1@O=Universitat, Barcelona@L=100000020@a=128@$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$202301261328$202301261329$TMB   L1$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261329$202301261333$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261333$202301261336$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT15M",
          rtDuration: "PT15M",
          checksum: "2299c4a7_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4706",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 15,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:21:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:23:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      arrTime: "13:24:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      depTime: "13:26:00",
                      depDate: "2023-01-26",
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                      extId: "100000038",
                      routeIdx: 15,
                      lon: 2.16391,
                      lat: 41.384772,
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                id: "C-5:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT6M",
                dist: 2729,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                    {
                      order: 4,
                      lon: 2.16391,
                      lat: 41.384772,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  time: "13:28:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261327$202301261328$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-5:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 120,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.16391, 41.384772, 2.164288, 41.385815],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 120,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:28:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:29:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37264#TA#3#DA#260123#1S#100000001#1T#1307#LS#100000035#LT#1352#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1307#TO#100000035#TT#1352#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 206,
                        g: 17,
                        b: 38,
                        hex: "#CE1126",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L1",
                    internalName: "TMB   L1",
                    displayNumber: "L1",
                    num: "1191",
                    line: "L1",
                    lineId: "1.1.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 14,
                    routeIdxTo: 15,
                    matchId: "L1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                      extId: "100000020",
                      routeIdx: 14,
                      lon: 2.164288,
                      lat: 41.385815,
                      depTime: "13:28:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                      depDir: "Fondo",
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                      extId: "60000021",
                      routeIdx: 15,
                      lon: 2.168998,
                      lat: 41.387487,
                      arrTime: "13:29:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37264#TA#3#DA#260123#1S#100000001#1T#1307#LS#100000035#LT#1352#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1307#TO#100000035#TT#1352#",
                },
                id: "C-5:002",
                idx: 2,
                name: "TMB L1",
                number: "L1",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Fondo",
                directionFlag: "0",
                duration: "PT1M",
                dist: 435,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.164288,
                      lat: 41.385815,
                    },
                    {
                      order: 1,
                      lon: 2.168998,
                      lat: 41.387487,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  time: "13:29:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:36:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261329$202301261333$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133300|133600|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-5:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT7M",
                dist: 186,
                GisRoute: {
                  dist: 186,
                  durS: "PT7M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
      ],
    },
  };
}

// NO OPERADOS POR RENFE
export function getFerrocarrilesBarcelona() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            mcpData: [
              { name: "provider", value: "taxi" },
              { name: "providerName", value: "Taxi" },
              { name: "availability", value: "A" },
              { name: "mcpId", value: "taxi:transient" },
              { name: "externalId", value: "transient" },
              { name: "mcpType", value: "V" },
            ],
            name: "Muntaner, Barcelona",
            type: "ST",
            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
            extId: "30000044",
            lon: 2.142345,
            lat: 41.398526,
            time: "10:38:00",
            date: "2023-03-29",
            mcp: true,
          },
          Destination: {
            name: "Gràcia, Barcelona",
            type: "ST",
            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
            extId: "50000026",
            lon: 2.152665,
            lat: 41.399101,
            time: "10:40:00",
            date: "2023-03-29",
          },
          Eco: { co2: 0.24381, type: "IMT", rating: 0 },
          EcoCmp: [{ co2: 0.160701, type: "BEE" }],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2700" },
                          { name: "estimateHigh", value: "2700" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O21wdjttcHY7Y2hpbGQtc2VhdA==",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "6" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "MPV" },
                          { name: "VEHICLE_TYPE", value: "MPV" },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpJeGQyUnFkSFJqU0ZrM1dUSm9jR0pIVVhSak1sWm9aRUU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURNdE1qSlVNVEU2TVRZNk5USXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2700,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1240" },
                          { name: "estimateHigh", value: "1240" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Taxi" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURNdE1qSlVNVEU2TVRZNk5USXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1240,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "600" },
                          { name: "estimateHigh", value: "600" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "2" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Taxi" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURNdE1qSlVNVEU2TVRZNk5USXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 600,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "900" },
                          { name: "estimateHigh", value: "900" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Electric" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TXkweU1sUXhNVG94TmpvMU1pc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 900,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1170" },
                          { name: "estimateHigh", value: "1170" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "1" },
                          { name: "VEHICLE_CLASS", value: "Electric" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TXkweU1sUXhNVG94TmpvMU1pc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1170,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2228" },
                          { name: "estimateHigh", value: "2228" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2V4ZWN1dGl2ZTtzdGFuZGFyZDtsdXh1cnk=",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Exec" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYzJSWWFERmpibXM5SWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TXkweU1sUXhNVG94TmpvMU1pc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2228,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1350" },
                          { name: "estimateHigh", value: "1350" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Saloon" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNeTB5TWxReE1Ub3hOam8xTWlzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1350,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "352" },
                          { name: "estimateHigh", value: "352" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:NmFjZWU3NjctYzU5Zi00MTU5LWE4OWItMjlhMTY0YmY1Y2Q3O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Saloon" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Delayed Allocation Fleet (Robot Fleet GB)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://karhoo.com/fleettcs/6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZUbTFHYWxwWFZUTk9hbU4wV1hwVk5WcHBNREJOVkZVMVRGZEZORTlYU1hSTmFteG9UVlJaTUZsdFdURlpNbEV6VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNeTB5TWxReE1Ub3hOam8xTWlzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Delayed Allocation Fleet (Robot Fleet GB)",
                        price: 352,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2591" },
                          { name: "estimateHigh", value: "2591" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO21wdjttcHY7",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "6" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "MPV" },
                          { name: "VEHICLE_TYPE", value: "MPV" },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd015MHlNbFF4TVRveE5qbzFNaXN3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1800" },
                          { name: "estimateHigh", value: "1800" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Exec" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ETXRNakpVTVRFNk1UWTZOVElyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1364" },
                          { name: "estimateHigh", value: "1364" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Saloon" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNeTB5TWxReE1Ub3hOam8xTWlzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1364,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1710" },
                          { name: "estimateHigh", value: "1710" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Saloon" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNeTB5TWxReE1Ub3hOam8xTWlzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1710,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2250" },
                          { name: "estimateHigh", value: "2250" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO21wdjttcHY7",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "6" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "MPV" },
                          { name: "VEHICLE_TYPE", value: "MPV" },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd015MHlNbFF4TVRveE5qbzFNaXN3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 2250,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1591" },
                          { name: "estimateHigh", value: "1591" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "4" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Saloon" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNeTB5TWxReE1Ub3hOam8xTWlzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2501" },
                          { name: "estimateHigh", value: "2501" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO21wdjttcHY7",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "6" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "MPV" },
                          { name: "VEHICLE_TYPE", value: "MPV" },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd015MHlNbFF4TVRveE5qbzFNaXN3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 2501,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1046" },
                          { name: "estimateHigh", value: "1046" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          { name: "OFFER_TYPE", value: "METERED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "2" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Electric" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TXkweU1sUXhNVG94TmpvMU1pc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1046,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMy0yMlQxMToxNjo1MiswMTowMCJ9",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "2340" },
                          { name: "estimateHigh", value: "2340" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Exec" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ETXRNakpVTVRFNk1UWTZOVElyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2340,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "estimateLow", value: "1800" },
                          { name: "estimateHigh", value: "1800" },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "44a636e1-c899-11ed-8c11-16d0f995ae38:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          { name: "OFFER_TYPE", value: "FIXED" },
                          { name: "PICKUP_TYPE", value: "DEFAULT" },
                          { name: "AVAILABLE_SEATS", value: "3" },
                          { name: "LUGGAGE_CAPACITY", value: "2" },
                          { name: "VEHICLE_CLASS", value: "Exec" },
                          { name: "VEHICLE_TYPE", value: "STANDARD" },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpRMFlUWXpObVV4TFdNNE9Ua3RNVEZsWkMwNFl6RXhMVEUyWkRCbU9UazFZV1V6T0NJc0luRjFiM1JsU1dRaU9pSTBOR0UyTXpabE1TMWpPRGs1TFRFeFpXUXRPR014TVMweE5tUXdaams1TldGbE16ZzZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ETXRNakpVTVRFNk1UWTZOVElyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjQ0YTYzNmUxLWM4OTktMTFlZC04YzExLTE2ZDBmOTk1YWUzOCIsInF1b3RlSWQiOiI0NGE2MzZlMS1jODk5LTExZWQtOGMxMS0xNmQwZjk5NWFlMzg6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDMtMjJUMTE6MTY6NTIrMDE6MDAifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  { name: "NAME", value: "Karhoo Pricing" },
                  { name: "secId", value: "C-0:000" },
                  { name: "secIdEnd", value: "C-0:000" },
                  { name: "secIds", value: "C-0:000" },
                ],
                name: "Karhoo Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: { hintCode: 0 },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=1@O=Muntaner, Barcelona@L=30000044@a=128@$A=1@O=Gràcia, Barcelona@L=50000026@a=128@$202303291038$202303291040$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDMtMjkiLCJyVGltZSI6IjEwOjM4IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9UQVhJIn0=",
          duration: "PT2M",
          checksum: "6fb9e038_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  mcpData: [
                    { name: "provider", value: "taxi" },
                    { name: "providerName", value: "Taxi" },
                    { name: "availability", value: "A" },
                    { name: "mcpId", value: "taxi:transient" },
                    { name: "externalId", value: "transient" },
                    { name: "mcpType", value: "V" },
                  ],
                  name: "Muntaner, Barcelona",
                  type: "ST",
                  id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                  extId: "30000044",
                  lon: 2.142345,
                  lat: 41.398526,
                  time: "10:38:00",
                  date: "2023-03-29",
                  mcp: true,
                },
                Destination: {
                  name: "Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                  extId: "50000026",
                  lon: 2.152665,
                  lat: 41.399101,
                  time: "10:40:00",
                  date: "2023-03-29",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@|A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@|29032023|103800|104000|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: { r: 105, g: 3, b: 194, hex: "#6903C2" },
                      res: "prod_taxi",
                    },
                    name: "Karhoo",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Karhoo",
                type: "TAXI",
                duration: "PT2M",
                dist: 1134,
                GisRoute: { dist: 1134, durS: "PT2M", dirGeo: 0 },
              },
            ],
          },
        },
        {
          Origin: {
            mcpData: [
              { name: "provider", value: "taxi" },
              { name: "providerName", value: "Taxi" },
              { name: "availability", value: "A" },
              { name: "mcpId", value: "taxi:transient" },
              { name: "externalId", value: "transient" },
              { name: "mcpType", value: "V" },
            ],
            name: "Muntaner, Barcelona",
            type: "ST",
            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
            extId: "30000044",
            lon: 2.142345,
            lat: 41.398526,
            time: "10:38:00",
            date: "2023-03-29",
            mcp: true,
          },
          Destination: {
            name: "Gràcia, Barcelona",
            type: "ST",
            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
            extId: "50000026",
            lon: 2.152665,
            lat: 41.399101,
            time: "10:40:00",
            date: "2023-03-29",
          },
          Eco: { co2: 0.24381, type: "IMT", rating: 0 },
          EcoCmp: [{ co2: 0.160701, type: "BEE" }],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          { name: "STATUS", value: "AVAILABLE" },
                          { name: "VEHICLE_TYPE", value: "4" },
                          { name: "VEHICLE_CLASS", value: "Standard" },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMyIsImJ1ZGdldElkIjoiMzc5NWFkNjQtZDgxNS00YzlhLWJmNzMtNmZhMGM3MDg1MjljIiwicHJpY2UiOjUuMzc2NiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          { name: "PROVIDER_ID", value: "taxi" },
                          { name: "PROVIDER_NAME", value: "Taxi" },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHhNeUlzSW1KMVpHZGxkRWxrSWpvaU16YzVOV0ZrTmpRdFpEZ3hOUzAwWXpsaExXSm1Oek10Tm1aaE1HTTNNRGcxTWpsaklpd2ljSEpwWTJVaU9qVXVNemMyTml3aVkzVnljbVZ1WTNraU9pSkZWVklpZlE9PQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 538,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMyIsImJ1ZGdldElkIjoiMzc5NWFkNjQtZDgxNS00YzlhLWJmNzMtNmZhMGM3MDg1MjljIiwicHJpY2UiOjUuMzc2NiwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  { name: "NAME", value: "Movitaxi Pricing" },
                  { name: "secId", value: "C-0:000" },
                  { name: "secIdEnd", value: "C-0:000" },
                  { name: "secIds", value: "C-0:000" },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: { hintCode: 0 },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=1@O=Muntaner, Barcelona@L=30000044@a=128@$A=1@O=Gràcia, Barcelona@L=50000026@a=128@$202303291038$202303291040$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDMtMjkiLCJyVGltZSI6IjEwOjM4IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9UQVhJIn0=",
          duration: "PT2M",
          checksum: "6fb9e038_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  mcpData: [
                    { name: "provider", value: "taxi" },
                    { name: "providerName", value: "Taxi" },
                    { name: "availability", value: "A" },
                    { name: "mcpId", value: "taxi:transient" },
                    { name: "externalId", value: "transient" },
                    { name: "mcpType", value: "V" },
                  ],
                  name: "Muntaner, Barcelona",
                  type: "ST",
                  id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                  extId: "30000044",
                  lon: 2.142345,
                  lat: 41.398526,
                  time: "10:38:00",
                  date: "2023-03-29",
                  mcp: true,
                },
                Destination: {
                  name: "Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                  extId: "50000026",
                  lon: 2.152665,
                  lat: 41.399101,
                  time: "10:40:00",
                  date: "2023-03-29",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@|A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@|29032023|103800|104000|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: { r: 105, g: 3, b: 194, hex: "#6903C2" },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT2M",
                dist: 1134,
                GisRoute: { dist: 1134, durS: "PT2M", dirGeo: 0 },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Muntaner, Barcelona",
            type: "ST",
            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
            extId: "30000044",
            lon: 2.142345,
            lat: 41.398526,
            routeIdx: 3,
            prognosisType: "PROGNOSED",
            time: "10:39:00",
            date: "2023-03-29",
          },
          Destination: {
            name: "Gràcia, Barcelona",
            type: "ST",
            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
            extId: "50000026",
            lon: 2.152665,
            lat: 41.399101,
            routeIdx: 5,
            prognosisType: "PROGNOSED",
            time: "10:41:00",
            date: "2023-03-29",
          },
          Eco: { co2: 0.044677, type: "PUT", rating: 3 },
          EcoCmp: [{ co2: 0.160701, type: "BEE" }],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-02-05",
              planningPeriodEnd: "2023-12-02",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 7., 10. Abr, 1. May, 5. Jun, 1. hasta 31. Ago 2023, 11., 25. Sep, 12. Oct, 1. Nov",
              sDaysB:
                "7CF9F3E7CF9F3E7879F3E3CF9F3E7C79F3E7CF9F3E7C800000009F1E7C79F3A7CF9B3E7CF9F0",
            },
          ],
          Freq: { waitMinimum: 8 },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "Precio depende del número de zonas.",
                          },
                          { name: "PRICE.PREFIX", value: "min." },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [{ name: "hasSamplePrice", value: "1" }],
                  },
                ],
                param: [
                  { name: "Supplier", value: "005_fgc_catal" },
                  { name: "DatasetVersion", value: "2022-1" },
                  { name: "PSetName", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "OrigZone", value: "33" },
                  { name: "DestZone", value: "33" },
                  { name: "PSetDesc", value: "Zona 1-6" },
                  { name: "FirstSectIdx", value: "0" },
                  { name: "secIdStart", value: "C-0:000" },
                  { name: "LastSectIdx", value: "0" },
                  { name: "secIdEnd", value: "C-0:000" },
                  { name: "NAME", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "DESCRIPTION", value: "Zona 1-6" },
                  { name: "TariffURL", value: "fgc.cat/es/billetes/" },
                  { name: "secIds", value: "C-0:000" },
                ],
                name: "Tarifas de FGC - Hay 6 zonas",
                desc: "Zona 1-6",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: { hintCode: 0 },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Muntaner, Barcelona@L=30000044@a=128@$A=1@O=Gràcia, Barcelona@L=50000026@a=128@$202303291039$202303291041$FGC   L6$$1$$$$$$¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT2M",
          rtDuration: "PT2M",
          checksum: "6bdc6cb3_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Muntaner, Barcelona",
                  type: "ST",
                  id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                  extId: "30000044",
                  lon: 2.142345,
                  lat: 41.398526,
                  routeIdx: 3,
                  prognosisType: "PROGNOSED",
                  time: "10:39:00",
                  date: "2023-03-29",
                },
                Destination: {
                  name: "Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                  extId: "50000026",
                  lon: 2.152665,
                  lat: 41.399101,
                  routeIdx: 5,
                  prognosisType: "PROGNOSED",
                  time: "10:41:00",
                  date: "2023-03-29",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2736#TA#0#DA#290323#1S#100000617#1T#1035#LS#10000055#LT#1047#PU#80#RT#1#CA#FGC#ZE#L6#ZB#FGC   L6#PC#6#FR#100000617#FT#1035#TO#10000055#TT#1047#",
                },
                Freq: { waitMinimum: 8, waitMaximum: 12, alternativeCount: 13 },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 121,
                        g: 127,
                        b: 188,
                        hex: "#797FBC",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "FGC",
                      nameS: "FGC",
                      nameN: "FGC",
                      nameL: "FGC",
                    },
                    name: "FGC L6",
                    internalName: "FGC   L6",
                    displayNumber: "L6",
                    num: "3722",
                    line: "L6",
                    lineId: "L6(DEFAULT_AGENCY_gtfs)005",
                    catOut: "FGC",
                    catIn: "FGC",
                    catCode: "6",
                    cls: "64",
                    catOutS: "FGC",
                    catOutL: "FGC",
                    operatorCode: "FGC",
                    operator: "FGC",
                    admin: "005000",
                    routeIdxFrom: 3,
                    routeIdxTo: 5,
                    matchId: "L6",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Muntaner, Barcelona",
                      id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                      extId: "30000044",
                      routeIdx: 3,
                      lon: 2.142345,
                      lat: 41.398526,
                      depTime: "10:39:00",
                      depDate: "2023-03-29",
                      depDir: "Pl. Catalunya",
                    },
                    {
                      name: "Pl Molina, Barcelona",
                      id: "A=1@O=Pl Molina, Barcelona@X=2147379@Y=41401411@U=80@L=100002417@",
                      extId: "100002417",
                      routeIdx: 4,
                      lon: 2.147379,
                      lat: 41.401411,
                      depTime: "10:40:00",
                      depDate: "2023-03-29",
                      arrTime: "10:39:00",
                      arrDate: "2023-03-29",
                    },
                    {
                      name: "Gràcia, Barcelona",
                      id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                      extId: "50000026",
                      routeIdx: 5,
                      lon: 2.152665,
                      lat: 41.399101,
                      arrTime: "10:41:00",
                      arrDate: "2023-03-29",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-03-29",
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2736#TA#0#DA#290323#1S#100000617#1T#1035#LS#10000055#LT#1047#PU#80#RT#1#CA#FGC#ZE#L6#ZB#FGC   L6#PC#6#FR#100000617#FT#1035#TO#10000055#TT#1047#",
                },
                id: "C-0:000",
                idx: 0,
                name: "FGC L6",
                number: "L6",
                category: "FGC",
                type: "JNY",
                reachable: true,
                direction: "Pl. Catalunya",
                directionFlag: "0",
                duration: "PT2M",
                dist: 1039,
                GisRoute: {
                  coordinates: [
                    { order: 0, lon: 2.142345, lat: 41.398526 },
                    { order: 1, lon: 2.147379, lat: 41.401411 },
                    { order: 2, lon: 2.152665, lat: 41.399101 },
                  ],
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Muntaner, Barcelona",
            type: "ST",
            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
            extId: "30000044",
            lon: 2.142345,
            lat: 41.398526,
            routeIdx: 17,
            prognosisType: "PROGNOSED",
            time: "10:41:00",
            date: "2023-03-29",
          },
          Destination: {
            name: "Gràcia, Barcelona",
            type: "ST",
            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
            extId: "50000026",
            lon: 2.152665,
            lat: 41.399101,
            routeIdx: 19,
            prognosisType: "PROGNOSED",
            time: "10:43:00",
            date: "2023-03-29",
          },
          Eco: { co2: 0.037404, type: "PUT", rating: 3 },
          EcoCmp: [{ co2: 0.160701, type: "BEE" }],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-02-05",
              planningPeriodEnd: "2023-12-02",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 7., 10. Abr, 1. May, 5. Jun, 1. hasta 31. Ago 2023, 11., 25. Sep, 12. Oct, 1. Nov",
              sDaysB:
                "7CF9F3E7CF9F3E7879F3E3CF9F3E7C79F3E7CF9F3E7C800000009F1E7C79F3A7CF9B3E7CF9F0",
            },
          ],
          Freq: { waitMinimum: 2 },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "Precio depende del número de zonas.",
                          },
                          { name: "PRICE.PREFIX", value: "min." },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [{ name: "hasSamplePrice", value: "1" }],
                  },
                ],
                param: [
                  { name: "Supplier", value: "005_fgc_catal" },
                  { name: "DatasetVersion", value: "2022-1" },
                  { name: "PSetName", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "OrigZone", value: "33" },
                  { name: "DestZone", value: "33" },
                  { name: "PSetDesc", value: "Zona 1-6" },
                  { name: "FirstSectIdx", value: "0" },
                  { name: "secIdStart", value: "C-1:000" },
                  { name: "LastSectIdx", value: "0" },
                  { name: "secIdEnd", value: "C-1:000" },
                  { name: "NAME", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "DESCRIPTION", value: "Zona 1-6" },
                  { name: "TariffURL", value: "fgc.cat/es/billetes/" },
                  { name: "secIds", value: "C-1:000" },
                ],
                name: "Tarifas de FGC - Hay 6 zonas",
                desc: "Zona 1-6",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: { hintCode: 0 },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶T$A=1@O=Muntaner, Barcelona@L=30000044@a=128@$A=1@O=Gràcia, Barcelona@L=50000026@a=128@$202303291041$202303291043$FGC   S1$$1$$$$$$¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT2M",
          rtDuration: "PT2M",
          checksum: "36428c4e_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Muntaner, Barcelona",
                  type: "ST",
                  id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                  extId: "30000044",
                  lon: 2.142345,
                  lat: 41.398526,
                  routeIdx: 17,
                  prognosisType: "PROGNOSED",
                  time: "10:41:00",
                  date: "2023-03-29",
                },
                Destination: {
                  name: "Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                  extId: "50000026",
                  lon: 2.152665,
                  lat: 41.399101,
                  routeIdx: 19,
                  prognosisType: "PROGNOSED",
                  time: "10:43:00",
                  date: "2023-03-29",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2685#TA#1#DA#290323#1S#400000050#1T#955#LS#10000055#LT#1049#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#955#TO#10000055#TT#1049#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 19,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "10:44:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 21,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "10:46:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#5#DA#290323#1S#500000063#1T#957#LS#10000055#LT#1052#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#957#TO#10000055#TT#1052#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 136,
                            g: 187,
                            b: 11,
                            hex: "#88BB0B",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S2",
                        internalName: "FGC   S2",
                        displayNumber: "S2",
                        num: "3196",
                        line: "S2",
                        lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S2",
                      },
                      name: "FGC S2",
                      direction: "Pl. Catalunya",
                      trainNumber: "S2",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 17,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "10:52:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 19,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "10:54:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2678#TA#10#DA#290323#1S#400000050#1T#1006#LS#10000055#LT#1100#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#1006#TO#10000055#TT#1100#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 239,
                            g: 121,
                            b: 0,
                            hex: "#EF7900",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S1",
                        internalName: "FGC   S1",
                        displayNumber: "S1",
                        num: "3380",
                        line: "S1",
                        lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S1",
                      },
                      name: "FGC S1",
                      direction: "Pl. Catalunya",
                      trainNumber: "S1",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 19,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "10:54:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 21,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "10:56:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#6#DA#290323#1S#500000063#1T#1007#LS#10000055#LT#1102#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#1007#TO#10000055#TT#1102#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 136,
                            g: 187,
                            b: 11,
                            hex: "#88BB0B",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S2",
                        internalName: "FGC   S2",
                        displayNumber: "S2",
                        num: "3194",
                        line: "S2",
                        lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S2",
                      },
                      name: "FGC S2",
                      direction: "Pl. Catalunya",
                      trainNumber: "S2",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 17,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "11:02:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 19,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "11:04:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2683#TA#2#DA#290323#1S#400000050#1T#1016#LS#10000055#LT#1110#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#1016#TO#10000055#TT#1110#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 239,
                            g: 121,
                            b: 0,
                            hex: "#EF7900",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S1",
                        internalName: "FGC   S1",
                        displayNumber: "S1",
                        num: "3384",
                        line: "S1",
                        lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S1",
                      },
                      name: "FGC S1",
                      direction: "Pl. Catalunya",
                      trainNumber: "S1",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 19,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "11:04:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 21,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "11:06:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#7#DA#290323#1S#500000063#1T#1017#LS#10000055#LT#1112#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#1017#TO#10000055#TT#1112#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 136,
                            g: 187,
                            b: 11,
                            hex: "#88BB0B",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S2",
                        internalName: "FGC   S2",
                        displayNumber: "S2",
                        num: "3198",
                        line: "S2",
                        lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S2",
                      },
                      name: "FGC S2",
                      direction: "Pl. Catalunya",
                      trainNumber: "S2",
                      trainCategory: "FGC",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 8,
                  alternativeCount: 25,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: { r: 239, g: 121, b: 0, hex: "#EF7900" },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "FGC",
                      nameS: "FGC",
                      nameN: "FGC",
                      nameL: "FGC",
                    },
                    name: "FGC S1",
                    internalName: "FGC   S1",
                    displayNumber: "S1",
                    num: "3382",
                    line: "S1",
                    lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                    catOut: "FGC",
                    catIn: "FGC",
                    catCode: "2",
                    cls: "4",
                    catOutS: "FGC",
                    catOutL: "FGC",
                    operatorCode: "FGC",
                    operator: "FGC",
                    admin: "005000",
                    routeIdxFrom: 17,
                    routeIdxTo: 19,
                    matchId: "S1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Muntaner, Barcelona",
                      id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                      extId: "30000044",
                      routeIdx: 17,
                      lon: 2.142345,
                      lat: 41.398526,
                      depTime: "10:41:00",
                      depDate: "2023-03-29",
                      depDir: "Pl. Catalunya",
                    },
                    {
                      name: "Pl Molina, Barcelona",
                      id: "A=1@O=Pl Molina, Barcelona@X=2147379@Y=41401411@U=80@L=100002417@",
                      extId: "100002417",
                      routeIdx: 18,
                      lon: 2.147379,
                      lat: 41.401411,
                      depTime: "10:42:00",
                      depDate: "2023-03-29",
                      arrTime: "10:41:00",
                      arrDate: "2023-03-29",
                    },
                    {
                      name: "Gràcia, Barcelona",
                      id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                      extId: "50000026",
                      routeIdx: 19,
                      lon: 2.152665,
                      lat: 41.399101,
                      arrTime: "10:43:00",
                      arrDate: "2023-03-29",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-03-29",
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2685#TA#1#DA#290323#1S#400000050#1T#955#LS#10000055#LT#1049#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#955#TO#10000055#TT#1049#",
                },
                id: "C-1:000",
                idx: 0,
                name: "FGC S1",
                number: "S1",
                category: "FGC",
                type: "JNY",
                reachable: true,
                direction: "Pl. Catalunya",
                directionFlag: "0",
                duration: "PT2M",
                dist: 1039,
                GisRoute: {
                  coordinates: [
                    { order: 0, lon: 2.142345, lat: 41.398526 },
                    { order: 1, lon: 2.147379, lat: 41.401411 },
                    { order: 2, lon: 2.152665, lat: 41.399101 },
                  ],
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Muntaner, Barcelona",
            type: "ST",
            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
            extId: "30000044",
            lon: 2.142345,
            lat: 41.398526,
            routeIdx: 19,
            prognosisType: "PROGNOSED",
            time: "10:44:00",
            date: "2023-03-29",
          },
          Destination: {
            name: "Gràcia, Barcelona",
            type: "ST",
            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
            extId: "50000026",
            lon: 2.152665,
            lat: 41.399101,
            routeIdx: 21,
            prognosisType: "PROGNOSED",
            time: "10:46:00",
            date: "2023-03-29",
          },
          Eco: { co2: 0.037404, type: "PUT", rating: 3 },
          EcoCmp: [{ co2: 0.160701, type: "BEE" }],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-02-05",
              planningPeriodEnd: "2023-12-02",
              sDaysR: "Lu - Vi",
              sDaysI:
                "no 7., 10. Abr, 1. May, 5. Jun, 1. hasta 31. Ago 2023, 11., 25. Sep, 12. Oct, 1. Nov",
              sDaysB:
                "7CF9F3E7CF9F3E7879F3E3CF9F3E7C79F3E7CF9F3E7C800000009F1E7C79F3A7CF9B3E7CF9F0",
            },
          ],
          Freq: { waitMinimum: 2 },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "Precio depende del número de zonas.",
                          },
                          { name: "PRICE.PREFIX", value: "min." },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [{ name: "hasSamplePrice", value: "1" }],
                  },
                ],
                param: [
                  { name: "Supplier", value: "005_fgc_catal" },
                  { name: "DatasetVersion", value: "2022-1" },
                  { name: "PSetName", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "OrigZone", value: "33" },
                  { name: "DestZone", value: "33" },
                  { name: "PSetDesc", value: "Zona 1-6" },
                  { name: "FirstSectIdx", value: "0" },
                  { name: "secIdStart", value: "C-2:000" },
                  { name: "LastSectIdx", value: "0" },
                  { name: "secIdEnd", value: "C-2:000" },
                  { name: "NAME", value: "Tarifas de FGC - Hay 6 zonas" },
                  { name: "DESCRIPTION", value: "Zona 1-6" },
                  { name: "TariffURL", value: "fgc.cat/es/billetes/" },
                  { name: "secIds", value: "C-2:000" },
                ],
                name: "Tarifas de FGC - Hay 6 zonas",
                desc: "Zona 1-6",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: { hintCode: 0 },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶T$A=1@O=Muntaner, Barcelona@L=30000044@a=128@$A=1@O=Gràcia, Barcelona@L=50000026@a=128@$202303291044$202303291046$FGC   S2$$1$$$$$$¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT2M",
          rtDuration: "PT2M",
          checksum: "b7634d28_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Muntaner, Barcelona",
                  type: "ST",
                  id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                  extId: "30000044",
                  lon: 2.142345,
                  lat: 41.398526,
                  routeIdx: 19,
                  prognosisType: "PROGNOSED",
                  time: "10:44:00",
                  date: "2023-03-29",
                },
                Destination: {
                  name: "Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                  extId: "50000026",
                  lon: 2.152665,
                  lat: 41.399101,
                  routeIdx: 21,
                  prognosisType: "PROGNOSED",
                  time: "10:46:00",
                  date: "2023-03-29",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#5#DA#290323#1S#500000063#1T#957#LS#10000055#LT#1052#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#957#TO#10000055#TT#1052#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 17,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "10:52:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 19,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "10:54:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2678#TA#10#DA#290323#1S#400000050#1T#1006#LS#10000055#LT#1100#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#1006#TO#10000055#TT#1100#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 239,
                            g: 121,
                            b: 0,
                            hex: "#EF7900",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S1",
                        internalName: "FGC   S1",
                        displayNumber: "S1",
                        num: "3380",
                        line: "S1",
                        lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S1",
                      },
                      name: "FGC S1",
                      direction: "Pl. Catalunya",
                      trainNumber: "S1",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 19,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "10:54:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 21,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "10:56:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#6#DA#290323#1S#500000063#1T#1007#LS#10000055#LT#1102#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#1007#TO#10000055#TT#1102#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 136,
                            g: 187,
                            b: 11,
                            hex: "#88BB0B",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S2",
                        internalName: "FGC   S2",
                        displayNumber: "S2",
                        num: "3194",
                        line: "S2",
                        lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S2",
                      },
                      name: "FGC S2",
                      direction: "Pl. Catalunya",
                      trainNumber: "S2",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 17,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "11:02:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 19,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "11:04:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2683#TA#2#DA#290323#1S#400000050#1T#1016#LS#10000055#LT#1110#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#1016#TO#10000055#TT#1110#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 239,
                            g: 121,
                            b: 0,
                            hex: "#EF7900",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S1",
                        internalName: "FGC   S1",
                        displayNumber: "S1",
                        num: "3384",
                        line: "S1",
                        lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S1",
                      },
                      name: "FGC S1",
                      direction: "Pl. Catalunya",
                      trainNumber: "S1",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 19,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "11:04:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 21,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "11:06:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#7#DA#290323#1S#500000063#1T#1017#LS#10000055#LT#1112#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#1017#TO#10000055#TT#1112#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 136,
                            g: 187,
                            b: 11,
                            hex: "#88BB0B",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S2",
                        internalName: "FGC   S2",
                        displayNumber: "S2",
                        num: "3198",
                        line: "S2",
                        lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S2",
                      },
                      name: "FGC S2",
                      direction: "Pl. Catalunya",
                      trainNumber: "S2",
                      trainCategory: "FGC",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Muntaner, Barcelona",
                            id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                            extId: "30000044",
                            routeIdx: 17,
                            lon: 2.142345,
                            lat: 41.398526,
                            depTime: "11:11:00",
                            depDate: "2023-03-29",
                            depDir: "Pl. Catalunya",
                          },
                          {
                            name: "Gràcia, Barcelona",
                            id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                            extId: "50000026",
                            routeIdx: 19,
                            lon: 2.152665,
                            lat: 41.399101,
                            arrTime: "11:13:00",
                            arrDate: "2023-03-29",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2685#TA#2#DA#290323#1S#400000050#1T#1025#LS#10000055#LT#1119#PU#80#RT#1#CA#FGC#ZE#S1#ZB#FGC   S1#PC#2#FR#400000050#FT#1025#TO#10000055#TT#1119#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 239,
                            g: 121,
                            b: 0,
                            hex: "#EF7900",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "FGC",
                          nameS: "FGC",
                          nameN: "FGC",
                          nameL: "FGC",
                        },
                        name: "FGC S1",
                        internalName: "FGC   S1",
                        displayNumber: "S1",
                        num: "3371",
                        line: "S1",
                        lineId: "S1(DEFAULT_AGENCY_gtfs)005",
                        catOut: "FGC",
                        catIn: "FGC",
                        catCode: "2",
                        cls: "4",
                        catOutS: "FGC",
                        catOutL: "FGC",
                        operatorCode: "FGC",
                        operator: "FGC",
                        admin: "005000",
                        matchId: "S1",
                      },
                      name: "FGC S1",
                      direction: "Pl. Catalunya",
                      trainNumber: "S1",
                      trainCategory: "FGC",
                    },
                  ],
                  waitMinimum: 2,
                  waitMaximum: 8,
                  alternativeCount: 25,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 136,
                        g: 187,
                        b: 11,
                        hex: "#88BB0B",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "FGC",
                      nameS: "FGC",
                      nameN: "FGC",
                      nameL: "FGC",
                    },
                    name: "FGC S2",
                    internalName: "FGC   S2",
                    displayNumber: "S2",
                    num: "3196",
                    line: "S2",
                    lineId: "S2(DEFAULT_AGENCY_gtfs)005",
                    catOut: "FGC",
                    catIn: "FGC",
                    catCode: "2",
                    cls: "4",
                    catOutS: "FGC",
                    catOutL: "FGC",
                    operatorCode: "FGC",
                    operator: "FGC",
                    admin: "005000",
                    routeIdxFrom: 19,
                    routeIdxTo: 21,
                    matchId: "S2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Muntaner, Barcelona",
                      id: "A=1@O=Muntaner, Barcelona@X=2142345@Y=41398526@U=80@L=30000044@",
                      extId: "30000044",
                      routeIdx: 19,
                      lon: 2.142345,
                      lat: 41.398526,
                      depTime: "10:44:00",
                      depDate: "2023-03-29",
                      depDir: "Pl. Catalunya",
                    },
                    {
                      name: "Pl Molina, Barcelona",
                      id: "A=1@O=Pl Molina, Barcelona@X=2147379@Y=41401411@U=80@L=100002417@",
                      extId: "100002417",
                      routeIdx: 20,
                      lon: 2.147379,
                      lat: 41.401411,
                      depTime: "10:45:00",
                      depDate: "2023-03-29",
                      arrTime: "10:44:00",
                      arrDate: "2023-03-29",
                    },
                    {
                      name: "Gràcia, Barcelona",
                      id: "A=1@O=Gràcia, Barcelona@X=2152665@Y=41399101@U=80@L=50000026@",
                      extId: "50000026",
                      routeIdx: 21,
                      lon: 2.152665,
                      lat: 41.399101,
                      arrTime: "10:46:00",
                      arrDate: "2023-03-29",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-03-29",
                  ref: "2|#VN#1#ST#1678192152#PI#0#ZI#2643#TA#5#DA#290323#1S#500000063#1T#957#LS#10000055#LT#1052#PU#80#RT#1#CA#FGC#ZE#S2#ZB#FGC   S2#PC#2#FR#500000063#FT#957#TO#10000055#TT#1052#",
                },
                id: "C-2:000",
                idx: 0,
                name: "FGC S2",
                number: "S2",
                category: "FGC",
                type: "JNY",
                reachable: true,
                direction: "Pl. Catalunya",
                directionFlag: "0",
                duration: "PT2M",
                dist: 1039,
                GisRoute: {
                  coordinates: [
                    { order: 0, lon: 2.142345, lat: 41.398526 },
                    { order: 1, lon: 2.147379, lat: 41.401411 },
                    { order: 2, lon: 2.152665, lat: 41.399101 },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  };
}

export function getTripTwoAve() {
  return {
    data: {
      Trip: [
      {
    "Origin": {
        "Notes": {
            "Note": [
                {
                    "value": "Silla de ruedas accesible",
                    "key": "WA",
                    "type": "A",
                    "priority": 0,
                    "txtN": "Silla de ruedas accesible"
                },
                {
                    "value": "Included in Tenant 1",
                    "key": "t1",
                    "type": "A",
                    "priority": 2,
                    "txtN": "Included in Tenant 1"
                },
                {
                    "value": "51003",
                    "key": "EK",
                    "type": "I",
                    "txtN": "51003"
                },
                {
                    "value": "30",
                    "key": "nc",
                    "type": "I",
                    "txtN": "30"
                }
            ]
        },
        "altId": [
            "a×028_51003",
            "a×030_51003",
            "a×031_0000960900000001",
            "a×095_51003"
        ],
        "name": "Sevilla-Santa Justa, Sevilla",
        "type": "ST",
        "id": "A=1@O=Sevilla-Santa Justa, Sevilla@X=-5974923@Y=37392492@U=80@L=100051003@",
        "extId": "100051003",
        "lon": -5.974923,
        "lat": 37.392492,
        "routeIdx": 0,
        "prognosisType": "PROGNOSED",
        "time": "09:55:00",
        "date": "2026-09-02",
        "isMainMast": true,
        "minimumChangeDuration": "PT4M"
    },
    "Destination": {
        "Notes": {
            "Note": [
                {
                    "value": "Silla de ruedas accesible",
                    "key": "WA",
                    "type": "A",
                    "priority": 0,
                    "txtN": "Silla de ruedas accesible"
                },
                {
                    "value": "Not included in Tenant 1",
                    "key": "n1",
                    "type": "A",
                    "priority": 2,
                    "txtN": "Not included in Tenant 1"
                },
                {
                    "value": "60000",
                    "key": "EK",
                    "type": "I",
                    "txtN": "60000"
                }
            ]
        },
        "altId": [
            "a×030_60000",
            "a×095_60000"
        ],
        "name": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
        "type": "ST",
        "id": "A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
        "extId": "100060000",
        "lon": -3.69089,
        "lat": 40.40644,
        "routeIdx": 7,
        "prognosisType": "PROGNOSED",
        "time": "13:49:00",
        "date": "2026-09-02",
        "minimumChangeDuration": "PT4M"
    },
    "Eco": {
        "co2": 15.200316,
        "dist": 422230,
        "type": "PUT",
        "rating": 3,
        "dur": "00d03:54:00",
        "duration": "PT3H54M"
    },
    "EcoCmp": [
        {
            "co2": 72.43315260258316,
            "type": "BEE"
        }
    ],
    "ServiceDays": [
        {
            "planningPeriodBegin": "2026-08-02",
            "planningPeriodEnd": "2027-05-29",
            "sDaysR": "no cada día",
            "sDaysI": "2. Sep hasta 3. Nov 2026",
            "sDaysB": "0000060FFFFFFFFFFFFFFFFC0000000000000000000000000000000000000000000000000000"
        }
    ],
    "Freq": {
        "waitMinimum": 58
    },
    "TariffResult": {},
    "calculation": "INITIAL",
    "TripStatus": {
        "economic": true,
        "convenient": true,
        "hintCode": 455
    },
    "idx": 1,
    "tripId": "C-1",
    "ctxRecon": "¶HKI¶T$A=1@O=Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$A=1@O=Córdoba-Julio Anguita, Córdoba@L=100050500@a=128@$202609020955$202609021039$RENAVANT$$1$$$$$$§G@F$A=1@O=Córdoba-Julio Anguita, Córdoba@L=100050500@a=128@$A=1@O=Córdoba-Julio Anguita, Córdoba@L=100050500@a=128@$202609021110$202609021140$__CI$$1$$$$$$§T$A=1@O=Córdoba-Julio Anguita, Córdoba@L=100050500@a=128@$A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@L=100060000@a=128@$202609021140$202609021349$REN AVLO$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#81#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9QVCJ9",
    "duration": "PT3H54M",
    "dist": 422231,
    "checksum": "899f7eb8_3",
    "checksumDti": "39b5182a_3",
    "checksumSave": "bf4fff6d_3",
    "transferCount": 1,
    "LegList": {
        "Leg": [
            {
                "Origin": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Included in Tenant 1",
                                "key": "t1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Included in Tenant 1"
                            },
                            {
                                "value": "51003",
                                "key": "EK",
                                "type": "I",
                                "txtN": "51003"
                            },
                            {
                                "value": "30",
                                "key": "nc",
                                "type": "I",
                                "txtN": "30"
                            }
                        ]
                    },
                    "altId": [
                        "a×028_51003",
                        "a×030_51003",
                        "a×031_0000960900000001",
                        "a×095_51003"
                    ],
                    "name": "Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Sevilla-Santa Justa, Sevilla@X=-5974923@Y=37392492@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.974923,
                    "lat": 37.392492,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "09:55:00",
                    "date": "2026-09-02",
                    "isMainMast": true,
                    "minimumChangeDuration": "PT4M"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Not included in Tenant 1",
                                "key": "n1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Not included in Tenant 1"
                            },
                            {
                                "value": "50500",
                                "key": "EK",
                                "type": "I",
                                "txtN": "50500"
                            }
                        ]
                    },
                    "altId": [
                        "a×030_50500",
                        "a×095_50500"
                    ],
                    "name": "Córdoba-Julio Anguita, Córdoba",
                    "type": "ST",
                    "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                    "extId": "100050500",
                    "lon": -4.789453,
                    "lat": 37.888292,
                    "routeIdx": 1,
                    "prognosisType": "PROGNOSED",
                    "time": "10:39:00",
                    "date": "2026-09-02",
                    "minimumChangeDuration": "PT4M"
                },
                "Notes": {
                    "Note": [
                        {
                            "value": "No accessible per silla de ruedas",
                            "key": "WN",
                            "type": "A",
                            "priority": 2,
                            "routeIdxFrom": 0,
                            "routeIdxTo": 1,
                            "txtN": "No accessible per silla de ruedas"
                        },
                        {
                            "value": "No accessible amb assistent",
                            "key": "NB",
                            "type": "A",
                            "priority": 999,
                            "routeIdxFrom": 0,
                            "routeIdxTo": 1,
                            "txtN": "No accessible amb assistent"
                        },
                        {
                            "value": "El proveedor no ha podido encontrar una oferta para su viaje.",
                            "key": "text.connection.section.show.with.info.NO_OFFER_AVAILABLE",
                            "type": "I",
                            "txtN": "El proveedor no ha podido encontrar una oferta para su viaje."
                        }
                    ]
                },
                "Eco": {
                    "co2": 4.251492000000001,
                    "dist": 118097
                },
                "JourneyDetailRef": {
                    "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#134863#TA#0#DA#20926#1S#100051003#1T#955#LS#100005000#LT#1235#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100051003#FT#955#TO#100005000#TT#1235#"
                },
                "JourneyStatus": "P",
                "Product": [
                    {
                        "icon": {
                            "foregroundColor": {
                                "r": 0,
                                "g": 0,
                                "b": 0,
                                "hex": "#000000"
                            },
                            "backgroundColor": {
                                "r": 242,
                                "g": 245,
                                "b": 245,
                                "hex": "#F2F5F5"
                            },
                            "res": "prod_ic"
                        },
                        "operatorInfo": {
                            "name": "RENFE OPERADORA",
                            "nameS": "107",
                            "nameN": "RENFE OP",
                            "nameL": "RENFE OPERADORA",
                            "id": "1071",
                            "url": "http://www.renfe.com"
                        },
                        "name": "RENAVANT",
                        "internalName": "RENAVANT",
                        "displayNumber": "AVANT",
                        "num": "2505",
                        "line": "AVANT",
                        "lineId": "5100305000AV008(1071)030",
                        "catOut": "RENFE OP",
                        "catIn": "107",
                        "catCode": "2",
                        "cls": "4",
                        "catOutS": "107",
                        "catOutL": "RENFE OPERADORA",
                        "operatorCode": "107",
                        "operator": "RENFE OPERADORA",
                        "admin": "030000",
                        "routeIdxFrom": 0,
                        "routeIdxTo": 1,
                        "matchId": "0829512026-08-30"
                    }
                ],
                "Stops": {
                    "Stop": [
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Included in Tenant 1",
                                        "key": "t1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Included in Tenant 1"
                                    },
                                    {
                                        "value": "51003",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "51003"
                                    },
                                    {
                                        "value": "30",
                                        "key": "nc",
                                        "type": "I",
                                        "txtN": "30"
                                    }
                                ]
                            },
                            "altId": [
                                "a×028_51003",
                                "a×030_51003",
                                "a×031_0000960900000001",
                                "a×095_51003"
                            ],
                            "name": "Sevilla-Santa Justa, Sevilla",
                            "id": "A=1@O=Sevilla-Santa Justa, Sevilla@X=-5974923@Y=37392492@U=80@L=100051003@",
                            "extId": "100051003",
                            "routeIdx": 0,
                            "lon": -5.974923,
                            "lat": 37.392492,
                            "depPrognosisType": "PROGNOSED",
                            "depTime": "09:55:00",
                            "depDate": "2026-09-02",
                            "isMainMast": true,
                            "depDir": "Granada, Granada",
                            "minimumChangeDuration": "PT4M"
                        },
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "50500",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "50500"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_50500",
                                "a×095_50500"
                            ],
                            "name": "Córdoba-Julio Anguita, Córdoba",
                            "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            "extId": "100050500",
                            "routeIdx": 1,
                            "lon": -4.789453,
                            "lat": 37.888292,
                            "arrTime": "10:39:00",
                            "arrDate": "2026-09-02",
                            "minimumChangeDuration": "PT4M"
                        }
                    ]
                },
                "JourneyDetail": {
                    "dayOfOperation": "2026-09-02",
                    "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#134863#TA#0#DA#20926#1S#100051003#1T#955#LS#100005000#LT#1235#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100051003#FT#955#TO#100005000#TT#1235#"
                },
                "id": "C-1:000",
                "idx": 0,
                "name": "RENAVANT",
                "number": "AVANT",
                "category": "107",
                "type": "JNY",
                "reachable": true,
                "waitingState": "UNDEF",
                "direction": "Granada, Granada",
                "directionFlag": "0",
                "duration": "PT44M",
                "dist": 118097,
                "minimumChangeDuration": "PT34M",
                "GisRoute": {
                    "coordinates": [
                        {
                            "order": 0,
                            "lon": -5.974923,
                            "lat": 37.392492
                        },
                        {
                            "order": 1,
                            "lon": -4.789453,
                            "lat": 37.888292
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Not included in Tenant 1",
                                "key": "n1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Not included in Tenant 1"
                            },
                            {
                                "value": "50500",
                                "key": "EK",
                                "type": "I",
                                "txtN": "50500"
                            }
                        ]
                    },
                    "altId": [
                        "a×030_50500",
                        "a×095_50500"
                    ],
                    "name": "Córdoba-Julio Anguita, Córdoba",
                    "type": "ST",
                    "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                    "extId": "100050500",
                    "lon": -4.789453,
                    "lat": 37.888292,
                    "routeIdx": 3,
                    "time": "11:10:00",
                    "date": "2026-09-02",
                    "minimumChangeDuration": "PT4M"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Not included in Tenant 1",
                                "key": "n1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Not included in Tenant 1"
                            },
                            {
                                "value": "50500",
                                "key": "EK",
                                "type": "I",
                                "txtN": "50500"
                            }
                        ]
                    },
                    "altId": [
                        "a×030_50500",
                        "a×095_50500"
                    ],
                    "name": "Córdoba-Julio Anguita, Córdoba",
                    "type": "ST",
                    "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                    "extId": "100050500",
                    "lon": -4.789453,
                    "lat": 37.888292,
                    "routeIdx": 3,
                    "time": "11:40:00",
                    "date": "2026-09-02",
                    "minimumChangeDuration": "PT4M"
                },
                "Eco": {
                    "co2": 0
                },
                "Product": [
                    {
                        "icon": {
                            "res": "check_in"
                        },
                        "name": "Ingreso",
                        "internalName": "Ingreso"
                    }
                ],
                "id": "C-1:001",
                "idx": 1,
                "name": "Ingreso",
                "type": "CHKI",
                "duration": "PT30M",
                "dist": 0,
                "GisRoute": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "El proveedor no ha podido encontrar una oferta para su viaje.",
                                "key": "text.connection.section.show.with.info.NO_OFFER_AVAILABLE",
                                "type": "I",
                                "txtN": "El proveedor no ha podido encontrar una oferta para su viaje."
                            }
                        ]
                    },
                    "dist": 0,
                    "durS": "PT30M",
                    "dirGeo": 0
                }
            },
            {
                "Origin": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Not included in Tenant 1",
                                "key": "n1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Not included in Tenant 1"
                            },
                            {
                                "value": "50500",
                                "key": "EK",
                                "type": "I",
                                "txtN": "50500"
                            }
                        ]
                    },
                    "altId": [
                        "a×030_50500",
                        "a×095_50500"
                    ],
                    "name": "Córdoba-Julio Anguita, Córdoba",
                    "type": "ST",
                    "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                    "extId": "100050500",
                    "lon": -4.789453,
                    "lat": 37.888292,
                    "routeIdx": 3,
                    "prognosisType": "PROGNOSED",
                    "time": "11:40:00",
                    "date": "2026-09-02",
                    "minimumChangeDuration": "PT4M"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Silla de ruedas accesible",
                                "key": "WA",
                                "type": "A",
                                "priority": 0,
                                "txtN": "Silla de ruedas accesible"
                            },
                            {
                                "value": "Not included in Tenant 1",
                                "key": "n1",
                                "type": "A",
                                "priority": 2,
                                "txtN": "Not included in Tenant 1"
                            },
                            {
                                "value": "60000",
                                "key": "EK",
                                "type": "I",
                                "txtN": "60000"
                            }
                        ]
                    },
                    "altId": [
                        "a×030_60000",
                        "a×095_60000"
                    ],
                    "name": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                    "extId": "100060000",
                    "lon": -3.69089,
                    "lat": 40.40644,
                    "routeIdx": 7,
                    "prognosisType": "PROGNOSED",
                    "time": "13:49:00",
                    "date": "2026-09-02",
                    "minimumChangeDuration": "PT4M"
                },
                "Notes": {
                    "Note": [
                        {
                            "value": "No accessible per silla de ruedas",
                            "key": "WN",
                            "type": "A",
                            "priority": 2,
                            "routeIdxFrom": 3,
                            "routeIdxTo": 7,
                            "txtN": "No accessible per silla de ruedas"
                        },
                        {
                            "value": "No accessible amb assistent",
                            "key": "NB",
                            "type": "A",
                            "priority": 999,
                            "routeIdxFrom": 3,
                            "routeIdxTo": 7,
                            "txtN": "No accessible amb assistent"
                        },
                        {
                            "value": "El proveedor no ha podido encontrar una oferta para su viaje.",
                            "key": "text.connection.section.show.with.info.NO_OFFER_AVAILABLE",
                            "type": "I",
                            "txtN": "El proveedor no ha podido encontrar una oferta para su viaje."
                        }
                    ]
                },
                "Eco": {
                    "co2": 10.948824,
                    "dist": 304134
                },
                "JourneyDetailRef": {
                    "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#139592#TA#0#DA#20926#1S#54413#1T#1035#LS#100060000#LT#1349#PU#80#RT#1#CA#107#ZE#AVLO#ZB#REN AVLO#PC#2#FR#54413#FT#1035#TO#100060000#TT#1349#"
                },
                "Freq": {
                    "journey": [
                        {
                            "Stops": {
                                "Stop": [
                                    {
                                        "Notes": {
                                            "Note": [
                                                {
                                                    "value": "Silla de ruedas accesible",
                                                    "key": "WA",
                                                    "type": "A",
                                                    "priority": 0,
                                                    "txtN": "Silla de ruedas accesible"
                                                },
                                                {
                                                    "value": "Not included in Tenant 1",
                                                    "key": "n1",
                                                    "type": "A",
                                                    "priority": 2,
                                                    "txtN": "Not included in Tenant 1"
                                                },
                                                {
                                                    "value": "50500",
                                                    "key": "EK",
                                                    "type": "I",
                                                    "txtN": "50500"
                                                }
                                            ]
                                        },
                                        "altId": [
                                            "a×030_50500",
                                            "a×095_50500"
                                        ],
                                        "name": "Córdoba-Julio Anguita, Córdoba",
                                        "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 5,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "12:38:00",
                                        "depDate": "2026-09-02",
                                        "depDir": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                                        "minimumChangeDuration": "PT4M"
                                    },
                                    {
                                        "Notes": {
                                            "Note": [
                                                {
                                                    "value": "Silla de ruedas accesible",
                                                    "key": "WA",
                                                    "type": "A",
                                                    "priority": 0,
                                                    "txtN": "Silla de ruedas accesible"
                                                },
                                                {
                                                    "value": "Not included in Tenant 1",
                                                    "key": "n1",
                                                    "type": "A",
                                                    "priority": 2,
                                                    "txtN": "Not included in Tenant 1"
                                                },
                                                {
                                                    "value": "60000",
                                                    "key": "EK",
                                                    "type": "I",
                                                    "txtN": "60000"
                                                }
                                            ]
                                        },
                                        "altId": [
                                            "a×030_60000",
                                            "a×095_60000"
                                        ],
                                        "name": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                                        "id": "A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 6,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "14:38:00",
                                        "arrDate": "2026-09-02",
                                        "minimumChangeDuration": "PT4M"
                                    }
                                ]
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#139484#TA#0#DA#20926#1S#100056312#1T#754#LS#100060000#LT#1438#PU#80#RT#1#CA#107#ZE#ALVIA#ZB#RENALVIA#PC#2#FR#100056312#FT#754#TO#100060000#TT#1438#"
                            },
                            "Product": {
                                "icon": {
                                    "foregroundColor": {
                                        "r": 0,
                                        "g": 0,
                                        "b": 0,
                                        "hex": "#000000"
                                    },
                                    "backgroundColor": {
                                        "r": 242,
                                        "g": 245,
                                        "b": 245,
                                        "hex": "#F2F5F5"
                                    },
                                    "res": "prod_ic"
                                },
                                "operatorInfo": {
                                    "name": "RENFE OPERADORA",
                                    "nameS": "107",
                                    "nameN": "RENFE OP",
                                    "nameL": "RENFE OPERADORA",
                                    "id": "1071",
                                    "url": "http://www.renfe.com"
                                },
                                "name": "RENALVIA",
                                "internalName": "RENALVIA",
                                "displayNumber": "ALVIA",
                                "num": "594",
                                "line": "ALVIA",
                                "lineId": "5631260000GL023(1071)030",
                                "catOut": "RENFE OP",
                                "catIn": "107",
                                "catCode": "2",
                                "cls": "4",
                                "catOutS": "107",
                                "catOutL": "RENFE OPERADORA",
                                "operatorCode": "107",
                                "operator": "RENFE OPERADORA",
                                "admin": "030000",
                                "matchId": "0208712026-08-30"
                            },
                            "name": "RENALVIA",
                            "direction": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                            "directionFlag": "0",
                            "lon": -2.813848,
                            "lat": 37.120955,
                            "trainNumber": "ALVIA",
                            "trainCategory": "107"
                        },
                        {
                            "Stops": {
                                "Stop": [
                                    {
                                        "Notes": {
                                            "Note": [
                                                {
                                                    "value": "Silla de ruedas accesible",
                                                    "key": "WA",
                                                    "type": "A",
                                                    "priority": 0,
                                                    "txtN": "Silla de ruedas accesible"
                                                },
                                                {
                                                    "value": "Not included in Tenant 1",
                                                    "key": "n1",
                                                    "type": "A",
                                                    "priority": 2,
                                                    "txtN": "Not included in Tenant 1"
                                                },
                                                {
                                                    "value": "50500",
                                                    "key": "EK",
                                                    "type": "I",
                                                    "txtN": "50500"
                                                }
                                            ]
                                        },
                                        "altId": [
                                            "a×030_50500",
                                            "a×095_50500"
                                        ],
                                        "name": "Córdoba-Julio Anguita, Córdoba",
                                        "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "13:59:00",
                                        "depDate": "2026-09-02",
                                        "depDir": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                                        "minimumChangeDuration": "PT4M"
                                    },
                                    {
                                        "Notes": {
                                            "Note": [
                                                {
                                                    "value": "Silla de ruedas accesible",
                                                    "key": "WA",
                                                    "type": "A",
                                                    "priority": 0,
                                                    "txtN": "Silla de ruedas accesible"
                                                },
                                                {
                                                    "value": "Not included in Tenant 1",
                                                    "key": "n1",
                                                    "type": "A",
                                                    "priority": 2,
                                                    "txtN": "Not included in Tenant 1"
                                                },
                                                {
                                                    "value": "60000",
                                                    "key": "EK",
                                                    "type": "I",
                                                    "txtN": "60000"
                                                }
                                            ]
                                        },
                                        "altId": [
                                            "a×030_60000",
                                            "a×095_60000"
                                        ],
                                        "name": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                                        "id": "A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 5,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "16:07:00",
                                        "arrDate": "2026-09-02",
                                        "minimumChangeDuration": "PT4M"
                                    }
                                ]
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#139664#TA#0#DA#20926#1S#100051003#1T#1315#LS#100060000#LT#1607#PU#80#RT#1#CA#107#ZE#AVLO#ZB#REN AVLO#PC#2#FR#100051003#FT#1315#TO#100060000#TT#1607#"
                            },
                            "Product": {
                                "icon": {
                                    "foregroundColor": {
                                        "r": 0,
                                        "g": 0,
                                        "b": 0,
                                        "hex": "#000000"
                                    },
                                    "backgroundColor": {
                                        "r": 242,
                                        "g": 245,
                                        "b": 245,
                                        "hex": "#F2F5F5"
                                    },
                                    "res": "prod_ic"
                                },
                                "operatorInfo": {
                                    "name": "RENFE OPERADORA",
                                    "nameS": "107",
                                    "nameN": "RENFE OP",
                                    "nameL": "RENFE OPERADORA",
                                    "id": "1071",
                                    "url": "http://www.renfe.com"
                                },
                                "name": "REN AVLO",
                                "internalName": "REN AVLO",
                                "displayNumber": "AVLO",
                                "num": "705",
                                "line": "AVLO",
                                "lineId": "5100360000LC112(1071)030",
                                "catOut": "RENFE OP",
                                "catIn": "107",
                                "catCode": "2",
                                "cls": "4",
                                "catOutS": "107",
                                "catOutL": "RENFE OPERADORA",
                                "operatorCode": "107",
                                "operator": "RENFE OPERADORA",
                                "admin": "030000",
                                "matchId": "0213712026-08-30"
                            },
                            "name": "REN AVLO",
                            "direction": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                            "directionFlag": "0",
                            "trainNumber": "AVLO",
                            "trainCategory": "107"
                        }
                    ],
                    "waitMinimum": 58,
                    "waitMaximum": 81,
                    "alternativeCount": 2
                },
                "JourneyStatus": "P",
                "Product": [
                    {
                        "icon": {
                            "foregroundColor": {
                                "r": 0,
                                "g": 0,
                                "b": 0,
                                "hex": "#000000"
                            },
                            "backgroundColor": {
                                "r": 242,
                                "g": 245,
                                "b": 245,
                                "hex": "#F2F5F5"
                            },
                            "res": "prod_ic"
                        },
                        "operatorInfo": {
                            "name": "RENFE OPERADORA",
                            "nameS": "107",
                            "nameN": "RENFE OP",
                            "nameL": "RENFE OPERADORA",
                            "id": "1071",
                            "url": "http://www.renfe.com"
                        },
                        "name": "REN AVLO",
                        "internalName": "REN AVLO",
                        "displayNumber": "AVLO",
                        "num": "649",
                        "line": "AVLO",
                        "lineId": "5441360000LC112(1071)030",
                        "catOut": "RENFE OP",
                        "catIn": "107",
                        "catCode": "2",
                        "cls": "4",
                        "catOutS": "107",
                        "catOutL": "RENFE OPERADORA",
                        "operatorCode": "107",
                        "operator": "RENFE OPERADORA",
                        "admin": "030000",
                        "routeIdxFrom": 3,
                        "routeIdxTo": 7,
                        "matchId": "0210912026-09-01"
                    }
                ],
                "Stops": {
                    "Stop": [
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "50500",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "50500"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_50500",
                                "a×095_50500"
                            ],
                            "name": "Córdoba-Julio Anguita, Córdoba",
                            "id": "A=1@O=Córdoba-Julio Anguita, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            "extId": "100050500",
                            "routeIdx": 3,
                            "lon": -4.789453,
                            "lat": 37.888292,
                            "depTime": "11:40:00",
                            "depDate": "2026-09-02",
                            "depDir": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                            "minimumChangeDuration": "PT4M"
                        },
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "No accessible per silla de ruedas",
                                        "key": "WN",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "No accessible per silla de ruedas"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "37704",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "37704"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_37704",
                                "a×095_37704"
                            ],
                            "name": "Villanueva de Córdoba, Villanueva de Córdoba",
                            "id": "A=1@O=Villanueva de Córdoba, Villanueva de Córdoba@X=-4570952@Y=38255403@U=80@L=100037704@",
                            "extId": "100037704",
                            "routeIdx": 4,
                            "lon": -4.570952,
                            "lat": 38.255403,
                            "depTime": "12:03:00",
                            "depDate": "2026-09-02",
                            "arrTime": "12:01:00",
                            "arrDate": "2026-09-02",
                            "minimumChangeDuration": "PT4M"
                        },
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "37300",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "37300"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_37300",
                                "a×095_37700"
                            ],
                            "name": "Puertollano, Puertollano",
                            "id": "A=1@O=Puertollano, Puertollano@X=-4111657@Y=38691280@U=80@L=100037300@",
                            "extId": "100037300",
                            "routeIdx": 5,
                            "lon": -4.111657,
                            "lat": 38.69128,
                            "depTime": "12:29:00",
                            "depDate": "2026-09-02",
                            "arrTime": "12:27:00",
                            "arrDate": "2026-09-02",
                            "minimumChangeDuration": "PT4M"
                        },
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "37200",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "37200"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_37200",
                                "a×070_61040",
                                "a×095_37200"
                            ],
                            "name": "Ciudad Real, Ciudad Real",
                            "id": "A=1@O=Ciudad Real, Ciudad Real@X=-3913634@Y=38985300@U=80@L=100037200@",
                            "extId": "100037200",
                            "routeIdx": 6,
                            "lon": -3.913634,
                            "lat": 38.9853,
                            "depTime": "12:44:00",
                            "depDate": "2026-09-02",
                            "arrTime": "12:42:00",
                            "arrDate": "2026-09-02",
                            "minimumChangeDuration": "PT4M"
                        },
                        {
                            "Notes": {
                                "Note": [
                                    {
                                        "value": "Silla de ruedas accesible",
                                        "key": "WA",
                                        "type": "A",
                                        "priority": 0,
                                        "txtN": "Silla de ruedas accesible"
                                    },
                                    {
                                        "value": "Not included in Tenant 1",
                                        "key": "n1",
                                        "type": "A",
                                        "priority": 2,
                                        "txtN": "Not included in Tenant 1"
                                    },
                                    {
                                        "value": "60000",
                                        "key": "EK",
                                        "type": "I",
                                        "txtN": "60000"
                                    }
                                ]
                            },
                            "altId": [
                                "a×030_60000",
                                "a×095_60000"
                            ],
                            "name": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                            "id": "A=1@O=Madrid-Puerta de Atocha-Almudena Grandes, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            "extId": "100060000",
                            "routeIdx": 7,
                            "lon": -3.69089,
                            "lat": 40.40644,
                            "arrPrognosisType": "PROGNOSED",
                            "arrTime": "13:49:00",
                            "arrDate": "2026-09-02",
                            "minimumChangeDuration": "PT4M"
                        }
                    ]
                },
                "JourneyDetail": {
                    "dayOfOperation": "2026-09-02",
                    "ref": "2|#VN#1#ST#1788251029#PI#0#ZI#139592#TA#0#DA#20926#1S#54413#1T#1035#LS#100060000#LT#1349#PU#80#RT#1#CA#107#ZE#AVLO#ZB#REN AVLO#PC#2#FR#54413#FT#1035#TO#100060000#TT#1349#"
                },
                "id": "C-1:002",
                "idx": 2,
                "name": "REN AVLO",
                "number": "AVLO",
                "category": "107",
                "type": "JNY",
                "reachable": true,
                "waitingState": "UNDEF",
                "direction": "Madrid-Puerta de Atocha-Almudena Grandes, Madrid",
                "directionFlag": "0",
                "duration": "PT2H9M",
                "dist": 304134,
                "GisRoute": {
                    "coordinates": [
                        {
                            "order": 0,
                            "lon": -4.789453,
                            "lat": 37.888292
                        },
                        {
                            "order": 1,
                            "lon": -4.570952,
                            "lat": 38.255403
                        },
                        {
                            "order": 2,
                            "lon": -4.111657,
                            "lat": 38.69128
                        },
                        {
                            "order": 3,
                            "lon": -3.913634,
                            "lat": 38.9853
                        },
                        {
                            "order": 4,
                            "lon": -3.69089,
                            "lat": 40.40644
                        }
                    ]
                }
            }
        ]
    }
}
      ]
    },
  };
}

export function getSheduleInformation() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:20:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "12:13:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 4.203004,
            dist: 80951,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. hasta 23. Nov 2024 Sa, Do",
              sDaysB:
                "0000000183040000000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 30,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Metro",
                        desc: "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - MetroEste, MetroNorte y MetroSur",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - TFM",
                        price: 200,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Combinado Metro",
                        desc: "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete Suplemento Aeropuerto de un viaje para un adulto",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "022_metro_madri",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2024-4",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona A",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdStart",
                    value: "C-0:002",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona A",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.crtm.es/billetes-y-tarifas.aspx",
                  },
                  {
                    name: "secIds",
                    value: "C-0:002",
                  },
                ],
                name: "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                desc: "Zona A",
                fromLegId: 2,
                toLegId: 2,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$202411161020$202411161113$Ren   C3$$1$$$$$$§W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161113$202411161117$$$1$$$$$$§T$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$202411161117$202411161121$Con    6$$1$$$$$$§W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161121$202411161125$$$1$$$$$$§T$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@$202411161130$202411161204$ALSALSA $$1$$$$$$§G@F$A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161204$202411161213$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9QVCJ9",
          duration: "PT1H53M",
          rtDuration: "PT1H53M",
          checksum: "c7320560_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:20:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:13:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 11,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                Freq: {
                  waitMinimum: 30,
                  waitMaximum: 30,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "182",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 11,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:20:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:29:00",
                      depDate: "2024-11-16",
                      arrTime: "10:29:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "10:34:00",
                      depDate: "2024-11-16",
                      arrTime: "10:34:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "10:39:00",
                      depDate: "2024-11-16",
                      arrTime: "10:39:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "10:44:00",
                      depDate: "2024-11-16",
                      arrTime: "10:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "10:46:00",
                      depDate: "2024-11-16",
                      arrTime: "10:46:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "10:49:00",
                      depDate: "2024-11-16",
                      arrTime: "10:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "10:52:00",
                      depDate: "2024-11-16",
                      arrTime: "10:52:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "10:55:00",
                      depDate: "2024-11-16",
                      arrTime: "10:55:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:05:00",
                      depDate: "2024-11-16",
                      arrTime: "11:05:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Sol, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                      extId: "100018101",
                      routeIdx: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                      depTime: "11:08:00",
                      depDate: "2024-11-16",
                      arrTime: "11:08:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      extId: "100018002",
                      routeIdx: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                      arrTime: "11:13:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                id: "C-0:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT53M",
                dist: 50433,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                    },
                    {
                      order: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  time: "11:13:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  time: "11:17:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161113$202411161117$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 6,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                    {
                      order: 1,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                  ],
                  dist: 6,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:17:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                Destination: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "11:21:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#9#DA#161124#1S#100035608#1T#1054#LS#100035608#LT#1149#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1054#TO#100035608#TT#1149#",
                },
                Freq: {
                  waitMinimum: 6,
                  waitMaximum: 6,
                  alternativeCount: 21,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 152,
                        g: 152,
                        b: 155,
                        hex: "#98989B",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "Consorcio Regional de Transportes de Madrid",
                      nameS: "CRT",
                      nameN: "Consorci",
                      nameL: "Consorcio Regional de Transportes de Madrid",
                      id: "CRTM",
                    },
                    name: "Con 6",
                    internalName: "Con    6",
                    displayNumber: "6",
                    num: "16",
                    line: "6",
                    lineId: "4__6___(CRTM)022",
                    catOut: "Consorci",
                    catIn: "CRT",
                    catCode: "6",
                    cls: "64",
                    catOutS: "CRT",
                    catOutL: "Consorcio Regional de Transportes de Madrid",
                    operatorCode: "CRT",
                    operator: "Consorcio Regional de Transportes de Madrid",
                    admin: "022000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "6",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "NUEVOS MINISTERIOS, Madrid",
                      id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                      extId: "110001007",
                      routeIdx: 11,
                      lon: -3.692409,
                      lat: 40.446622,
                      depTime: "11:17:00",
                      depDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      mainMastExtId: "100018002",
                      mainMastLon: -3.692337,
                      mainMastLat: 40.446613,
                      depDir: "LAGUNA",
                    },
                    {
                      name: "REPUBLICA ARGENTINA, Madrid",
                      id: "A=1@O=REPUBLICA ARGENTINA, Madrid@X=-3684058@Y=40443790@U=80@L=110001005@",
                      extId: "110001005",
                      routeIdx: 12,
                      lon: -3.684058,
                      lat: 40.44379,
                      depTime: "11:19:00",
                      depDate: "2024-11-16",
                      arrTime: "11:19:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "AVENIDA DE AMERICA, Madrid",
                      id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                      extId: "80001004",
                      routeIdx: 13,
                      lon: -3.676579,
                      lat: 40.438037,
                      arrTime: "11:21:00",
                      arrDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      mainMastExtId: "979",
                      mainMastLon: -3.676687,
                      mainMastLat: 40.438028,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#9#DA#161124#1S#100035608#1T#1054#LS#100035608#LT#1149#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1054#TO#100035608#TT#1149#",
                },
                id: "C-0:002",
                idx: 2,
                name: "Con 6",
                number: "6",
                category: "CRT",
                type: "JNY",
                reachable: true,
                direction: "LAGUNA",
                directionFlag: "1",
                duration: "PT4M",
                dist: 1674,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                    {
                      order: 1,
                      lon: -3.684058,
                      lat: 40.44379,
                    },
                    {
                      order: 2,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  time: "11:21:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                Destination: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  time: "11:25:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161121$202411161125$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 9,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                    {
                      order: 1,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                  ],
                  dist: 9,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "11:30:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Alcala - Via Complutense 78, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                  extId: "100009345",
                  lon: -3.354945,
                  lat: 40.489375,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "12:04:00",
                  date: "2024-11-16",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170788#TA#1#DA#161124#1S#979#1T#1130#LS#566#LT#1215#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1130#TO#566#TT#1215#",
                },
                Freq: {
                  waitMinimum: 15,
                  waitMaximum: 15,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - 2",
                    num: "8074",
                    line: "ALSA - 2",
                    lineId: "3685(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 13,
                    matchId: "ALSA - 2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Intercambiador de Avenida de América, Madrid",
                      id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      extId: "979",
                      routeIdx: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                      depPrognosisType: "PROGNOSED",
                      depTime: "11:30:00",
                      depDate: "2024-11-16",
                      depDir: "Alcala De Henares",
                    },
                    {
                      name: "Madrid - Puente de la Cea, Madrid",
                      id: "A=1@O=Madrid - Puente de la Cea, Madrid@X=-3651571@Y=40447836@U=80@L=100008495@",
                      extId: "100008495",
                      routeIdx: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                      depTime: "11:33:00",
                      depDate: "2024-11-16",
                      arrTime: "11:33:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Madrid - Metro Canillejas, Madrid",
                      id: "A=1@O=Madrid - Metro Canillejas, Madrid@X=-3609690@Y=40449454@U=80@L=100008528@",
                      extId: "100008528",
                      routeIdx: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                      depTime: "11:36:00",
                      depDate: "2024-11-16",
                      arrTime: "11:36:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Poligono de las Mercedes, Madrid",
                      id: "A=1@O=Poligono de las Mercedes, Madrid@X=-3581051@Y=40449597@U=80@L=100008714@",
                      extId: "100008714",
                      routeIdx: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                      depTime: "11:40:00",
                      depDate: "2024-11-16",
                      arrTime: "11:40:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Colonia Fin de Semana, Madrid",
                      id: "A=1@O=Colonia Fin de Semana, Madrid@X=-3567917@Y=40449400@U=80@L=100008715@",
                      extId: "100008715",
                      routeIdx: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                      depTime: "11:42:00",
                      depDate: "2024-11-16",
                      arrTime: "11:42:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Avenida de Aragon 400, Madrid",
                      id: "A=1@O=Avenida de Aragon 400, Madrid@X=-3558281@Y=40449139@U=80@L=100008716@",
                      extId: "100008716",
                      routeIdx: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                      depTime: "11:43:00",
                      depDate: "2024-11-16",
                      arrTime: "11:43:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Fabrica Iveco-Pegaso, Madrid",
                      id: "A=1@O=Fabrica Iveco-Pegaso, Madrid@X=-3547890@Y=40448105@U=80@L=100008717@",
                      extId: "100008717",
                      routeIdx: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                      depTime: "11:44:00",
                      depDate: "2024-11-16",
                      arrTime: "11:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Zanussi, Alcalá de Henares",
                      id: "A=1@O=Alcala - Zanussi, Alcalá de Henares@X=-3409959@Y=40471468@U=80@L=100008719@",
                      extId: "100008719",
                      routeIdx: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                      depTime: "11:53:00",
                      depDate: "2024-11-16",
                      arrTime: "11:53:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Fiat España, Alcalá de Henares",
                      id: "A=1@O=Alcala - Fiat España, Alcalá de Henares@X=-3395612@Y=40475630@U=80@L=100009127@",
                      extId: "100009127",
                      routeIdx: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                      depTime: "11:54:00",
                      depDate: "2024-11-16",
                      arrTime: "11:54:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 36, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 36, Alcalá de Henares@X=-3383908@Y=40478705@U=80@L=100008720@",
                      extId: "100008720",
                      routeIdx: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                      depTime: "11:56:00",
                      depDate: "2024-11-16",
                      arrTime: "11:56:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 28, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 28, Alcalá de Henares@X=-3375476@Y=40480287@U=80@L=100008721@",
                      extId: "100008721",
                      routeIdx: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                      depTime: "11:58:00",
                      depDate: "2024-11-16",
                      arrTime: "11:58:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 24, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 24, Alcalá de Henares@X=-3366766@Y=40484422@U=80@L=100009259@",
                      extId: "100009259",
                      routeIdx: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                      depTime: "12:00:00",
                      depDate: "2024-11-16",
                      arrTime: "12:00:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Via Complutense-Ribera, Alcalá de Henares",
                      id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                      extId: "100009872",
                      routeIdx: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                      depTime: "12:02:00",
                      depDate: "2024-11-16",
                      arrTime: "12:02:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 78, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                      extId: "100009345",
                      routeIdx: 13,
                      lon: -3.354945,
                      lat: 40.489375,
                      arrTime: "12:04:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170788#TA#1#DA#161124#1S#979#1T#1130#LS#566#LT#1215#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1130#TO#566#TT#1215#",
                },
                id: "C-0:004",
                idx: 4,
                name: "ALSALSA",
                number: "ALSA - 2",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Alcala De Henares",
                directionFlag: "0",
                duration: "PT34M",
                dist: 28237,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                    {
                      order: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                    },
                    {
                      order: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                    },
                    {
                      order: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                    },
                    {
                      order: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                    },
                    {
                      order: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                    },
                    {
                      order: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                    },
                    {
                      order: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                    },
                    {
                      order: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                    },
                    {
                      order: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                    },
                    {
                      order: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                    },
                    {
                      order: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                    },
                    {
                      order: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                    },
                    {
                      order: 13,
                      lon: -3.354945,
                      lat: 40.489375,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Alcala - Via Complutense 78, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                  extId: "100009345",
                  lon: -3.354945,
                  lat: 40.489375,
                  time: "12:04:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "12:13:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|120400|121300|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:005",
                idx: 5,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT9M",
                dist: 592,
                GisRoute: {
                  dist: 592,
                  durS: "PT9M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:20:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "12:18:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 4.16348,
            dist: 80933,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. hasta 23. Nov 2024 Sa, Do",
              sDaysB:
                "0000000183040000000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 30,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-1:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:000",
                  },
                  {
                    name: "secIds",
                    value: "C-1:000",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Metro",
                        desc: "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - MetroEste, MetroNorte y MetroSur",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - TFM",
                        price: 200,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Combinado Metro",
                        desc: "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete Suplemento Aeropuerto de un viaje para un adulto",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "022_metro_madri",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2024-4",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona A",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdStart",
                    value: "C-1:002",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona A",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.crtm.es/billetes-y-tarifas.aspx",
                  },
                  {
                    name: "secIds",
                    value: "C-1:002",
                  },
                ],
                name: "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                desc: "Zona A",
                fromLegId: 2,
                toLegId: 2,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$202411161020$202411161113$Ren   C3$$1$$$$$$§W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161113$202411161117$$$1$$$$$$§T$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$202411161117$202411161121$Con    6$$1$$$$$$§W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161121$202411161125$$$1$$$$$$§T$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@$202411161130$202411161202$ALSALSA $$1$$$$$$§G@F$A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161202$202411161218$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9QVCJ9",
          duration: "PT1H58M",
          rtDuration: "PT1H58M",
          checksum: "a1325237_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:20:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:13:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 11,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                Freq: {
                  waitMinimum: 30,
                  waitMaximum: 30,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "182",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 11,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:20:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:29:00",
                      depDate: "2024-11-16",
                      arrTime: "10:29:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "10:34:00",
                      depDate: "2024-11-16",
                      arrTime: "10:34:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "10:39:00",
                      depDate: "2024-11-16",
                      arrTime: "10:39:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "10:44:00",
                      depDate: "2024-11-16",
                      arrTime: "10:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "10:46:00",
                      depDate: "2024-11-16",
                      arrTime: "10:46:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "10:49:00",
                      depDate: "2024-11-16",
                      arrTime: "10:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "10:52:00",
                      depDate: "2024-11-16",
                      arrTime: "10:52:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "10:55:00",
                      depDate: "2024-11-16",
                      arrTime: "10:55:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:05:00",
                      depDate: "2024-11-16",
                      arrTime: "11:05:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Sol, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                      extId: "100018101",
                      routeIdx: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                      depTime: "11:08:00",
                      depDate: "2024-11-16",
                      arrTime: "11:08:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      extId: "100018002",
                      routeIdx: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                      arrTime: "11:13:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                id: "C-1:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT53M",
                dist: 50433,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                    },
                    {
                      order: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  time: "11:13:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  time: "11:17:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161113$202411161117$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 6,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                    {
                      order: 1,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                  ],
                  dist: 6,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:17:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                Destination: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "11:21:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#9#DA#161124#1S#100035608#1T#1054#LS#100035608#LT#1149#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1054#TO#100035608#TT#1149#",
                },
                Freq: {
                  waitMinimum: 6,
                  waitMaximum: 6,
                  alternativeCount: 21,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 152,
                        g: 152,
                        b: 155,
                        hex: "#98989B",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "Consorcio Regional de Transportes de Madrid",
                      nameS: "CRT",
                      nameN: "Consorci",
                      nameL: "Consorcio Regional de Transportes de Madrid",
                      id: "CRTM",
                    },
                    name: "Con 6",
                    internalName: "Con    6",
                    displayNumber: "6",
                    num: "16",
                    line: "6",
                    lineId: "4__6___(CRTM)022",
                    catOut: "Consorci",
                    catIn: "CRT",
                    catCode: "6",
                    cls: "64",
                    catOutS: "CRT",
                    catOutL: "Consorcio Regional de Transportes de Madrid",
                    operatorCode: "CRT",
                    operator: "Consorcio Regional de Transportes de Madrid",
                    admin: "022000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "6",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "NUEVOS MINISTERIOS, Madrid",
                      id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                      extId: "110001007",
                      routeIdx: 11,
                      lon: -3.692409,
                      lat: 40.446622,
                      depTime: "11:17:00",
                      depDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      mainMastExtId: "100018002",
                      mainMastLon: -3.692337,
                      mainMastLat: 40.446613,
                      depDir: "LAGUNA",
                    },
                    {
                      name: "REPUBLICA ARGENTINA, Madrid",
                      id: "A=1@O=REPUBLICA ARGENTINA, Madrid@X=-3684058@Y=40443790@U=80@L=110001005@",
                      extId: "110001005",
                      routeIdx: 12,
                      lon: -3.684058,
                      lat: 40.44379,
                      depTime: "11:19:00",
                      depDate: "2024-11-16",
                      arrTime: "11:19:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "AVENIDA DE AMERICA, Madrid",
                      id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                      extId: "80001004",
                      routeIdx: 13,
                      lon: -3.676579,
                      lat: 40.438037,
                      arrTime: "11:21:00",
                      arrDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      mainMastExtId: "979",
                      mainMastLon: -3.676687,
                      mainMastLat: 40.438028,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#9#DA#161124#1S#100035608#1T#1054#LS#100035608#LT#1149#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1054#TO#100035608#TT#1149#",
                },
                id: "C-1:002",
                idx: 2,
                name: "Con 6",
                number: "6",
                category: "CRT",
                type: "JNY",
                reachable: true,
                direction: "LAGUNA",
                directionFlag: "1",
                duration: "PT4M",
                dist: 1674,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                    {
                      order: 1,
                      lon: -3.684058,
                      lat: 40.44379,
                    },
                    {
                      order: 2,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  time: "11:21:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                Destination: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  time: "11:25:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161121$202411161125$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 9,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                    {
                      order: 1,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                  ],
                  dist: 9,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "11:30:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Via Complutense-Ribera, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                  extId: "100009872",
                  lon: -3.359628,
                  lat: 40.486912,
                  routeIdx: 12,
                  prognosisType: "PROGNOSED",
                  time: "12:02:00",
                  date: "2024-11-16",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170788#TA#1#DA#161124#1S#979#1T#1130#LS#566#LT#1215#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1130#TO#566#TT#1215#",
                },
                Freq: {
                  waitMinimum: 15,
                  waitMaximum: 15,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - 2",
                    num: "8074",
                    line: "ALSA - 2",
                    lineId: "3685(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 12,
                    matchId: "ALSA - 2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Intercambiador de Avenida de América, Madrid",
                      id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      extId: "979",
                      routeIdx: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                      depPrognosisType: "PROGNOSED",
                      depTime: "11:30:00",
                      depDate: "2024-11-16",
                      depDir: "Alcala De Henares",
                    },
                    {
                      name: "Madrid - Puente de la Cea, Madrid",
                      id: "A=1@O=Madrid - Puente de la Cea, Madrid@X=-3651571@Y=40447836@U=80@L=100008495@",
                      extId: "100008495",
                      routeIdx: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                      depTime: "11:33:00",
                      depDate: "2024-11-16",
                      arrTime: "11:33:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Madrid - Metro Canillejas, Madrid",
                      id: "A=1@O=Madrid - Metro Canillejas, Madrid@X=-3609690@Y=40449454@U=80@L=100008528@",
                      extId: "100008528",
                      routeIdx: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                      depTime: "11:36:00",
                      depDate: "2024-11-16",
                      arrTime: "11:36:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Poligono de las Mercedes, Madrid",
                      id: "A=1@O=Poligono de las Mercedes, Madrid@X=-3581051@Y=40449597@U=80@L=100008714@",
                      extId: "100008714",
                      routeIdx: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                      depTime: "11:40:00",
                      depDate: "2024-11-16",
                      arrTime: "11:40:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Colonia Fin de Semana, Madrid",
                      id: "A=1@O=Colonia Fin de Semana, Madrid@X=-3567917@Y=40449400@U=80@L=100008715@",
                      extId: "100008715",
                      routeIdx: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                      depTime: "11:42:00",
                      depDate: "2024-11-16",
                      arrTime: "11:42:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Avenida de Aragon 400, Madrid",
                      id: "A=1@O=Avenida de Aragon 400, Madrid@X=-3558281@Y=40449139@U=80@L=100008716@",
                      extId: "100008716",
                      routeIdx: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                      depTime: "11:43:00",
                      depDate: "2024-11-16",
                      arrTime: "11:43:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Fabrica Iveco-Pegaso, Madrid",
                      id: "A=1@O=Fabrica Iveco-Pegaso, Madrid@X=-3547890@Y=40448105@U=80@L=100008717@",
                      extId: "100008717",
                      routeIdx: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                      depTime: "11:44:00",
                      depDate: "2024-11-16",
                      arrTime: "11:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Zanussi, Alcalá de Henares",
                      id: "A=1@O=Alcala - Zanussi, Alcalá de Henares@X=-3409959@Y=40471468@U=80@L=100008719@",
                      extId: "100008719",
                      routeIdx: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                      depTime: "11:53:00",
                      depDate: "2024-11-16",
                      arrTime: "11:53:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Fiat España, Alcalá de Henares",
                      id: "A=1@O=Alcala - Fiat España, Alcalá de Henares@X=-3395612@Y=40475630@U=80@L=100009127@",
                      extId: "100009127",
                      routeIdx: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                      depTime: "11:54:00",
                      depDate: "2024-11-16",
                      arrTime: "11:54:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 36, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 36, Alcalá de Henares@X=-3383908@Y=40478705@U=80@L=100008720@",
                      extId: "100008720",
                      routeIdx: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                      depTime: "11:56:00",
                      depDate: "2024-11-16",
                      arrTime: "11:56:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 28, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 28, Alcalá de Henares@X=-3375476@Y=40480287@U=80@L=100008721@",
                      extId: "100008721",
                      routeIdx: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                      depTime: "11:58:00",
                      depDate: "2024-11-16",
                      arrTime: "11:58:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 24, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 24, Alcalá de Henares@X=-3366766@Y=40484422@U=80@L=100009259@",
                      extId: "100009259",
                      routeIdx: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                      depTime: "12:00:00",
                      depDate: "2024-11-16",
                      arrTime: "12:00:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Via Complutense-Ribera, Alcalá de Henares",
                      id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                      extId: "100009872",
                      routeIdx: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                      arrTime: "12:02:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170788#TA#1#DA#161124#1S#979#1T#1130#LS#566#LT#1215#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1130#TO#566#TT#1215#",
                },
                id: "C-1:004",
                idx: 4,
                name: "ALSALSA",
                number: "ALSA - 2",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Alcala De Henares",
                directionFlag: "0",
                duration: "PT32M",
                dist: 27755,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                    {
                      order: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                    },
                    {
                      order: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                    },
                    {
                      order: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                    },
                    {
                      order: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                    },
                    {
                      order: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                    },
                    {
                      order: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                    },
                    {
                      order: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                    },
                    {
                      order: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                    },
                    {
                      order: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                    },
                    {
                      order: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                    },
                    {
                      order: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                    },
                    {
                      order: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Via Complutense-Ribera, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                  extId: "100009872",
                  lon: -3.359628,
                  lat: 40.486912,
                  time: "12:02:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "12:18:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|120200|121800|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:005",
                idx: 5,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT16M",
                dist: 1056,
                GisRoute: {
                  dist: 1056,
                  durS: "PT16M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:50:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "12:43:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 4.203004,
            dist: 80951,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. hasta 23. Nov 2024 Sa, Do",
              sDaysB:
                "0000000183040000000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 24,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-2:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:000",
                  },
                  {
                    name: "secIds",
                    value: "C-2:000",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Metro",
                        desc: "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - MetroEste, MetroNorte y MetroSur",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - TFM",
                        price: 200,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Combinado Metro",
                        desc: "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete Suplemento Aeropuerto de un viaje para un adulto",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "022_metro_madri",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2024-4",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona A",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdStart",
                    value: "C-2:002",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona A",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.crtm.es/billetes-y-tarifas.aspx",
                  },
                  {
                    name: "secIds",
                    value: "C-2:002",
                  },
                ],
                name: "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                desc: "Zona A",
                fromLegId: 2,
                toLegId: 2,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$202411161050$202411161143$Ren   C3$$1$$$$$$§W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161143$202411161147$$$1$$$$$$§T$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$202411161147$202411161151$Con    6$$1$$$$$$§W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161151$202411161155$$$1$$$$$$§T$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@$202411161200$202411161234$ALSALSA $$1$$$$$$§G@F$A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161234$202411161243$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9QVCJ9",
          duration: "PT1H53M",
          rtDuration: "PT1H53M",
          checksum: "4ddcc9d8_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:50:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:43:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 11,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                },
                Freq: {
                  waitMinimum: 24,
                  waitMaximum: 30,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "245",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 11,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:50:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:59:00",
                      depDate: "2024-11-16",
                      arrTime: "10:59:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "11:04:00",
                      depDate: "2024-11-16",
                      arrTime: "11:04:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "11:09:00",
                      depDate: "2024-11-16",
                      arrTime: "11:09:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "11:14:00",
                      depDate: "2024-11-16",
                      arrTime: "11:14:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "11:16:00",
                      depDate: "2024-11-16",
                      arrTime: "11:16:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "11:19:00",
                      depDate: "2024-11-16",
                      arrTime: "11:19:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "11:22:00",
                      depDate: "2024-11-16",
                      arrTime: "11:22:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "11:25:00",
                      depDate: "2024-11-16",
                      arrTime: "11:25:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:35:00",
                      depDate: "2024-11-16",
                      arrTime: "11:35:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Sol, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                      extId: "100018101",
                      routeIdx: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                      depTime: "11:38:00",
                      depDate: "2024-11-16",
                      arrTime: "11:38:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      extId: "100018002",
                      routeIdx: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                      arrTime: "11:43:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                },
                id: "C-2:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT53M",
                dist: 50433,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                    },
                    {
                      order: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  time: "11:43:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  time: "11:47:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161143$202411161147$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 6,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                    {
                      order: 1,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                  ],
                  dist: 6,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:47:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                Destination: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "11:51:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#14#DA#161124#1S#100035608#1T#1124#LS#100035608#LT#1219#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1124#TO#100035608#TT#1219#",
                },
                Freq: {
                  waitMinimum: 6,
                  waitMaximum: 6,
                  alternativeCount: 21,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 152,
                        g: 152,
                        b: 155,
                        hex: "#98989B",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "Consorcio Regional de Transportes de Madrid",
                      nameS: "CRT",
                      nameN: "Consorci",
                      nameL: "Consorcio Regional de Transportes de Madrid",
                      id: "CRTM",
                    },
                    name: "Con 6",
                    internalName: "Con    6",
                    displayNumber: "6",
                    num: "16",
                    line: "6",
                    lineId: "4__6___(CRTM)022",
                    catOut: "Consorci",
                    catIn: "CRT",
                    catCode: "6",
                    cls: "64",
                    catOutS: "CRT",
                    catOutL: "Consorcio Regional de Transportes de Madrid",
                    operatorCode: "CRT",
                    operator: "Consorcio Regional de Transportes de Madrid",
                    admin: "022000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "6",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "NUEVOS MINISTERIOS, Madrid",
                      id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                      extId: "110001007",
                      routeIdx: 11,
                      lon: -3.692409,
                      lat: 40.446622,
                      depTime: "11:47:00",
                      depDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      mainMastExtId: "100018002",
                      mainMastLon: -3.692337,
                      mainMastLat: 40.446613,
                      depDir: "LAGUNA",
                    },
                    {
                      name: "REPUBLICA ARGENTINA, Madrid",
                      id: "A=1@O=REPUBLICA ARGENTINA, Madrid@X=-3684058@Y=40443790@U=80@L=110001005@",
                      extId: "110001005",
                      routeIdx: 12,
                      lon: -3.684058,
                      lat: 40.44379,
                      depTime: "11:49:00",
                      depDate: "2024-11-16",
                      arrTime: "11:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "AVENIDA DE AMERICA, Madrid",
                      id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                      extId: "80001004",
                      routeIdx: 13,
                      lon: -3.676579,
                      lat: 40.438037,
                      arrTime: "11:51:00",
                      arrDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      mainMastExtId: "979",
                      mainMastLon: -3.676687,
                      mainMastLat: 40.438028,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#14#DA#161124#1S#100035608#1T#1124#LS#100035608#LT#1219#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1124#TO#100035608#TT#1219#",
                },
                id: "C-2:002",
                idx: 2,
                name: "Con 6",
                number: "6",
                category: "CRT",
                type: "JNY",
                reachable: true,
                direction: "LAGUNA",
                directionFlag: "1",
                duration: "PT4M",
                dist: 1674,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                    {
                      order: 1,
                      lon: -3.684058,
                      lat: 40.44379,
                    },
                    {
                      order: 2,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  time: "11:51:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                Destination: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  time: "11:55:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161151$202411161155$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 9,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                    {
                      order: 1,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                  ],
                  dist: 9,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "12:00:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Alcala - Via Complutense 78, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                  extId: "100009345",
                  lon: -3.354945,
                  lat: 40.489375,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "12:34:00",
                  date: "2024-11-16",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170824#TA#5#DA#161124#1S#979#1T#1200#LS#566#LT#1245#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1200#TO#566#TT#1245#",
                },
                Freq: {
                  waitMinimum: 15,
                  waitMaximum: 15,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - 2",
                    num: "8120",
                    line: "ALSA - 2",
                    lineId: "3685(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 13,
                    matchId: "ALSA - 2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Intercambiador de Avenida de América, Madrid",
                      id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      extId: "979",
                      routeIdx: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                      depPrognosisType: "PROGNOSED",
                      depTime: "12:00:00",
                      depDate: "2024-11-16",
                      depDir: "Alcala De Henares",
                    },
                    {
                      name: "Madrid - Puente de la Cea, Madrid",
                      id: "A=1@O=Madrid - Puente de la Cea, Madrid@X=-3651571@Y=40447836@U=80@L=100008495@",
                      extId: "100008495",
                      routeIdx: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                      depTime: "12:03:00",
                      depDate: "2024-11-16",
                      arrTime: "12:03:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Madrid - Metro Canillejas, Madrid",
                      id: "A=1@O=Madrid - Metro Canillejas, Madrid@X=-3609690@Y=40449454@U=80@L=100008528@",
                      extId: "100008528",
                      routeIdx: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                      depTime: "12:06:00",
                      depDate: "2024-11-16",
                      arrTime: "12:06:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Poligono de las Mercedes, Madrid",
                      id: "A=1@O=Poligono de las Mercedes, Madrid@X=-3581051@Y=40449597@U=80@L=100008714@",
                      extId: "100008714",
                      routeIdx: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                      depTime: "12:10:00",
                      depDate: "2024-11-16",
                      arrTime: "12:10:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Colonia Fin de Semana, Madrid",
                      id: "A=1@O=Colonia Fin de Semana, Madrid@X=-3567917@Y=40449400@U=80@L=100008715@",
                      extId: "100008715",
                      routeIdx: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                      depTime: "12:12:00",
                      depDate: "2024-11-16",
                      arrTime: "12:12:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Avenida de Aragon 400, Madrid",
                      id: "A=1@O=Avenida de Aragon 400, Madrid@X=-3558281@Y=40449139@U=80@L=100008716@",
                      extId: "100008716",
                      routeIdx: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                      depTime: "12:13:00",
                      depDate: "2024-11-16",
                      arrTime: "12:13:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Fabrica Iveco-Pegaso, Madrid",
                      id: "A=1@O=Fabrica Iveco-Pegaso, Madrid@X=-3547890@Y=40448105@U=80@L=100008717@",
                      extId: "100008717",
                      routeIdx: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                      depTime: "12:14:00",
                      depDate: "2024-11-16",
                      arrTime: "12:14:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Zanussi, Alcalá de Henares",
                      id: "A=1@O=Alcala - Zanussi, Alcalá de Henares@X=-3409959@Y=40471468@U=80@L=100008719@",
                      extId: "100008719",
                      routeIdx: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                      depTime: "12:23:00",
                      depDate: "2024-11-16",
                      arrTime: "12:23:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Fiat España, Alcalá de Henares",
                      id: "A=1@O=Alcala - Fiat España, Alcalá de Henares@X=-3395612@Y=40475630@U=80@L=100009127@",
                      extId: "100009127",
                      routeIdx: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                      depTime: "12:24:00",
                      depDate: "2024-11-16",
                      arrTime: "12:24:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 36, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 36, Alcalá de Henares@X=-3383908@Y=40478705@U=80@L=100008720@",
                      extId: "100008720",
                      routeIdx: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                      depTime: "12:26:00",
                      depDate: "2024-11-16",
                      arrTime: "12:26:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 28, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 28, Alcalá de Henares@X=-3375476@Y=40480287@U=80@L=100008721@",
                      extId: "100008721",
                      routeIdx: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                      depTime: "12:28:00",
                      depDate: "2024-11-16",
                      arrTime: "12:28:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 24, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 24, Alcalá de Henares@X=-3366766@Y=40484422@U=80@L=100009259@",
                      extId: "100009259",
                      routeIdx: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                      depTime: "12:30:00",
                      depDate: "2024-11-16",
                      arrTime: "12:30:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Via Complutense-Ribera, Alcalá de Henares",
                      id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                      extId: "100009872",
                      routeIdx: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                      depTime: "12:32:00",
                      depDate: "2024-11-16",
                      arrTime: "12:32:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 78, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                      extId: "100009345",
                      routeIdx: 13,
                      lon: -3.354945,
                      lat: 40.489375,
                      arrTime: "12:34:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170824#TA#5#DA#161124#1S#979#1T#1200#LS#566#LT#1245#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1200#TO#566#TT#1245#",
                },
                id: "C-2:004",
                idx: 4,
                name: "ALSALSA",
                number: "ALSA - 2",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Alcala De Henares",
                directionFlag: "0",
                duration: "PT34M",
                dist: 28237,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                    {
                      order: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                    },
                    {
                      order: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                    },
                    {
                      order: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                    },
                    {
                      order: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                    },
                    {
                      order: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                    },
                    {
                      order: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                    },
                    {
                      order: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                    },
                    {
                      order: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                    },
                    {
                      order: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                    },
                    {
                      order: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                    },
                    {
                      order: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                    },
                    {
                      order: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                    },
                    {
                      order: 13,
                      lon: -3.354945,
                      lat: 40.489375,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Alcala - Via Complutense 78, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@X=-3354945@Y=40489375@U=80@L=100009345@",
                  extId: "100009345",
                  lon: -3.354945,
                  lat: 40.489375,
                  time: "12:34:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "12:43:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Alcala - Via Complutense 78, Alcalá de Henares@L=100009345@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|123400|124300|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:005",
                idx: 5,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT9M",
                dist: 592,
                GisRoute: {
                  dist: 592,
                  durS: "PT9M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:50:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "12:48:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 4.16348,
            dist: 80933,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. hasta 23. Nov 2024 Sa, Do",
              sDaysB:
                "0000000183040000000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 24,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TWlJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMiIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-3:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:000",
                  },
                  {
                    name: "secIds",
                    value: "C-3:000",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Metro",
                        desc: "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - MetroEste, MetroNorte y MetroSur",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - TFM",
                        price: 200,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Combinado Metro",
                        desc: "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete Suplemento Aeropuerto de un viaje para un adulto",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "022_metro_madri",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2024-4",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona A",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdStart",
                    value: "C-3:002",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona A",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.crtm.es/billetes-y-tarifas.aspx",
                  },
                  {
                    name: "secIds",
                    value: "C-3:002",
                  },
                ],
                name: "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                desc: "Zona A",
                fromLegId: 2,
                toLegId: 2,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
          },
          idx: 3,
          tripId: "C-3",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$202411161050$202411161143$Ren   C3$$1$$$$$$§W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161143$202411161147$$$1$$$$$$§T$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$202411161147$202411161151$Con    6$$1$$$$$$§W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161151$202411161155$$$1$$$$$$§T$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@$202411161200$202411161232$ALSALSA $$1$$$$$$§G@F$A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161232$202411161248$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9QVCJ9",
          duration: "PT1H58M",
          rtDuration: "PT1H58M",
          checksum: "903ee07f_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:50:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:43:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 11,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                },
                Freq: {
                  waitMinimum: 24,
                  waitMaximum: 30,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "245",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 11,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:50:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:59:00",
                      depDate: "2024-11-16",
                      arrTime: "10:59:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "11:04:00",
                      depDate: "2024-11-16",
                      arrTime: "11:04:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "11:09:00",
                      depDate: "2024-11-16",
                      arrTime: "11:09:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "11:14:00",
                      depDate: "2024-11-16",
                      arrTime: "11:14:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "11:16:00",
                      depDate: "2024-11-16",
                      arrTime: "11:16:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "11:19:00",
                      depDate: "2024-11-16",
                      arrTime: "11:19:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "11:22:00",
                      depDate: "2024-11-16",
                      arrTime: "11:22:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "11:25:00",
                      depDate: "2024-11-16",
                      arrTime: "11:25:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:35:00",
                      depDate: "2024-11-16",
                      arrTime: "11:35:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Sol, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                      extId: "100018101",
                      routeIdx: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                      depTime: "11:38:00",
                      depDate: "2024-11-16",
                      arrTime: "11:38:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      extId: "100018002",
                      routeIdx: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                      arrTime: "11:43:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                },
                id: "C-3:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT53M",
                dist: 50433,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 10,
                      lon: -3.703214,
                      lat: 40.416877,
                    },
                    {
                      order: 11,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid-Nuevos Ministerios, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  extId: "100018002",
                  lon: -3.692337,
                  lat: 40.446613,
                  time: "11:43:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  time: "11:47:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@L=100018002@a=128@$A=1@O=NUEVOS MINISTERIOS, Madrid@L=110001007@a=128@$202411161143$202411161147$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 6,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692337,
                      lat: 40.446613,
                    },
                    {
                      order: 1,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                  ],
                  dist: 6,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "NUEVOS MINISTERIOS, Madrid",
                  type: "ST",
                  id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                  extId: "110001007",
                  lon: -3.692409,
                  lat: 40.446622,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "11:47:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                  mainMastExtId: "100018002",
                  mainMastLon: -3.692337,
                  mainMastLat: 40.446613,
                },
                Destination: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "11:51:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#14#DA#161124#1S#100035608#1T#1124#LS#100035608#LT#1219#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1124#TO#100035608#TT#1219#",
                },
                Freq: {
                  waitMinimum: 6,
                  waitMaximum: 6,
                  alternativeCount: 21,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 152,
                        g: 152,
                        b: 155,
                        hex: "#98989B",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "Consorcio Regional de Transportes de Madrid",
                      nameS: "CRT",
                      nameN: "Consorci",
                      nameL: "Consorcio Regional de Transportes de Madrid",
                      id: "CRTM",
                    },
                    name: "Con 6",
                    internalName: "Con    6",
                    displayNumber: "6",
                    num: "16",
                    line: "6",
                    lineId: "4__6___(CRTM)022",
                    catOut: "Consorci",
                    catIn: "CRT",
                    catCode: "6",
                    cls: "64",
                    catOutS: "CRT",
                    catOutL: "Consorcio Regional de Transportes de Madrid",
                    operatorCode: "CRT",
                    operator: "Consorcio Regional de Transportes de Madrid",
                    admin: "022000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "6",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "NUEVOS MINISTERIOS, Madrid",
                      id: "A=1@O=NUEVOS MINISTERIOS, Madrid@X=-3692409@Y=40446622@U=80@L=110001007@",
                      extId: "110001007",
                      routeIdx: 11,
                      lon: -3.692409,
                      lat: 40.446622,
                      depTime: "11:47:00",
                      depDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid-Nuevos Ministerios, Madrid@X=-3692337@Y=40446613@U=80@L=100018002@",
                      mainMastExtId: "100018002",
                      mainMastLon: -3.692337,
                      mainMastLat: 40.446613,
                      depDir: "LAGUNA",
                    },
                    {
                      name: "REPUBLICA ARGENTINA, Madrid",
                      id: "A=1@O=REPUBLICA ARGENTINA, Madrid@X=-3684058@Y=40443790@U=80@L=110001005@",
                      extId: "110001005",
                      routeIdx: 12,
                      lon: -3.684058,
                      lat: 40.44379,
                      depTime: "11:49:00",
                      depDate: "2024-11-16",
                      arrTime: "11:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "AVENIDA DE AMERICA, Madrid",
                      id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                      extId: "80001004",
                      routeIdx: 13,
                      lon: -3.676579,
                      lat: 40.438037,
                      arrTime: "11:51:00",
                      arrDate: "2024-11-16",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      mainMastExtId: "979",
                      mainMastLon: -3.676687,
                      mainMastLat: 40.438028,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#107386#TA#14#DA#161124#1S#100035608#1T#1124#LS#100035608#LT#1219#PU#80#RT#1#CA#CRT#ZE#6#ZB#Con    6#PC#6#FR#100035608#FT#1124#TO#100035608#TT#1219#",
                },
                id: "C-3:002",
                idx: 2,
                name: "Con 6",
                number: "6",
                category: "CRT",
                type: "JNY",
                reachable: true,
                direction: "LAGUNA",
                directionFlag: "1",
                duration: "PT4M",
                dist: 1674,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.692409,
                      lat: 40.446622,
                    },
                    {
                      order: 1,
                      lon: -3.684058,
                      lat: 40.44379,
                    },
                    {
                      order: 2,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "AVENIDA DE AMERICA, Madrid",
                  type: "ST",
                  id: "A=1@O=AVENIDA DE AMERICA, Madrid@X=-3676579@Y=40438037@U=80@L=80001004@",
                  extId: "80001004",
                  lon: -3.676579,
                  lat: 40.438037,
                  time: "11:51:00",
                  date: "2024-11-16",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  mainMastExtId: "979",
                  mainMastLon: -3.676687,
                  mainMastLat: 40.438028,
                },
                Destination: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  time: "11:55:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=AVENIDA DE AMERICA, Madrid@L=80001004@a=128@$A=1@O=Intercambiador de Avenida de América, Madrid@L=979@a=128@$202411161151$202411161155$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT4M",
                dist: 9,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676579,
                      lat: 40.438037,
                    },
                    {
                      order: 1,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                  ],
                  dist: 9,
                  durS: "PT4M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "Intercambiador de Avenida de América, Madrid",
                  type: "ST",
                  id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                  extId: "979",
                  lon: -3.676687,
                  lat: 40.438028,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "12:00:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Via Complutense-Ribera, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                  extId: "100009872",
                  lon: -3.359628,
                  lat: 40.486912,
                  routeIdx: 12,
                  prognosisType: "PROGNOSED",
                  time: "12:32:00",
                  date: "2024-11-16",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170824#TA#5#DA#161124#1S#979#1T#1200#LS#566#LT#1245#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1200#TO#566#TT#1245#",
                },
                Freq: {
                  waitMinimum: 15,
                  waitMaximum: 15,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 39,
                        b: 134,
                        hex: "#002786",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "ALSA",
                      nameS: "300",
                      nameN: "ALSA",
                      nameL: "ALSA",
                      id: "300",
                    },
                    name: "ALSALSA",
                    internalName: "ALSALSA ",
                    displayNumber: "ALSA - 2",
                    num: "8120",
                    line: "ALSA - 2",
                    lineId: "3685(300)031",
                    catOut: "ALSA",
                    catIn: "300",
                    catCode: "8",
                    cls: "256",
                    catOutS: "300",
                    catOutL: "ALSA",
                    operatorCode: "300",
                    operator: "ALSA",
                    admin: "031000",
                    routeIdxFrom: 0,
                    routeIdxTo: 12,
                    matchId: "ALSA - 2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Intercambiador de Avenida de América, Madrid",
                      id: "A=1@O=Intercambiador de Avenida de América, Madrid@X=-3676687@Y=40438028@U=80@L=979@",
                      extId: "979",
                      routeIdx: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                      depPrognosisType: "PROGNOSED",
                      depTime: "12:00:00",
                      depDate: "2024-11-16",
                      depDir: "Alcala De Henares",
                    },
                    {
                      name: "Madrid - Puente de la Cea, Madrid",
                      id: "A=1@O=Madrid - Puente de la Cea, Madrid@X=-3651571@Y=40447836@U=80@L=100008495@",
                      extId: "100008495",
                      routeIdx: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                      depTime: "12:03:00",
                      depDate: "2024-11-16",
                      arrTime: "12:03:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Madrid - Metro Canillejas, Madrid",
                      id: "A=1@O=Madrid - Metro Canillejas, Madrid@X=-3609690@Y=40449454@U=80@L=100008528@",
                      extId: "100008528",
                      routeIdx: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                      depTime: "12:06:00",
                      depDate: "2024-11-16",
                      arrTime: "12:06:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Poligono de las Mercedes, Madrid",
                      id: "A=1@O=Poligono de las Mercedes, Madrid@X=-3581051@Y=40449597@U=80@L=100008714@",
                      extId: "100008714",
                      routeIdx: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                      depTime: "12:10:00",
                      depDate: "2024-11-16",
                      arrTime: "12:10:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Colonia Fin de Semana, Madrid",
                      id: "A=1@O=Colonia Fin de Semana, Madrid@X=-3567917@Y=40449400@U=80@L=100008715@",
                      extId: "100008715",
                      routeIdx: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                      depTime: "12:12:00",
                      depDate: "2024-11-16",
                      arrTime: "12:12:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Avenida de Aragon 400, Madrid",
                      id: "A=1@O=Avenida de Aragon 400, Madrid@X=-3558281@Y=40449139@U=80@L=100008716@",
                      extId: "100008716",
                      routeIdx: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                      depTime: "12:13:00",
                      depDate: "2024-11-16",
                      arrTime: "12:13:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Fabrica Iveco-Pegaso, Madrid",
                      id: "A=1@O=Fabrica Iveco-Pegaso, Madrid@X=-3547890@Y=40448105@U=80@L=100008717@",
                      extId: "100008717",
                      routeIdx: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                      depTime: "12:14:00",
                      depDate: "2024-11-16",
                      arrTime: "12:14:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Zanussi, Alcalá de Henares",
                      id: "A=1@O=Alcala - Zanussi, Alcalá de Henares@X=-3409959@Y=40471468@U=80@L=100008719@",
                      extId: "100008719",
                      routeIdx: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                      depTime: "12:23:00",
                      depDate: "2024-11-16",
                      arrTime: "12:23:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Fiat España, Alcalá de Henares",
                      id: "A=1@O=Alcala - Fiat España, Alcalá de Henares@X=-3395612@Y=40475630@U=80@L=100009127@",
                      extId: "100009127",
                      routeIdx: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                      depTime: "12:24:00",
                      depDate: "2024-11-16",
                      arrTime: "12:24:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 36, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 36, Alcalá de Henares@X=-3383908@Y=40478705@U=80@L=100008720@",
                      extId: "100008720",
                      routeIdx: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                      depTime: "12:26:00",
                      depDate: "2024-11-16",
                      arrTime: "12:26:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Avenida Madrid 28, Alcalá de Henares",
                      id: "A=1@O=Alcala - Avenida Madrid 28, Alcalá de Henares@X=-3375476@Y=40480287@U=80@L=100008721@",
                      extId: "100008721",
                      routeIdx: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                      depTime: "12:28:00",
                      depDate: "2024-11-16",
                      arrTime: "12:28:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Alcala - Via Complutense 24, Alcalá de Henares",
                      id: "A=1@O=Alcala - Via Complutense 24, Alcalá de Henares@X=-3366766@Y=40484422@U=80@L=100009259@",
                      extId: "100009259",
                      routeIdx: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                      depTime: "12:30:00",
                      depDate: "2024-11-16",
                      arrTime: "12:30:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      name: "Via Complutense-Ribera, Alcalá de Henares",
                      id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                      extId: "100009872",
                      routeIdx: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                      arrTime: "12:32:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#170824#TA#5#DA#161124#1S#979#1T#1200#LS#566#LT#1245#PU#80#RT#1#CA#300#ZE#ALSA - 2#ZB#ALSALSA #PC#8#FR#979#FT#1200#TO#566#TT#1245#",
                },
                id: "C-3:004",
                idx: 4,
                name: "ALSALSA",
                number: "ALSA - 2",
                category: "300",
                type: "JNY",
                reachable: true,
                direction: "Alcala De Henares",
                directionFlag: "0",
                duration: "PT32M",
                dist: 27755,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.676687,
                      lat: 40.438028,
                    },
                    {
                      order: 1,
                      lon: -3.651571,
                      lat: 40.447836,
                    },
                    {
                      order: 2,
                      lon: -3.60969,
                      lat: 40.449454,
                    },
                    {
                      order: 3,
                      lon: -3.581051,
                      lat: 40.449597,
                    },
                    {
                      order: 4,
                      lon: -3.567917,
                      lat: 40.4494,
                    },
                    {
                      order: 5,
                      lon: -3.558281,
                      lat: 40.449139,
                    },
                    {
                      order: 6,
                      lon: -3.54789,
                      lat: 40.448105,
                    },
                    {
                      order: 7,
                      lon: -3.409959,
                      lat: 40.471468,
                    },
                    {
                      order: 8,
                      lon: -3.395612,
                      lat: 40.47563,
                    },
                    {
                      order: 9,
                      lon: -3.383908,
                      lat: 40.478705,
                    },
                    {
                      order: 10,
                      lon: -3.375476,
                      lat: 40.480287,
                    },
                    {
                      order: 11,
                      lon: -3.366766,
                      lat: 40.484422,
                    },
                    {
                      order: 12,
                      lon: -3.359628,
                      lat: 40.486912,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Via Complutense-Ribera, Alcalá de Henares",
                  type: "ST",
                  id: "A=1@O=Via Complutense-Ribera, Alcalá de Henares@X=-3359628@Y=40486912@U=80@L=100009872@",
                  extId: "100009872",
                  lon: -3.359628,
                  lat: 40.486912,
                  time: "12:32:00",
                  date: "2024-11-16",
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "12:48:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Via Complutense-Ribera, Alcalá de Henares@L=100009872@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|123200|124800|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:005",
                idx: 5,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT16M",
                dist: 1056,
                GisRoute: {
                  dist: 1056,
                  durS: "PT16M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:20:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "11:52:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 6.641749000000001,
            dist: 83184,
            type: "PTM",
            rating: 2,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. Nov hasta 1. Dic 2024 Sa, Do; también 6. Dic",
              sDaysB:
                "0000000183060C20000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 12,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "4",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Standard",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMDMzNjk1YWItZGE2OS00YTU5LTlhNWItNWQzZTEyYjIwMWQwIiwicHJpY2UiOjQwLjE4MDI5OTk5OTk5OTk5NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1ETXpOamsxWVdJdFpHRTJPUzAwWVRVNUxUbGhOV0l0TldRelpURXlZakl3TVdRd0lpd2ljSEpwWTJVaU9qUXdMakU0TURJNU9UazVPVGs1T1RrNU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Standard",
                        price: 4018,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMDMzNjk1YWItZGE2OS00YTU5LTlhNWItNWQzZTEyYjIwMWQwIiwicHJpY2UiOjQwLjE4MDI5OTk5OTk5OTk5NSwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "5",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "VTC Executive",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNzU3NDg1ZGMtN2U5Ni00OWZlLWIwNTEtZTY4OTQzZjgxNjUwIiwicHJpY2UiOjQ3LjYxNjg5OTk5OTk5OTk5NCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU56VTNORGcxWkdNdE4yVTVOaTAwT1dabExXSXdOVEV0WlRZNE9UUXpaamd4TmpVd0lpd2ljSEpwWTJVaU9qUTNMall4TmpnNU9UazVPVGs1T1RrNU5Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi VTC Executive",
                        price: 4762,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNzU3NDg1ZGMtN2U5Ni00OWZlLWIwNTEtZTY4OTQzZjgxNjUwIiwicHJpY2UiOjQ3LjYxNjg5OTk5OTk5OTk5NCwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "9",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNTJhYjRiZGMtOWFmNS00NzFlLWJlZjYtZDgxMjhiZjAwZGRhIiwicHJpY2UiOjUzLjA3NTkwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU5USmhZalJpWkdNdE9XRm1OUzAwTnpGbExXSmxaall0WkRneE1qaGlaakF3WkdSaElpd2ljSEpwWTJVaU9qVXpMakEzTlRrd01EQXdNREF3TURBd05Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan 7pax",
                        price: 5308,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiNTJhYjRiZGMtOWFmNS00NzFlLWJlZjYtZDgxMjhiZjAwZGRhIiwicHJpY2UiOjUzLjA3NTkwMDAwMDAwMDAwNCwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "10",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Minivan EXECUTIVE 7pax",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMjExM2JjZDItY2Y1MC00NjliLTlhYzAtOTlhZjBiODMxYWNhIiwicHJpY2UiOjYxLjI2NDM5OTk5OTk5OTk5NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHlNU0lzSW1KMVpHZGxkRWxrSWpvaU1qRXhNMkpqWkRJdFkyWTFNQzAwTmpsaUxUbGhZekF0T1RsaFpqQmlPRE14WVdOaElpd2ljSEpwWTJVaU9qWXhMakkyTkRNNU9UazVPVGs1T1RrNU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Movitaxi Minivan EXECUTIVE 7pax",
                        price: 6126,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4yMSIsImJ1ZGdldElkIjoiMjExM2JjZDItY2Y1MC00NjliLTlhYzAtOTlhZjBiODMxYWNhIiwicHJpY2UiOjYxLjI2NDM5OTk5OTk5OTk5NSwiY3VycmVuY3kiOiJFVVIifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:002",
                  },
                  {
                    name: "secIds",
                    value: "C-0:002",
                  },
                ],
                name: "Movitaxi Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSTNNREV3TVNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSTNNREV3TVNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:001",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000 C-0:001",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 1,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias,bolt",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202411161020$202411161105$Ren   C3$$1$$$$$$§T$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@$202411161110$202411161132$Ren   C7$$1$$$$$$§G@T$A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161132$202411161152$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT1H32M",
          rtDuration: "PT1H32M",
          checksum: "6b83ef0a_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:20:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  extId: "100018000",
                  lon: -3.688957,
                  lat: 40.406153,
                  routeIdx: 9,
                  prognosisType: "PROGNOSED",
                  time: "11:05:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 9,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "10:50:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "11:35:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "245",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "11:20:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:05:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#3#DA#161124#1S#100060200#1T#1120#LS#100017000#LT#1219#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1120#TO#100017000#TT#1219#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "184",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 10,
                            lon: -3.61823,
                            lat: 40.034862,
                            depTime: "11:43:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            name: "Estación de tren Madrid - Atocha Cercanias, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanias, Madrid@X=-3688957@Y=40406153@U=80@L=300018000@",
                            extId: "300018000",
                            routeIdx: 11,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:13:00",
                            arrDate: "2024-11-16",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            mainMastExtId: "100018000",
                            mainMastLon: -3.688957,
                            mainMastLat: 40.406153,
                            entry: true,
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#117116#TA#0#DA#161124#1S#100003100#1T#832#LS#100017000#LT#1227#PU#80#RT#1#CA#107#ZE#MD#ZB#REN   MD#PC#2#FR#100003100#FT#832#TO#100017000#TT#1227#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN MD",
                        internalName: "REN   MD",
                        displayNumber: "MD",
                        num: "1588",
                        line: "MD",
                        lineId: "0310017000VRX(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "MD",
                      },
                      name: "REN MD",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "MD",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "11:50:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:35:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#4#DA#161124#1S#100060200#1T#1150#LS#100017000#LT#1249#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1150#TO#100017000#TT#1249#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "247",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "12:20:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "13:05:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#5#DA#161124#1S#100060200#1T#1220#LS#100017000#LT#1319#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1220#TO#100017000#TT#1319#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "186",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 7,
                  waitMaximum: 30,
                  alternativeCount: 6,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "182",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 9,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:20:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:29:00",
                      depDate: "2024-11-16",
                      arrTime: "10:29:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "10:34:00",
                      depDate: "2024-11-16",
                      arrTime: "10:34:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "10:39:00",
                      depDate: "2024-11-16",
                      arrTime: "10:39:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "10:44:00",
                      depDate: "2024-11-16",
                      arrTime: "10:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "10:46:00",
                      depDate: "2024-11-16",
                      arrTime: "10:46:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "10:49:00",
                      depDate: "2024-11-16",
                      arrTime: "10:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "10:52:00",
                      depDate: "2024-11-16",
                      arrTime: "10:52:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "10:55:00",
                      depDate: "2024-11-16",
                      arrTime: "10:55:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      arrTime: "11:05:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                id: "C-0:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT45M",
                dist: 45301,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  extId: "100018000",
                  lon: -3.688957,
                  lat: 40.406153,
                  routeIdx: 12,
                  prognosisType: "PROGNOSED",
                  time: "11:10:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren San Fernando Henares, Coslada",
                  type: "ST",
                  id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                  extId: "100070101",
                  lon: -3.53446,
                  lat: 40.442541,
                  routeIdx: 19,
                  prognosisType: "PROGNOSED",
                  time: "11:32:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 12,
                      routeIdxTo: 19,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#113746#TA#2#DA#161124#1S#100010000#1T#1013#LS#100070103#LT#1150#PU#80#RT#1#CA#107#ZE#C7#ZB#Ren   C7#PC#2#FR#100010000#FT#1013#TO#100070103#TT#1150#",
                },
                Freq: {
                  waitMinimum: 12,
                  waitMaximum: 18,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 243,
                        g: 151,
                        b: 42,
                        hex: "#F3972A",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C7",
                    internalName: "Ren   C7",
                    displayNumber: "C7",
                    num: "1869",
                    line: "C7",
                    lineId: "10T0051C7(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 12,
                    routeIdxTo: 19,
                    matchId: "C7",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 12,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:10:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Alcala De Henares, Alcalá de Henares",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Asamblea De Mad. Entrevías, Madrid",
                      id: "A=1@O=Estación de tren Asamblea De Mad. Entrevías, Madrid@X=-3667985@Y=40381621@U=80@L=100070002@",
                      extId: "100070002",
                      routeIdx: 13,
                      lon: -3.667985,
                      lat: 40.381621,
                      depTime: "11:15:00",
                      depDate: "2024-11-16",
                      arrTime: "11:15:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren El Pozo, Madrid",
                      id: "A=1@O=Estación de tren El Pozo, Madrid@X=-3656237@Y=40376057@U=80@L=100070003@",
                      extId: "100070003",
                      routeIdx: 14,
                      lon: -3.656237,
                      lat: 40.376057,
                      depTime: "11:17:00",
                      depDate: "2024-11-16",
                      arrTime: "11:17:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Vallecas, Madrid",
                      id: "A=1@O=Estación de tren Vallecas, Madrid@X=-3624684@Y=40382044@U=80@L=100070001@",
                      extId: "100070001",
                      routeIdx: 15,
                      lon: -3.624684,
                      lat: 40.382044,
                      depTime: "11:20:00",
                      depDate: "2024-11-16",
                      arrTime: "11:20:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Santa Eugenia, Madrid",
                      id: "A=1@O=Estación de tren Santa Eugenia, Madrid@X=-3608962@Y=40386916@U=80@L=100070109@",
                      extId: "100070109",
                      routeIdx: 16,
                      lon: -3.608962,
                      lat: 40.386916,
                      depTime: "11:22:00",
                      depDate: "2024-11-16",
                      arrTime: "11:22:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Vicálvaro, Madrid",
                      id: "A=1@O=Estación de tren Vicálvaro, Madrid@X=-3595982@Y=40401209@U=80@L=100070100@",
                      extId: "100070100",
                      routeIdx: 17,
                      lon: -3.595982,
                      lat: 40.401209,
                      depTime: "11:25:00",
                      depDate: "2024-11-16",
                      arrTime: "11:25:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Coslada (apd), Coslada",
                      id: "A=1@O=Estación de tren Coslada (apd), Coslada@X=-3561113@Y=40423223@U=80@L=100070108@",
                      extId: "100070108",
                      routeIdx: 18,
                      lon: -3.561113,
                      lat: 40.423223,
                      depTime: "11:28:00",
                      depDate: "2024-11-16",
                      arrTime: "11:28:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Fernando Henares, Coslada",
                      id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                      extId: "100070101",
                      routeIdx: 19,
                      lon: -3.53446,
                      lat: 40.442541,
                      arrTime: "11:32:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#113746#TA#2#DA#161124#1S#100010000#1T#1013#LS#100070103#LT#1150#PU#80#RT#1#CA#107#ZE#C7#ZB#Ren   C7#PC#2#FR#100010000#FT#1013#TO#100070103#TT#1150#",
                },
                id: "C-0:001",
                idx: 1,
                name: "Ren C7",
                number: "C7",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Alcala De Henares, Alcalá de Henares",
                directionFlag: "0",
                duration: "PT22M",
                dist: 17508,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 1,
                      lon: -3.667985,
                      lat: 40.381621,
                    },
                    {
                      order: 2,
                      lon: -3.656237,
                      lat: 40.376057,
                    },
                    {
                      order: 3,
                      lon: -3.624684,
                      lat: 40.382044,
                    },
                    {
                      order: 4,
                      lon: -3.608962,
                      lat: 40.386916,
                    },
                    {
                      order: 5,
                      lon: -3.595982,
                      lat: 40.401209,
                    },
                    {
                      order: 6,
                      lon: -3.561113,
                      lat: 40.423223,
                    },
                    {
                      order: 7,
                      lon: -3.53446,
                      lat: 40.442541,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Estación de tren San Fernando Henares, Coslada",
                  type: "ST",
                  id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                  extId: "100070101",
                  lon: -3.53446,
                  lat: 40.442541,
                  time: "11:32:00",
                  date: "2024-11-16",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "11:52:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|113200|115200|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Movitaxi",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:002",
                idx: 2,
                name: "Movitaxi",
                type: "TAXI",
                duration: "PT20M",
                dist: 20375,
                GisRoute: {
                  dist: 20375,
                  durS: "PT20M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            Notes: {
              Note: [
                {
                  value: "not accessible by wheelchair",
                  key: "WN",
                  type: "A",
                  priority: 0,
                  txtN: "not accessible by wheelchair",
                },
              ],
            },
            name: "Estación de tren Aranjuez, Aranjuez",
            type: "ST",
            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
            extId: "100060200",
            lon: -3.61823,
            lat: 40.034862,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "10:20:00",
            date: "2024-11-16",
          },
          Destination: {
            name: "Calle Luis Madrona 8",
            description: "Alcalá de Henares",
            type: "ADR",
            id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
            extId: "980021459",
            lon: -3.349731,
            lat: 40.489635,
            time: "11:52:00",
            date: "2024-11-16",
          },
          Eco: {
            co2: 6.641749000000001,
            dist: 83184,
            type: "PTM",
            rating: 2,
          },
          EcoCmp: [
            {
              co2: 10.326378523527508,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2024-10-09",
              planningPeriodEnd: "2025-08-05",
              sDaysR: "no cada día",
              sDaysI: "16. Nov hasta 1. Dic 2024 Sa, Do; también 6. Dic",
              sDaysB:
                "0000000183060C20000000000000000000000000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 12,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "31",
                          },
                          {
                            name: "estimateHigh",
                            value: "31",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDgyLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TkRneUxDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "business",
                        price: 3138,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDgyLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "19",
                          },
                          {
                            name: "estimateHigh",
                            value: "19",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg0LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TkRnMExDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "standard",
                        price: 1905,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg0LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "44",
                          },
                          {
                            name: "estimateHigh",
                            value: "44",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg2LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TkRnMkxDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "van",
                        price: 4415,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg2LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "21",
                          },
                          {
                            name: "estimateHigh",
                            value: "21",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwODY5LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3T0RZNUxDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "other",
                        price: 2105,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwODY5LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "31",
                          },
                          {
                            name: "estimateHigh",
                            value: "31",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNzE2LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TnpFMkxDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "comfort",
                        price: 3135,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNzE2LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "23",
                          },
                          {
                            name: "estimateHigh",
                            value: "23",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNzIwLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TnpJd0xDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "electric",
                        price: 2300,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNzIwLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "38",
                          },
                          {
                            name: "estimateHigh",
                            value: "38",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg4LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3TkRnNExDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "premium",
                        price: 3827,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwNDg4LCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "21",
                          },
                          {
                            name: "estimateHigh",
                            value: "21",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwODcyLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pWW05c2RDSXNJblpsY25OcGIyNGlPaUl4TGpJeElpd2lkbVZvYVdOc1pVTmhkR1ZuYjNKNVNXUWlPakV3T0RjeUxDSndhV05yVlhCVWFXMWxJam9pTWpBeU5DMHhNUzB4TmxReE1Ub3pNam93TUNzd01Ub3dNQ0lzSW05eWFXZHBiaUk2ZXlKMGVYQmxJam9pVUc5cGJuUWlMQ0pqYjI5eVpHbHVZWFJsY3lJNld5MHpMalV6TkRRMkxEUXdMalEwTWpVME1WMTlMQ0prWlhOMGFXNWhkR2x2YmlJNmV5SjBlWEJsSWpvaVVHOXBiblFpTENKamIyOXlaR2x1WVhSbGN5STZXeTB6TGpNME9UY3pNU3cwTUM0ME9EazJNelZkZlN3aVpYTjBhVzFoZEdsdmJsTnZkWEpqWlNJNklsTkRTRVZFVlV4RlJGOUZVMVJKVFVGVVNVOU9VeUo5",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "child_seat",
                        price: 2105,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoiYm9sdCIsInZlcnNpb24iOiIxLjIxIiwidmVoaWNsZUNhdGVnb3J5SWQiOjEwODcyLCJwaWNrVXBUaW1lIjoiMjAyNC0xMS0xNlQxMTozMjowMCswMTowMCIsIm9yaWdpbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjUzNDQ2LDQwLjQ0MjU0MV19LCJkZXN0aW5hdGlvbiI6eyJ0eXBlIjoiUG9pbnQiLCJjb29yZGluYXRlcyI6Wy0zLjM0OTczMSw0MC40ODk2MzVdfSwiZXN0aW1hdGlvblNvdXJjZSI6IlNDSEVEVUxFRF9FU1RJTUFUSU9OUyJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Bolt Pricing",
                  },
                  {
                    name: "providerId",
                    value: "bolt",
                  },
                  {
                    name: "secId",
                    value: "C-0:002",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:002",
                  },
                  {
                    name: "secIds",
                    value: "C-0:002",
                  },
                ],
                name: "Bolt Pricing",
                fromLegId: 2,
                toLegId: 2,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "ida/regreso",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSTNNREV3TVNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvNExqRXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "ida/regreso",
                        desc: "ida/regreso",
                        price: 810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjo4LjEsImN1cnJlbmN5IjoiRVVSIn0=",
                      },
                      {
                        param: [
                          {
                            name: "DESCRIPTION",
                            value: "Sencillo",
                          },
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "PRICE",
                            value: "405",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJMk1ESXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSTNNREV3TVNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1URXhOaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpvMExqQTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Sencillo",
                        desc: "Sencillo",
                        price: 405,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiI2MDIwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiI3MDEwMSIsImZlY2hhVmlhamUiOiIyMDI0MTExNiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjo0LjA1LCJjdXJyZW5jeSI6IkVVUiJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe Cercanias Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe Cercanias",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:001",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000 C-0:001",
                  },
                ],
                name: "Renfe Cercanias Pricing",
                fromLegId: 0,
                toLegId: 1,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe Cercanias,bolt",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Aranjuez, Aranjuez@L=100060200@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202411161020$202411161105$Ren   C3$$1$$$$$$§T$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@$202411161110$202411161132$Ren   C7$$1$$$$$$§G@T$A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@$A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@$202411161132$202411161152$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1RBWEkifQ==",
          duration: "PT1H32M",
          rtDuration: "PT1H32M",
          checksum: "6b83ef0a_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren Aranjuez, Aranjuez",
                  type: "ST",
                  id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                  extId: "100060200",
                  lon: -3.61823,
                  lat: 40.034862,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "10:20:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  extId: "100018000",
                  lon: -3.688957,
                  lat: 40.406153,
                  routeIdx: 9,
                  prognosisType: "PROGNOSED",
                  time: "11:05:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 0,
                      routeIdxTo: 9,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "10:50:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "11:35:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#2#DA#161124#1S#100060200#1T#1050#LS#100017000#LT#1149#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1050#TO#100017000#TT#1149#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "245",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "11:20:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:05:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#3#DA#161124#1S#100060200#1T#1120#LS#100017000#LT#1219#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1120#TO#100017000#TT#1219#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "184",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 10,
                            lon: -3.61823,
                            lat: 40.034862,
                            depTime: "11:43:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            name: "Estación de tren Madrid - Atocha Cercanias, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanias, Madrid@X=-3688957@Y=40406153@U=80@L=300018000@",
                            extId: "300018000",
                            routeIdx: 11,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:13:00",
                            arrDate: "2024-11-16",
                            hasMainMast: true,
                            mainMastId:
                              "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            mainMastExtId: "100018000",
                            mainMastLon: -3.688957,
                            mainMastLat: 40.406153,
                            entry: true,
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#117116#TA#0#DA#161124#1S#100003100#1T#832#LS#100017000#LT#1227#PU#80#RT#1#CA#107#ZE#MD#ZB#REN   MD#PC#2#FR#100003100#FT#832#TO#100017000#TT#1227#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN MD",
                        internalName: "REN   MD",
                        displayNumber: "MD",
                        num: "1588",
                        line: "MD",
                        lineId: "0310017000VRX(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "MD",
                      },
                      name: "REN MD",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "MD",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "11:50:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "12:35:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#4#DA#161124#1S#100060200#1T#1150#LS#100017000#LT#1249#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1150#TO#100017000#TT#1249#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "247",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "not accessible by wheelchair",
                                  key: "WN",
                                  type: "A",
                                  priority: 0,
                                  txtN: "not accessible by wheelchair",
                                },
                              ],
                            },
                            name: "Estación de tren Aranjuez, Aranjuez",
                            id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                            extId: "100060200",
                            routeIdx: 0,
                            lon: -3.61823,
                            lat: 40.034862,
                            depPrognosisType: "PROGNOSED",
                            depTime: "12:20:00",
                            depDate: "2024-11-16",
                            depDir:
                              "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                          },
                          {
                            Notes: {
                              Note: [
                                {
                                  value: "Silla de ruedas accesible",
                                  key: "WA",
                                  type: "A",
                                  priority: 0,
                                  txtN: "Silla de ruedas accesible",
                                },
                              ],
                            },
                            name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                            id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                            extId: "100018000",
                            routeIdx: 9,
                            lon: -3.688957,
                            lat: 40.406153,
                            arrTime: "13:05:00",
                            arrDate: "2024-11-16",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#5#DA#161124#1S#100060200#1T#1220#LS#100017000#LT#1319#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1220#TO#100017000#TT#1319#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 255,
                            g: 255,
                            b: 255,
                            hex: "#FFFFFF",
                          },
                          backgroundColor: {
                            r: 126,
                            g: 64,
                            b: 132,
                            hex: "#7E4084",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "Renfe Cercanias",
                          nameS: "107",
                          nameN: "Renfe Ce",
                          nameL: "Renfe Cercanias",
                          id: "1071VC",
                        },
                        name: "Ren C3",
                        internalName: "Ren   C3",
                        displayNumber: "C3",
                        num: "186",
                        line: "C3",
                        lineId: "10T0008C3(1071VC)028",
                        catOut: "Renfe Ce",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "Renfe Cercanias",
                        operatorCode: "107",
                        operator: "Renfe Cercanias",
                        admin: "028000",
                        matchId: "C3",
                      },
                      name: "Ren C3",
                      direction:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                      trainNumber: "C3",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 7,
                  waitMaximum: 30,
                  alternativeCount: 6,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 126,
                        g: 64,
                        b: 132,
                        hex: "#7E4084",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C3",
                    internalName: "Ren   C3",
                    displayNumber: "C3",
                    num: "182",
                    line: "C3",
                    lineId: "10T0008C3(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 0,
                    routeIdxTo: 9,
                    matchId: "C3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Aranjuez, Aranjuez",
                      id: "A=1@O=Estación de tren Aranjuez, Aranjuez@X=-3618230@Y=40034862@U=80@L=100060200@",
                      extId: "100060200",
                      routeIdx: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                      depPrognosisType: "PROGNOSED",
                      depTime: "10:20:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Ciempozuelos, Ciempozuelos",
                      id: "A=1@O=Estación de tren Ciempozuelos, Ciempozuelos@X=-3610113@Y=40159075@U=80@L=100060105@",
                      extId: "100060105",
                      routeIdx: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                      depTime: "10:29:00",
                      depDate: "2024-11-16",
                      arrTime: "10:29:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Valdemoro, Valdemoro",
                      id: "A=1@O=Estación de tren Valdemoro, Valdemoro@X=-3664974@Y=40196003@U=80@L=100060104@",
                      extId: "100060104",
                      routeIdx: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                      depTime: "10:34:00",
                      depDate: "2024-11-16",
                      arrTime: "10:34:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Pinto, Pinto",
                      id: "A=1@O=Estación de tren Pinto, Pinto@X=-3703664@Y=40242783@U=80@L=100060103@",
                      extId: "100060103",
                      routeIdx: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                      depTime: "10:39:00",
                      depDate: "2024-11-16",
                      arrTime: "10:39:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Getafe Industrial (alicante), Getafe",
                      id: "A=1@O=Estación de tren Getafe Industrial (alicante), Getafe@X=-3707817@Y=40305446@U=80@L=100060102@",
                      extId: "100060102",
                      routeIdx: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                      depTime: "10:44:00",
                      depDate: "2024-11-16",
                      arrTime: "10:44:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren El Casar, Getafe",
                      id: "A=1@O=Estación de tren El Casar, Getafe@X=-3710010@Y=40318634@U=80@L=100060109@",
                      extId: "100060109",
                      routeIdx: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                      depTime: "10:46:00",
                      depDate: "2024-11-16",
                      arrTime: "10:46:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristóbal Industrial, Madrid",
                      id: "A=1@O=Estación de tren San Cristóbal Industrial, Madrid@X=-3698675@Y=40331938@U=80@L=100060101@",
                      extId: "100060101",
                      routeIdx: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                      depTime: "10:49:00",
                      depDate: "2024-11-16",
                      arrTime: "10:49:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren San Cristobal De Los Angeles, Madrid",
                      id: "A=1@O=Estación de tren San Cristobal De Los Angeles, Madrid@X=-3683995@Y=40340810@U=80@L=100060107@",
                      extId: "100060107",
                      routeIdx: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                      depTime: "10:52:00",
                      depDate: "2024-11-16",
                      arrTime: "10:52:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid-Villaverde Bajo, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Villaverde Bajo, Madrid@X=-3683986@Y=40353638@U=80@L=100060100@",
                      extId: "100060100",
                      routeIdx: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                      depTime: "10:55:00",
                      depDate: "2024-11-16",
                      arrTime: "10:55:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                      arrTime: "11:05:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#114024#TA#1#DA#161124#1S#100060200#1T#1020#LS#100017000#LT#1119#PU#80#RT#1#CA#107#ZE#C3#ZB#Ren   C3#PC#2#FR#100060200#FT#1020#TO#100017000#TT#1119#",
                },
                id: "C-0:000",
                idx: 0,
                name: "Ren C3",
                number: "C3",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                directionFlag: "0",
                duration: "PT45M",
                dist: 45301,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.61823,
                      lat: 40.034862,
                    },
                    {
                      order: 1,
                      lon: -3.610113,
                      lat: 40.159075,
                    },
                    {
                      order: 2,
                      lon: -3.664974,
                      lat: 40.196003,
                    },
                    {
                      order: 3,
                      lon: -3.703664,
                      lat: 40.242783,
                    },
                    {
                      order: 4,
                      lon: -3.707817,
                      lat: 40.305446,
                    },
                    {
                      order: 5,
                      lon: -3.71001,
                      lat: 40.318634,
                    },
                    {
                      order: 6,
                      lon: -3.698675,
                      lat: 40.331938,
                    },
                    {
                      order: 7,
                      lon: -3.683995,
                      lat: 40.34081,
                    },
                    {
                      order: 8,
                      lon: -3.683986,
                      lat: 40.353638,
                    },
                    {
                      order: 9,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "Silla de ruedas accesible",
                        key: "WA",
                        type: "A",
                        priority: 0,
                        txtN: "Silla de ruedas accesible",
                      },
                    ],
                  },
                  name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  extId: "100018000",
                  lon: -3.688957,
                  lat: 40.406153,
                  routeIdx: 12,
                  prognosisType: "PROGNOSED",
                  time: "11:10:00",
                  date: "2024-11-16",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  name: "Estación de tren San Fernando Henares, Coslada",
                  type: "ST",
                  id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                  extId: "100070101",
                  lon: -3.53446,
                  lat: 40.442541,
                  routeIdx: 19,
                  prognosisType: "PROGNOSED",
                  time: "11:32:00",
                  date: "2024-11-16",
                },
                Notes: {
                  Note: [
                    {
                      value: "Silla de ruedas accesible",
                      key: "WA",
                      type: "A",
                      priority: 2,
                      routeIdxFrom: 12,
                      routeIdxTo: 19,
                      txtN: "Silla de ruedas accesible",
                    },
                  ],
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#113746#TA#2#DA#161124#1S#100010000#1T#1013#LS#100070103#LT#1150#PU#80#RT#1#CA#107#ZE#C7#ZB#Ren   C7#PC#2#FR#100010000#FT#1013#TO#100070103#TT#1150#",
                },
                Freq: {
                  waitMinimum: 12,
                  waitMaximum: 18,
                  alternativeCount: 9,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 243,
                        g: 151,
                        b: 42,
                        hex: "#F3972A",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "Renfe Cercanias",
                      nameS: "107",
                      nameN: "Renfe Ce",
                      nameL: "Renfe Cercanias",
                      id: "1071VC",
                    },
                    name: "Ren C7",
                    internalName: "Ren   C7",
                    displayNumber: "C7",
                    num: "1869",
                    line: "C7",
                    lineId: "10T0051C7(1071VC)028",
                    catOut: "Renfe Ce",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "Renfe Cercanias",
                    operatorCode: "107",
                    operator: "Renfe Cercanias",
                    admin: "028000",
                    routeIdxFrom: 12,
                    routeIdxTo: 19,
                    matchId: "C7",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      Notes: {
                        Note: [
                          {
                            value: "Silla de ruedas accesible",
                            key: "WA",
                            type: "A",
                            priority: 0,
                            txtN: "Silla de ruedas accesible",
                          },
                        ],
                      },
                      name: "Estación de tren Madrid - Atocha Cercanías, Madrid",
                      id: "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      extId: "100018000",
                      routeIdx: 12,
                      lon: -3.688957,
                      lat: 40.406153,
                      depTime: "11:10:00",
                      depDate: "2024-11-16",
                      depDir:
                        "Estación de tren Alcala De Henares, Alcalá de Henares",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Asamblea De Mad. Entrevías, Madrid",
                      id: "A=1@O=Estación de tren Asamblea De Mad. Entrevías, Madrid@X=-3667985@Y=40381621@U=80@L=100070002@",
                      extId: "100070002",
                      routeIdx: 13,
                      lon: -3.667985,
                      lat: 40.381621,
                      depTime: "11:15:00",
                      depDate: "2024-11-16",
                      arrTime: "11:15:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren El Pozo, Madrid",
                      id: "A=1@O=Estación de tren El Pozo, Madrid@X=-3656237@Y=40376057@U=80@L=100070003@",
                      extId: "100070003",
                      routeIdx: 14,
                      lon: -3.656237,
                      lat: 40.376057,
                      depTime: "11:17:00",
                      depDate: "2024-11-16",
                      arrTime: "11:17:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Vallecas, Madrid",
                      id: "A=1@O=Estación de tren Vallecas, Madrid@X=-3624684@Y=40382044@U=80@L=100070001@",
                      extId: "100070001",
                      routeIdx: 15,
                      lon: -3.624684,
                      lat: 40.382044,
                      depTime: "11:20:00",
                      depDate: "2024-11-16",
                      arrTime: "11:20:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Santa Eugenia, Madrid",
                      id: "A=1@O=Estación de tren Santa Eugenia, Madrid@X=-3608962@Y=40386916@U=80@L=100070109@",
                      extId: "100070109",
                      routeIdx: 16,
                      lon: -3.608962,
                      lat: 40.386916,
                      depTime: "11:22:00",
                      depDate: "2024-11-16",
                      arrTime: "11:22:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Vicálvaro, Madrid",
                      id: "A=1@O=Estación de tren Vicálvaro, Madrid@X=-3595982@Y=40401209@U=80@L=100070100@",
                      extId: "100070100",
                      routeIdx: 17,
                      lon: -3.595982,
                      lat: 40.401209,
                      depTime: "11:25:00",
                      depDate: "2024-11-16",
                      arrTime: "11:25:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren Coslada (apd), Coslada",
                      id: "A=1@O=Estación de tren Coslada (apd), Coslada@X=-3561113@Y=40423223@U=80@L=100070108@",
                      extId: "100070108",
                      routeIdx: 18,
                      lon: -3.561113,
                      lat: 40.423223,
                      depTime: "11:28:00",
                      depDate: "2024-11-16",
                      arrTime: "11:28:00",
                      arrDate: "2024-11-16",
                    },
                    {
                      Notes: {
                        Note: [
                          {
                            value: "not accessible by wheelchair",
                            key: "WN",
                            type: "A",
                            priority: 0,
                            txtN: "not accessible by wheelchair",
                          },
                        ],
                      },
                      name: "Estación de tren San Fernando Henares, Coslada",
                      id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                      extId: "100070101",
                      routeIdx: 19,
                      lon: -3.53446,
                      lat: 40.442541,
                      arrTime: "11:32:00",
                      arrDate: "2024-11-16",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2024-11-16",
                  ref: "2|#VN#1#ST#1731057053#PI#0#ZI#113746#TA#2#DA#161124#1S#100010000#1T#1013#LS#100070103#LT#1150#PU#80#RT#1#CA#107#ZE#C7#ZB#Ren   C7#PC#2#FR#100010000#FT#1013#TO#100070103#TT#1150#",
                },
                id: "C-0:001",
                idx: 1,
                name: "Ren C7",
                number: "C7",
                category: "107",
                type: "JNY",
                reachable: true,
                direction:
                  "Estación de tren Alcala De Henares, Alcalá de Henares",
                directionFlag: "0",
                duration: "PT22M",
                dist: 17508,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.688957,
                      lat: 40.406153,
                    },
                    {
                      order: 1,
                      lon: -3.667985,
                      lat: 40.381621,
                    },
                    {
                      order: 2,
                      lon: -3.656237,
                      lat: 40.376057,
                    },
                    {
                      order: 3,
                      lon: -3.624684,
                      lat: 40.382044,
                    },
                    {
                      order: 4,
                      lon: -3.608962,
                      lat: 40.386916,
                    },
                    {
                      order: 5,
                      lon: -3.595982,
                      lat: 40.401209,
                    },
                    {
                      order: 6,
                      lon: -3.561113,
                      lat: 40.423223,
                    },
                    {
                      order: 7,
                      lon: -3.53446,
                      lat: 40.442541,
                    },
                  ],
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "not accessible by wheelchair",
                        key: "WN",
                        type: "A",
                        priority: 0,
                        txtN: "not accessible by wheelchair",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Estación de tren San Fernando Henares, Coslada",
                  type: "ST",
                  id: "A=1@O=Estación de tren San Fernando Henares, Coslada@X=-3534460@Y=40442541@U=80@L=100070101@",
                  extId: "100070101",
                  lon: -3.53446,
                  lat: 40.442541,
                  time: "11:32:00",
                  date: "2024-11-16",
                  mcp: true,
                },
                Destination: {
                  name: "Calle Luis Madrona 8",
                  description: "Alcalá de Henares",
                  type: "ADR",
                  id: "A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@U=100@L=980021459@",
                  extId: "980021459",
                  lon: -3.349731,
                  lat: 40.489635,
                  time: "11:52:00",
                  date: "2024-11-16",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Estación de tren San Fernando Henares, Coslada@L=100070101@a=128@|A=2@O=Calle Luis Madrona 8@H=8@X=-3349731@Y=40489635@L=980021459@a=128@|16112024|113200|115200|fb|ft@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§|||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Bolt",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:002",
                idx: 2,
                name: "Bolt",
                type: "TAXI",
                duration: "PT20M",
                dist: 20375,
                GisRoute: {
                  dist: 20375,
                  durS: "PT20M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
      ],
    },
  };
}
